// This file is auto-generated by @hey-api/openapi-ts

import type {
  ApiError,
  DeleteChatSessionsByChatSessionIdData,
  DeleteChatSessionsByChatSessionIdResponse,
  DeleteEntitiesByFpIdAnnotationsByAnnotationIdData,
  DeleteEntitiesByFpIdAnnotationsByAnnotationIdResponse,
  DeleteEntitiesByFpIdData,
  DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyData,
  DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyResponse,
  DeleteEntitiesByFpIdResponse,
  DeleteEntitiesByFpIdTagsByTagIdData,
  DeleteEntitiesByFpIdTagsByTagIdResponse,
  DeleteEntitiesByFpIdVaultData,
  DeleteEntitiesByFpIdVaultResponse,
  DeleteOrgAgentsMcpServersByServerIdData,
  DeleteOrgAgentsMcpServersByServerIdResponse,
  DeleteOrgAppMetaAndroidByMetaIdData,
  DeleteOrgAppMetaAndroidByMetaIdResponse,
  DeleteOrgAppMetaIosByMetaIdData,
  DeleteOrgAppMetaIosByMetaIdResponse,
  DeleteOrgArtifactsByArtifactIdData,
  DeleteOrgArtifactsByArtifactIdResponse,
  DeleteOrgCredentialsByCredentialIdData,
  DeleteOrgCredentialsByCredentialIdResponse,
  DeleteOrgEntityStatusesBySlugData,
  DeleteOrgEntityStatusesBySlugResponse,
  DeleteOrgFrequentNotesByFrequentNoteIdData,
  DeleteOrgFrequentNotesByFrequentNoteIdResponse,
  DeleteOrgListsByListIdData,
  DeleteOrgListsByListIdEntriesByListEntryIdData,
  DeleteOrgListsByListIdEntriesByListEntryIdResponse,
  DeleteOrgListsByListIdResponse,
  DeleteOrgReviewQueuesByIdData,
  DeleteOrgReviewQueuesByIdResponse,
  DeleteOrgReviewTeamsByIdData,
  DeleteOrgReviewTeamsByIdResponse,
  DeleteOrgTagsByTagIdData,
  DeleteOrgTagsByTagIdResponse,
  GetChatSessionsByChatSessionIdData,
  GetChatSessionsByChatSessionIdWireMessagesData,
  GetChatSessionsByChatSessionIdWireMessagesResponse,
  GetChatSessionsData,
  GetChatSessionsResponse,
  GetData,
  GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsData,
  GetEntitiesByFpIdAnnotationsData,
  GetEntitiesByFpIdAvailableAdhocVendorsData,
  GetEntitiesByFpIdBusinessesData,
  GetEntitiesByFpIdBusinessOwnersData,
  GetEntitiesByFpIdData,
  GetEntitiesByFpIdDataData,
  GetEntitiesByFpIdDocumentsByDocumentIdentifierData,
  GetEntitiesByFpIdDocumentsData,
  GetEntitiesByFpIdDupesData,
  GetEntitiesByFpIdInvestigationsArtifactsByKeyData,
  GetEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionData,
  GetEntitiesByFpIdLabelData,
  GetEntitiesByFpIdLinkedBankAccountsData,
  GetEntitiesByFpIdLivenessData,
  GetEntitiesByFpIdMatchSignalsData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdDataData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdTraceData,
  GetEntitiesByFpIdOnboardingsData,
  GetEntitiesByFpIdOnboardingsResponse,
  GetEntitiesByFpIdReviewsData,
  GetEntitiesByFpIdRiskSignalsData,
  GetEntitiesByFpIdRuleSetResultByRuleSetResultIdData,
  GetEntitiesByFpIdRuleSetResultData,
  GetEntitiesByFpIdTagsData,
  GetEntitiesByFpIdTimelineData,
  GetEntitiesByFpIdTimelineResponse,
  GetEntitiesByFpIdUserInsightsData,
  GetEntitiesByFpIdVaultData,
  GetEntitiesClientTokenData,
  GetEntitiesVaultDecryptByTokenData,
  GetFailData,
  GetHeadersData,
  GetHealthData,
  GetHealthEnclaveData,
  GetHealthEnclaveDecryptData,
  GetOrgAgentsByAgentIdBuilderData,
  GetOrgAgentsByAgentIdData,
  GetOrgAgentsByAgentIdHistoryData,
  GetOrgAgentsByAgentIdHistoryResponse,
  GetOrgAgentsByAgentIdReleasesData,
  GetOrgAgentsByAgentIdReleasesResponse,
  GetOrgAgentsByAgentIdSummaryData,
  GetOrgAgentsData,
  GetOrgAgentsMcpServersData,
  GetOrgAgentsMetricsData,
  GetOrgAgentsResponse,
  GetOrgAgentsRunsByWorkflowIdData,
  GetOrgAgentsTaskCatalogData,
  GetOrgAgentsTemplatesData,
  GetOrgAgentsToolsData,
  GetOrgApiKeysData,
  GetOrgApiKeysResponse,
  GetOrgAppearencesByAppearanceIdData,
  GetOrgAppearencesData,
  GetOrgAppearencesResponse,
  GetOrgAppMetaAndroidData,
  GetOrgAppMetaIosData,
  GetOrgArtifactsByArtifactIdData,
  GetOrgArtifactsByArtifactIdVersionsByVersionIdData,
  GetOrgArtifactsByArtifactIdVersionsData,
  GetOrgArtifactsByArtifactIdVersionsResponse,
  GetOrgArtifactsData,
  GetOrgArtifactsResponse,
  GetOrgAuditEventsData,
  GetOrgAuditEventsResponse,
  GetOrgAuthGoogleOauthData,
  GetOrgAuthRolesData,
  GetOrgBoardThreadsData,
  GetOrgClientSecurityConfigData,
  GetOrgCredentialsData,
  GetOrgData,
  GetOrgEntityStatusesByIdData,
  GetOrgEntityStatusesData,
  GetOrgFootprintWrappedData,
  GetOrgFrequentNotesData,
  GetOrgGraphsByGraphIdNodesByNodeIdContextData,
  GetOrgGraphsByGraphIdSearchData,
  GetOrgInvestigationsByIdData,
  GetOrgInvestigationsByIdTraceData,
  GetOrgInvoicePreviewData,
  GetOrgListsByIdTimelineData,
  GetOrgListsByIdTimelineResponse,
  GetOrgListsByListIdData,
  GetOrgListsByListIdEntriesData,
  GetOrgListsData,
  GetOrgListsResponse,
  GetOrgMemberData,
  GetOrgMemberInProgressOnboardingsData,
  GetOrgMembersData,
  GetOrgMembersResponse,
  GetOrgMetricsData,
  GetOrgOnboardingsByIdData,
  GetOrgPlaybooksByIdData,
  GetOrgPlaybooksByPlaybookIdDeploymentsData,
  GetOrgPlaybooksByPlaybookIdDeploymentsResponse,
  GetOrgPlaybooksByPlaybookIdVersionsByVersionIdData,
  GetOrgPlaybooksByPlaybookIdVersionsData,
  GetOrgPlaybooksByPlaybookIdVersionsResponse,
  GetOrgPlaybooksData,
  GetOrgPlaybooksEditSessionsByEditSessionIdData,
  GetOrgPlaybooksGalleryData,
  GetOrgPlaybooksResponse,
  GetOrgPlaybooksTemplatesData,
  GetOrgProxyConfigsByConfigIdLogsData,
  GetOrgProxyConfigsByConfigIdLogsResponse,
  GetOrgProxyConfigsByProxyConfigIdData,
  GetOrgProxyConfigsData,
  GetOrgReportingEmbedData,
  GetOrgReviewAgentsData,
  GetOrgReviewAgentsReviewsData,
  GetOrgReviewKindsData,
  GetOrgReviewQueuesByIdData,
  GetOrgReviewQueuesByQueueIdMetricsData,
  GetOrgReviewQueuesByQueueIdReviewsData,
  GetOrgReviewQueuesByQueueIdReviewsResponse,
  GetOrgReviewQueuesData,
  GetOrgReviewTeamsByIdData,
  GetOrgReviewTeamsData,
  GetOrgRiskSignalMetricsData,
  GetOrgRiskSignalsSpecData,
  GetOrgRolesData,
  GetOrgRolesResponse,
  GetOrgSdkVersionData,
  GetOrgSdkVersionResponse,
  GetOrgTagsData,
  GetOrgVaultDrAwsPreEnrollmentData,
  GetOrgVaultDrStatusData,
  GetOrgVendorIntegrationsData,
  GetOrgWebhookPortalData,
  GetPrivateAccessRequestsData,
  GetPrivateGraphsByGraphIdData,
  GetRoStatusData,
  GetStatus2Data,
  GetStatusData,
  PatchChatSessionsByChatSessionIdData,
  PatchChatSessionsByChatSessionIdResponse,
  PatchEntitiesByFpIdAnnotationsByAnnotationIdData,
  PatchEntitiesByFpIdAnnotationsByAnnotationIdResponse,
  PatchEntitiesByFpIdStatusesData,
  PatchEntitiesByFpIdStatusesResponse,
  PatchEntitiesByFpIdVaultData,
  PatchEntitiesByFpIdVaultResponse,
  PatchEntitiesVaultData,
  PatchEntitiesVaultResponse,
  PatchOrgAgentsByAgentIdBuilderData,
  PatchOrgAgentsByAgentIdBuilderResponse,
  PatchOrgAgentsByAgentIdData,
  PatchOrgAgentsByAgentIdResponse,
  PatchOrgAgentsMcpServersByServerIdData,
  PatchOrgAgentsMcpServersByServerIdResponse,
  PatchOrgApiKeysByIdData,
  PatchOrgApiKeysByIdResponse,
  PatchOrgAppearencesByAppearanceIdData,
  PatchOrgAppearencesByAppearanceIdResponse,
  PatchOrgAppMetaAndroidByMetaIdData,
  PatchOrgAppMetaAndroidByMetaIdResponse,
  PatchOrgAppMetaIosByMetaIdData,
  PatchOrgAppMetaIosByMetaIdResponse,
  PatchOrgArtifactsByArtifactIdData,
  PatchOrgArtifactsByArtifactIdResponse,
  PatchOrgClientSecurityConfigData,
  PatchOrgClientSecurityConfigResponse,
  PatchOrgData,
  PatchOrgEntityStatusesBySlugData,
  PatchOrgEntityStatusesBySlugResponse,
  PatchOrgListsByListIdData,
  PatchOrgListsByListIdResponse,
  PatchOrgMemberData,
  PatchOrgMemberResponse,
  PatchOrgMembersByTenantUserIdData,
  PatchOrgMembersByTenantUserIdResponse,
  PatchOrgPlaybooksByIdData,
  PatchOrgPlaybooksByIdResponse,
  PatchOrgPlaybooksEditSessionsByEditSessionIdData,
  PatchOrgPlaybooksEditSessionsByEditSessionIdResponse,
  PatchOrgProxyConfigsByProxyConfigIdData,
  PatchOrgProxyConfigsByProxyConfigIdResponse,
  PatchOrgResponse,
  PatchOrgReviewAgentsByIdData,
  PatchOrgReviewAgentsByIdResponse,
  PatchOrgReviewKindsByIdData,
  PatchOrgReviewKindsByIdResponse,
  PatchOrgReviewQueuesByIdData,
  PatchOrgReviewQueuesByIdResponse,
  PatchOrgReviewTeamsByIdData,
  PatchOrgReviewTeamsByIdResponse,
  PatchOrgRolesByTenantRoleIdData,
  PatchOrgRolesByTenantRoleIdResponse,
  PatchPrivateAccessRequestsByRequestIdData,
  PatchPrivateAccessRequestsByRequestIdResponse,
  PostBusinessesByFpBidVaultByIdentifierUploadData,
  PostBusinessesByFpBidVaultByIdentifierUploadResponse,
  PostChatSessionsData,
  PostChatSessionsResponse,
  PostEntitiesByFpIdActionsData,
  PostEntitiesByFpIdActionsResponse,
  PostEntitiesByFpIdAgentsExecutionByIdData,
  PostEntitiesByFpIdAgentsExecutionByIdResponse,
  PostEntitiesByFpIdAnnotationsData,
  PostEntitiesByFpIdAnnotationsResponse,
  PostEntitiesByFpIdBusinessOwnersKycLinksData,
  PostEntitiesByFpIdBusinessOwnersKycLinksResponse,
  PostEntitiesByFpIdDecryptAmlHitsBySignalIdData,
  PostEntitiesByFpIdDecryptAmlHitsBySignalIdResponse,
  PostEntitiesByFpIdInvestigationsArtifactsData,
  PostEntitiesByFpIdInvestigationsArtifactsResponse,
  PostEntitiesByFpIdLabelData,
  PostEntitiesByFpIdLabelResponse,
  PostEntitiesByFpIdRequestFpReviewData,
  PostEntitiesByFpIdRequestFpReviewResponse,
  PostEntitiesByFpIdSentilinkBySignalIdData,
  PostEntitiesByFpIdSentilinkBySignalIdResponse,
  PostEntitiesByFpIdTagsData,
  PostEntitiesByFpIdTagsResponse,
  PostEntitiesByFpIdTokenData,
  PostEntitiesByFpIdTokenResponse,
  PostEntitiesByFpIdVaultByIdentifierUploadData,
  PostEntitiesByFpIdVaultByIdentifierUploadResponse,
  PostEntitiesByFpIdVaultDecryptData,
  PostEntitiesByFpIdVaultDecryptResponse,
  PostEntitiesByFpIdVaultIntegrityData,
  PostEntitiesByFpIdVaultIntegrityResponse,
  PostEntitiesByFpIdVaultValidateData,
  PostEntitiesByFpIdVaultValidateResponse,
  PostEntitiesData,
  PostEntitiesExtractPromptData,
  PostEntitiesExtractPromptResponse,
  PostEntitiesResponse,
  PostEntitiesSearchCountData,
  PostEntitiesSearchCountResponse,
  PostEntitiesSearchData,
  PostEntitiesSearchResponse,
  PostEntitiesVaultByIdentifierUploadData,
  PostEntitiesVaultByIdentifierUploadResponse,
  PostEntitiesVaultDecryptData,
  PostEntitiesVaultDecryptResponse,
  PostEntitiesVaultValidateData,
  PostEntitiesVaultValidateResponse,
  PostInvestigationsByInvestigationIdSourcesData,
  PostInvestigationsByInvestigationIdSourcesResponse,
  PostOrgAgentsBuilderData,
  PostOrgAgentsBuilderExplainRulesData,
  PostOrgAgentsBuilderExplainRulesResponse,
  PostOrgAgentsBuilderGenerateRulesData,
  PostOrgAgentsBuilderGenerateRulesResponse,
  PostOrgAgentsBuilderResponse,
  PostOrgAgentsByAgentIdBuilderPublishData,
  PostOrgAgentsByAgentIdBuilderPublishResponse,
  PostOrgAgentsByAgentIdBuilderRestoreData,
  PostOrgAgentsByAgentIdBuilderRestoreResponse,
  PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData,
  PostOrgAgentsByAgentIdBuilderSuggestionsAcceptResponse,
  PostOrgAgentsByAgentIdBuilderSuggestionsRejectData,
  PostOrgAgentsByAgentIdBuilderSuggestionsRejectResponse,
  PostOrgAgentsByAgentIdRunData,
  PostOrgAgentsByAgentIdRunResponse,
  PostOrgAgentsMcpServersByServerIdOauthStartData,
  PostOrgAgentsMcpServersByServerIdOauthStartResponse,
  PostOrgAgentsMcpServersData,
  PostOrgAgentsMcpServersOauthCompleteData,
  PostOrgAgentsMcpServersOauthCompleteResponse,
  PostOrgAgentsMcpServersOauthStartData,
  PostOrgAgentsMcpServersOauthStartResponse,
  PostOrgAgentsMcpServersResponse,
  PostOrgApiKeysByIdDeactivateData,
  PostOrgApiKeysByIdDeactivateResponse,
  PostOrgApiKeysByIdRevealData,
  PostOrgApiKeysByIdRevealResponse,
  PostOrgApiKeysData,
  PostOrgApiKeysResponse,
  PostOrgAppearencesByAppearanceIdProposalData,
  PostOrgAppearencesByAppearanceIdProposalResponse,
  PostOrgAppearencesData,
  PostOrgAppearencesResponse,
  PostOrgAppMetaAndroidByMetaIdRevealData,
  PostOrgAppMetaAndroidByMetaIdRevealResponse,
  PostOrgAppMetaAndroidData,
  PostOrgAppMetaAndroidResponse,
  PostOrgAppMetaIosByMetaIdRevealData,
  PostOrgAppMetaIosByMetaIdRevealResponse,
  PostOrgAppMetaIosData,
  PostOrgAppMetaIosResponse,
  PostOrgArtifactsByArtifactIdVersionsData,
  PostOrgArtifactsByArtifactIdVersionsResponse,
  PostOrgArtifactsData,
  PostOrgArtifactsResponse,
  PostOrgAuthAssumeRoleData,
  PostOrgAuthAssumeRoleResponse,
  PostOrgAuthDocsTokenData,
  PostOrgAuthDocsTokenResponse,
  PostOrgAuthLoginData,
  PostOrgAuthLoginResponse,
  PostOrgAuthLogoutData,
  PostOrgAuthLogoutResponse,
  PostOrgAuthMagicLinkData,
  PostOrgAuthMagicLinkResponse,
  PostOrgAuthMcpCompleteData,
  PostOrgAuthMcpCompleteResponse,
  PostOrgAuthSamlSsoData,
  PostOrgAuthSamlSsoResponse,
  PostOrgBoardThreadsByThreadIdDeactivateData,
  PostOrgBoardThreadsByThreadIdDeactivateResponse,
  PostOrgCredentialsByCredentialIdDecryptData,
  PostOrgCredentialsByCredentialIdDecryptResponse,
  PostOrgCredentialsData,
  PostOrgCredentialsResponse,
  PostOrgFrequentNotesData,
  PostOrgFrequentNotesResponse,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsResponse,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesResponse,
  PostOrgInvestigationsSearchData,
  PostOrgInvestigationsSearchResponse,
  PostOrgListsByListIdEntriesData,
  PostOrgListsByListIdEntriesResponse,
  PostOrgListsData,
  PostOrgListsResponse,
  PostOrgMembersByTenantUserIdDeactivateData,
  PostOrgMembersByTenantUserIdDeactivateResponse,
  PostOrgMembersData,
  PostOrgMembersResponse,
  PostOrgOnboardingConfigsByIdCopyData,
  PostOrgOnboardingConfigsByIdCopyResponse,
  PostOrgOnboardingSessionData,
  PostOrgOnboardingSessionResponse,
  PostOrgOnboardingSessionValidateData,
  PostOrgOnboardingSessionValidateResponse,
  PostOrgOnboardingsData,
  PostOrgOnboardingsResponse,
  PostOrgPercyEntitiesQueryData,
  PostOrgPercyEntitiesQueryResponse,
  PostOrgPlaybooksByPlaybookIdDeploymentsData,
  PostOrgPlaybooksByPlaybookIdDeploymentsResponse,
  PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData,
  PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishResponse,
  PostOrgPlaybooksEditSessionsByEditSessionIdCommitData,
  PostOrgPlaybooksEditSessionsByEditSessionIdCommitResponse,
  PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData,
  PostOrgPlaybooksEditSessionsByEditSessionIdModernizeResponse,
  PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData,
  PostOrgPlaybooksEditSessionsByEditSessionIdRestoreResponse,
  PostOrgPlaybooksEditSessionsByEditSessionIdRunData,
  PostOrgPlaybooksEditSessionsByEditSessionIdRunResponse,
  PostOrgPlaybooksEditSessionsData,
  PostOrgPlaybooksEditSessionsResponse,
  PostOrgProxyConfigsByProxyConfigIdDeactivateData,
  PostOrgProxyConfigsByProxyConfigIdDeactivateResponse,
  PostOrgProxyConfigsData,
  PostOrgProxyConfigsResponse,
  PostOrgReviewAgentsData,
  PostOrgReviewAgentsResponse,
  PostOrgReviewKindsData,
  PostOrgReviewKindsResponse,
  PostOrgReviewQueuesByQueueIdNextData,
  PostOrgReviewQueuesByQueueIdNextResponse,
  PostOrgReviewQueuesData,
  PostOrgReviewQueuesResponse,
  PostOrgReviewsByIdSelfAssignData,
  PostOrgReviewsByIdSelfAssignResponse,
  PostOrgReviewsByIdSelfUnassignData,
  PostOrgReviewsByIdSelfUnassignResponse,
  PostOrgReviewsByIdStartData,
  PostOrgReviewsByIdStartResponse,
  PostOrgReviewTeamsData,
  PostOrgReviewTeamsResponse,
  PostOrgRolesByTenantRoleIdDeactivateData,
  PostOrgRolesByTenantRoleIdDeactivateResponse,
  PostOrgRolesData,
  PostOrgRolesResponse,
  PostOrgTagsData,
  PostOrgTagsResponse,
  PostOrgVaultDrAwsPreEnrollmentData,
  PostOrgVaultDrAwsPreEnrollmentResponse,
  PostOrgVaultDrEnrollData,
  PostOrgVaultDrEnrollResponse,
  PostOrgVaultDrRevealWrappedRecordKeysData,
  PostOrgVaultDrRevealWrappedRecordKeysResponse,
  PostOrgVendorIntegrationsByIntegrationIdCredentialsData,
  PostOrgVendorIntegrationsByIntegrationIdCredentialsResponse,
  PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData,
  PostOrgVendorIntegrationsData,
  PostOrgVendorIntegrationsResponse,
  PostPrivateAccessRequestsData,
  PostPrivateAccessRequestsResponse,
  PostPrivateAssumeData,
  PostPrivateAssumeResponse,
  PostVaultProxyLogsByLogIdRevealData,
  PostVaultProxyLogsByLogIdRevealResponse,
  PutOrgAppearencesByAppearanceIdLogoData,
  PutOrgAppearencesByAppearanceIdLogoResponse,
  PutOrgLogoData,
  PutOrgLogoResponse,
} from '@onefootprint/request-types/dashboard';
import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import { client as _heyApiClient } from '../client.gen';
import {
  deleteChatSessionsByChatSessionId,
  deleteEntitiesByFpId,
  deleteEntitiesByFpIdAnnotationsByAnnotationId,
  deleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKey,
  deleteEntitiesByFpIdTagsByTagId,
  deleteEntitiesByFpIdVault,
  deleteOrgAgentsMcpServersByServerId,
  deleteOrgAppMetaAndroidByMetaId,
  deleteOrgAppMetaIosByMetaId,
  deleteOrgArtifactsByArtifactId,
  deleteOrgCredentialsByCredentialId,
  deleteOrgEntityStatusesBySlug,
  deleteOrgFrequentNotesByFrequentNoteId,
  deleteOrgListsByListId,
  deleteOrgListsByListIdEntriesByListEntryId,
  deleteOrgReviewQueuesById,
  deleteOrgReviewTeamsById,
  deleteOrgTagsByTagId,
  get,
  getChatSessions,
  getChatSessionsByChatSessionId,
  getChatSessionsByChatSessionIdWireMessages,
  getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsights,
  getEntitiesByFpId,
  getEntitiesByFpIdAnnotations,
  getEntitiesByFpIdAvailableAdhocVendors,
  getEntitiesByFpIdBusinesses,
  getEntitiesByFpIdBusinessOwners,
  getEntitiesByFpIdData,
  getEntitiesByFpIdDocuments,
  getEntitiesByFpIdDocumentsByDocumentIdentifier,
  getEntitiesByFpIdDupes,
  getEntitiesByFpIdInvestigationsArtifactsByKey,
  getEntitiesByFpIdInvestigationsByInvestigationIdActiveSession,
  getEntitiesByFpIdLabel,
  getEntitiesByFpIdLinkedBankAccounts,
  getEntitiesByFpIdLiveness,
  getEntitiesByFpIdMatchSignals,
  getEntitiesByFpIdOnboardings,
  getEntitiesByFpIdOnboardingsByOnboardingId,
  getEntitiesByFpIdOnboardingsByOnboardingIdData,
  getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignals,
  getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignals,
  getEntitiesByFpIdOnboardingsByOnboardingIdTrace,
  getEntitiesByFpIdReviews,
  getEntitiesByFpIdRiskSignals,
  getEntitiesByFpIdRuleSetResult,
  getEntitiesByFpIdRuleSetResultByRuleSetResultId,
  getEntitiesByFpIdTags,
  getEntitiesByFpIdTimeline,
  getEntitiesByFpIdUserInsights,
  getEntitiesByFpIdVault,
  getEntitiesClientToken,
  getEntitiesVaultDecryptByToken,
  getFail,
  getHeaders,
  getHealth,
  getHealthEnclave,
  getHealthEnclaveDecrypt,
  getOrg,
  getOrgAgents,
  getOrgAgentsByAgentId,
  getOrgAgentsByAgentIdBuilder,
  getOrgAgentsByAgentIdHistory,
  getOrgAgentsByAgentIdReleases,
  getOrgAgentsByAgentIdSummary,
  getOrgAgentsMcpServers,
  getOrgAgentsMetrics,
  getOrgAgentsRunsByWorkflowId,
  getOrgAgentsTaskCatalog,
  getOrgAgentsTemplates,
  getOrgAgentsTools,
  getOrgApiKeys,
  getOrgAppearences,
  getOrgAppearencesByAppearanceId,
  getOrgAppMetaAndroid,
  getOrgAppMetaIos,
  getOrgArtifacts,
  getOrgArtifactsByArtifactId,
  getOrgArtifactsByArtifactIdVersions,
  getOrgArtifactsByArtifactIdVersionsByVersionId,
  getOrgAuditEvents,
  getOrgAuthGoogleOauth,
  getOrgAuthRoles,
  getOrgBoardThreads,
  getOrgClientSecurityConfig,
  getOrgCredentials,
  getOrgEntityStatuses,
  getOrgEntityStatusesById,
  getOrgFootprintWrapped,
  getOrgFrequentNotes,
  getOrgGraphsByGraphIdNodesByNodeIdContext,
  getOrgGraphsByGraphIdSearch,
  getOrgInvestigationsById,
  getOrgInvestigationsByIdTrace,
  getOrgInvoicePreview,
  getOrgLists,
  getOrgListsByIdTimeline,
  getOrgListsByListId,
  getOrgListsByListIdEntries,
  getOrgMember,
  getOrgMemberInProgressOnboardings,
  getOrgMembers,
  getOrgMetrics,
  getOrgOnboardingsById,
  getOrgPlaybooks,
  getOrgPlaybooksById,
  getOrgPlaybooksByPlaybookIdDeployments,
  getOrgPlaybooksByPlaybookIdVersions,
  getOrgPlaybooksByPlaybookIdVersionsByVersionId,
  getOrgPlaybooksEditSessionsByEditSessionId,
  getOrgPlaybooksGallery,
  getOrgPlaybooksTemplates,
  getOrgProxyConfigs,
  getOrgProxyConfigsByConfigIdLogs,
  getOrgProxyConfigsByProxyConfigId,
  getOrgReportingEmbed,
  getOrgReviewAgents,
  getOrgReviewAgentsReviews,
  getOrgReviewKinds,
  getOrgReviewQueues,
  getOrgReviewQueuesById,
  getOrgReviewQueuesByQueueIdMetrics,
  getOrgReviewQueuesByQueueIdReviews,
  getOrgReviewTeams,
  getOrgReviewTeamsById,
  getOrgRiskSignalMetrics,
  getOrgRiskSignalsSpec,
  getOrgRoles,
  getOrgSdkVersion,
  getOrgTags,
  getOrgVaultDrAwsPreEnrollment,
  getOrgVaultDrStatus,
  getOrgVendorIntegrations,
  getOrgWebhookPortal,
  getPrivateAccessRequests,
  getPrivateGraphsByGraphId,
  getRoStatus,
  getStatus,
  getStatus2,
  type Options,
  patchChatSessionsByChatSessionId,
  patchEntitiesByFpIdAnnotationsByAnnotationId,
  patchEntitiesByFpIdStatuses,
  patchEntitiesByFpIdVault,
  patchEntitiesVault,
  patchOrg,
  patchOrgAgentsByAgentId,
  patchOrgAgentsByAgentIdBuilder,
  patchOrgAgentsMcpServersByServerId,
  patchOrgApiKeysById,
  patchOrgAppearencesByAppearanceId,
  patchOrgAppMetaAndroidByMetaId,
  patchOrgAppMetaIosByMetaId,
  patchOrgArtifactsByArtifactId,
  patchOrgClientSecurityConfig,
  patchOrgEntityStatusesBySlug,
  patchOrgListsByListId,
  patchOrgMember,
  patchOrgMembersByTenantUserId,
  patchOrgPlaybooksById,
  patchOrgPlaybooksEditSessionsByEditSessionId,
  patchOrgProxyConfigsByProxyConfigId,
  patchOrgReviewAgentsById,
  patchOrgReviewKindsById,
  patchOrgReviewQueuesById,
  patchOrgReviewTeamsById,
  patchOrgRolesByTenantRoleId,
  patchPrivateAccessRequestsByRequestId,
  postBusinessesByFpBidVaultByIdentifierUpload,
  postChatSessions,
  postEntities,
  postEntitiesByFpIdActions,
  postEntitiesByFpIdAgentsExecutionById,
  postEntitiesByFpIdAnnotations,
  postEntitiesByFpIdBusinessOwnersKycLinks,
  postEntitiesByFpIdDecryptAmlHitsBySignalId,
  postEntitiesByFpIdInvestigationsArtifacts,
  postEntitiesByFpIdLabel,
  postEntitiesByFpIdRequestFpReview,
  postEntitiesByFpIdSentilinkBySignalId,
  postEntitiesByFpIdTags,
  postEntitiesByFpIdToken,
  postEntitiesByFpIdVaultByIdentifierUpload,
  postEntitiesByFpIdVaultDecrypt,
  postEntitiesByFpIdVaultIntegrity,
  postEntitiesByFpIdVaultValidate,
  postEntitiesExtractPrompt,
  postEntitiesSearch,
  postEntitiesSearchCount,
  postEntitiesVaultByIdentifierUpload,
  postEntitiesVaultDecrypt,
  postEntitiesVaultValidate,
  postInvestigationsByInvestigationIdSources,
  postOrgAgentsBuilder,
  postOrgAgentsBuilderExplainRules,
  postOrgAgentsBuilderGenerateRules,
  postOrgAgentsByAgentIdBuilderPublish,
  postOrgAgentsByAgentIdBuilderRestore,
  postOrgAgentsByAgentIdBuilderSuggestionsAccept,
  postOrgAgentsByAgentIdBuilderSuggestionsReject,
  postOrgAgentsByAgentIdRun,
  postOrgAgentsMcpServers,
  postOrgAgentsMcpServersByServerIdOauthStart,
  postOrgAgentsMcpServersOauthComplete,
  postOrgAgentsMcpServersOauthStart,
  postOrgApiKeys,
  postOrgApiKeysByIdDeactivate,
  postOrgApiKeysByIdReveal,
  postOrgAppearences,
  postOrgAppearencesByAppearanceIdProposal,
  postOrgAppMetaAndroid,
  postOrgAppMetaAndroidByMetaIdReveal,
  postOrgAppMetaIos,
  postOrgAppMetaIosByMetaIdReveal,
  postOrgArtifacts,
  postOrgArtifactsByArtifactIdVersions,
  postOrgAuthAssumeRole,
  postOrgAuthDocsToken,
  postOrgAuthLogin,
  postOrgAuthLogout,
  postOrgAuthMagicLink,
  postOrgAuthMcpComplete,
  postOrgAuthSamlSso,
  postOrgBoardThreadsByThreadIdDeactivate,
  postOrgCredentials,
  postOrgCredentialsByCredentialIdDecrypt,
  postOrgFrequentNotes,
  postOrgGraphsByGraphIdNodesByNodeIdValidateExpressions,
  postOrgGraphsByGraphIdNodesByNodeIdValidateRules,
  postOrgInvestigationsSearch,
  postOrgLists,
  postOrgListsByListIdEntries,
  postOrgMembers,
  postOrgMembersByTenantUserIdDeactivate,
  postOrgOnboardingConfigsByIdCopy,
  postOrgOnboardingSession,
  postOrgOnboardingSessionValidate,
  postOrgOnboardings,
  postOrgPercyEntitiesQuery,
  postOrgPlaybooksByPlaybookIdDeployments,
  postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublish,
  postOrgPlaybooksEditSessions,
  postOrgPlaybooksEditSessionsByEditSessionIdCommit,
  postOrgPlaybooksEditSessionsByEditSessionIdModernize,
  postOrgPlaybooksEditSessionsByEditSessionIdRestore,
  postOrgPlaybooksEditSessionsByEditSessionIdRun,
  postOrgProxyConfigs,
  postOrgProxyConfigsByProxyConfigIdDeactivate,
  postOrgReviewAgents,
  postOrgReviewKinds,
  postOrgReviewQueues,
  postOrgReviewQueuesByQueueIdNext,
  postOrgReviewsByIdSelfAssign,
  postOrgReviewsByIdSelfUnassign,
  postOrgReviewsByIdStart,
  postOrgReviewTeams,
  postOrgRoles,
  postOrgRolesByTenantRoleIdDeactivate,
  postOrgTags,
  postOrgVaultDrAwsPreEnrollment,
  postOrgVaultDrEnroll,
  postOrgVaultDrRevealWrappedRecordKeys,
  postOrgVendorIntegrations,
  postOrgVendorIntegrationsByIntegrationIdCredentials,
  postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdReveal,
  postPrivateAccessRequests,
  postPrivateAssume,
  postVaultProxyLogsByLogIdReveal,
  putOrgAppearencesByAppearanceIdLogo,
  putOrgLogo,
} from '../sdk.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getQueryKey = (options?: Options<GetData>) => createQueryKey('get', options);

export const getOptions = (options?: Options<GetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await get({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getQueryKey(options),
  });
};

export const postBusinessesByFpBidVaultByIdentifierUploadQueryKey = (
  options: Options<PostBusinessesByFpBidVaultByIdentifierUploadData>,
) => createQueryKey('postBusinessesByFpBidVaultByIdentifierUpload', options);

/**
 * Sets the contents of the provided identifier for the provided business vault to the HTTP request body. Supports fp_bid or ext_id. Useful for uploading large objects.
 */
export const postBusinessesByFpBidVaultByIdentifierUploadOptions = (
  options: Options<PostBusinessesByFpBidVaultByIdentifierUploadData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postBusinessesByFpBidVaultByIdentifierUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postBusinessesByFpBidVaultByIdentifierUploadQueryKey(options),
  });
};

/**
 * Sets the contents of the provided identifier for the provided business vault to the HTTP request body. Supports fp_bid or ext_id. Useful for uploading large objects.
 */
export const postBusinessesByFpBidVaultByIdentifierUploadMutation = (
  options?: Partial<Options<PostBusinessesByFpBidVaultByIdentifierUploadData>>,
): UseMutationOptions<
  PostBusinessesByFpBidVaultByIdentifierUploadResponse,
  ApiError,
  Options<PostBusinessesByFpBidVaultByIdentifierUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    PostBusinessesByFpBidVaultByIdentifierUploadResponse,
    ApiError,
    Options<PostBusinessesByFpBidVaultByIdentifierUploadData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postBusinessesByFpBidVaultByIdentifierUpload({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChatSessionsQueryKey = (options?: Options<GetChatSessionsData>) =>
  createQueryKey('getChatSessions', options);

/**
 * List chat sessions for the authenticated tenant user.
 */
export const getChatSessionsOptions = (options?: Options<GetChatSessionsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChatSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChatSessionsQueryKey(options),
  });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = {
    ...queryKey[0],
  };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getChatSessionsInfiniteQueryKey = (
  options?: Options<GetChatSessionsData>,
): QueryKey<Options<GetChatSessionsData>> => createQueryKey('getChatSessions', options, true);

/**
 * List chat sessions for the authenticated tenant user.
 */
export const getChatSessionsInfiniteOptions = (options?: Options<GetChatSessionsData>) => {
  return infiniteQueryOptions<
    GetChatSessionsResponse,
    ApiError,
    InfiniteData<GetChatSessionsResponse>,
    QueryKey<Options<GetChatSessionsData>>,
    number | Pick<QueryKey<Options<GetChatSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetChatSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getChatSessions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getChatSessionsInfiniteQueryKey(options),
    },
  );
};

export const postChatSessionsQueryKey = (options: Options<PostChatSessionsData>) =>
  createQueryKey('postChatSessions', options);

/**
 * Create or resume a percy chat session.
 */
export const postChatSessionsOptions = (options: Options<PostChatSessionsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postChatSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postChatSessionsQueryKey(options),
  });
};

/**
 * Create or resume a percy chat session.
 */
export const postChatSessionsMutation = (
  options?: Partial<Options<PostChatSessionsData>>,
): UseMutationOptions<PostChatSessionsResponse, ApiError, Options<PostChatSessionsData>> => {
  const mutationOptions: UseMutationOptions<PostChatSessionsResponse, ApiError, Options<PostChatSessionsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postChatSessions({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Soft-delete a chat session by setting its deactivated_at timestamp.
 */
export const deleteChatSessionsByChatSessionIdMutation = (
  options?: Partial<Options<DeleteChatSessionsByChatSessionIdData>>,
): UseMutationOptions<
  DeleteChatSessionsByChatSessionIdResponse,
  ApiError,
  Options<DeleteChatSessionsByChatSessionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteChatSessionsByChatSessionIdResponse,
    ApiError,
    Options<DeleteChatSessionsByChatSessionIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteChatSessionsByChatSessionId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChatSessionsByChatSessionIdQueryKey = (options: Options<GetChatSessionsByChatSessionIdData>) =>
  createQueryKey('getChatSessionsByChatSessionId', options);

/**
 * Get a chat session includingthe status of its underlying percy session.
 */
export const getChatSessionsByChatSessionIdOptions = (options: Options<GetChatSessionsByChatSessionIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChatSessionsByChatSessionId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChatSessionsByChatSessionIdQueryKey(options),
  });
};

/**
 * Update a chat session's title or starred state.
 */
export const patchChatSessionsByChatSessionIdMutation = (
  options?: Partial<Options<PatchChatSessionsByChatSessionIdData>>,
): UseMutationOptions<
  PatchChatSessionsByChatSessionIdResponse,
  ApiError,
  Options<PatchChatSessionsByChatSessionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchChatSessionsByChatSessionIdResponse,
    ApiError,
    Options<PatchChatSessionsByChatSessionIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchChatSessionsByChatSessionId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChatSessionsByChatSessionIdWireMessagesQueryKey = (
  options: Options<GetChatSessionsByChatSessionIdWireMessagesData>,
) => createQueryKey('getChatSessionsByChatSessionIdWireMessages', options);

/**
 * List rendered wire-message rows for a chat session in insertion order. Each row is a single `WsMessage`. Sessions persisted before wire messages existed fall back to deriving messages from the raw transcript just in time.
 */
export const getChatSessionsByChatSessionIdWireMessagesOptions = (
  options: Options<GetChatSessionsByChatSessionIdWireMessagesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChatSessionsByChatSessionIdWireMessages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChatSessionsByChatSessionIdWireMessagesQueryKey(options),
  });
};

export const getChatSessionsByChatSessionIdWireMessagesInfiniteQueryKey = (
  options: Options<GetChatSessionsByChatSessionIdWireMessagesData>,
): QueryKey<Options<GetChatSessionsByChatSessionIdWireMessagesData>> =>
  createQueryKey('getChatSessionsByChatSessionIdWireMessages', options, true);

/**
 * List rendered wire-message rows for a chat session in insertion order. Each row is a single `WsMessage`. Sessions persisted before wire messages existed fall back to deriving messages from the raw transcript just in time.
 */
export const getChatSessionsByChatSessionIdWireMessagesInfiniteOptions = (
  options: Options<GetChatSessionsByChatSessionIdWireMessagesData>,
) => {
  return infiniteQueryOptions<
    GetChatSessionsByChatSessionIdWireMessagesResponse,
    ApiError,
    InfiniteData<GetChatSessionsByChatSessionIdWireMessagesResponse>,
    QueryKey<Options<GetChatSessionsByChatSessionIdWireMessagesData>>,
    | number
    | Pick<QueryKey<Options<GetChatSessionsByChatSessionIdWireMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetChatSessionsByChatSessionIdWireMessagesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getChatSessionsByChatSessionIdWireMessages({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getChatSessionsByChatSessionIdWireMessagesInfiniteQueryKey(options),
    },
  );
};

export const postEntitiesQueryKey = (options: Options<PostEntitiesData>) => createQueryKey('postEntities', options);

/**
 * Create a new entity, initializing its vault with the provided data
 */
export const postEntitiesOptions = (options: Options<PostEntitiesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesQueryKey(options),
  });
};

/**
 * Create a new entity, initializing its vault with the provided data
 */
export const postEntitiesMutation = (
  options?: Partial<Options<PostEntitiesData>>,
): UseMutationOptions<PostEntitiesResponse, ApiError, Options<PostEntitiesData>> => {
  const mutationOptions: UseMutationOptions<PostEntitiesResponse, ApiError, Options<PostEntitiesData>> = {
    mutationFn: async localOptions => {
      const { data } = await postEntities({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesClientTokenQueryKey = (options: Options<GetEntitiesClientTokenData>) =>
  createQueryKey('getEntitiesClientToken', options);

/**
 * Returns information about the provided client auth token.
 */
export const getEntitiesClientTokenOptions = (options: Options<GetEntitiesClientTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesClientToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesClientTokenQueryKey(options),
  });
};

export const postEntitiesExtractPromptQueryKey = (options: Options<PostEntitiesExtractPromptData>) =>
  createQueryKey('postEntitiesExtractPrompt', options);

/**
 * Extract entity name, kind, and investigation prompt from free-text input using LLM
 */
export const postEntitiesExtractPromptOptions = (options: Options<PostEntitiesExtractPromptData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesExtractPrompt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesExtractPromptQueryKey(options),
  });
};

/**
 * Extract entity name, kind, and investigation prompt from free-text input using LLM
 */
export const postEntitiesExtractPromptMutation = (
  options?: Partial<Options<PostEntitiesExtractPromptData>>,
): UseMutationOptions<PostEntitiesExtractPromptResponse, ApiError, Options<PostEntitiesExtractPromptData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesExtractPromptResponse,
    ApiError,
    Options<PostEntitiesExtractPromptData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesExtractPrompt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesSearchQueryKey = (options?: Options<PostEntitiesSearchData>) =>
  createQueryKey('postEntitiesSearch', options);

/**
 * This doesn't actually have side effects despite being a POST. The request simply needs to be sent as an HTTP body since it contains PII, and many HTTP clients don't support GET with an HTTP body
 * View list of entities (business or user) matching the search query.
 */
export const postEntitiesSearchOptions = (options?: Options<PostEntitiesSearchData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesSearchQueryKey(options),
  });
};

/**
 * This doesn't actually have side effects despite being a POST. The request simply needs to be sent as an HTTP body since it contains PII, and many HTTP clients don't support GET with an HTTP body
 * View list of entities (business or user) matching the search query.
 */
export const postEntitiesSearchMutation = (
  options?: Partial<Options<PostEntitiesSearchData>>,
): UseMutationOptions<PostEntitiesSearchResponse, ApiError, Options<PostEntitiesSearchData>> => {
  const mutationOptions: UseMutationOptions<PostEntitiesSearchResponse, ApiError, Options<PostEntitiesSearchData>> = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesSearch({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesSearchCountQueryKey = (options: Options<PostEntitiesSearchCountData>) =>
  createQueryKey('postEntitiesSearchCount', options);

/**
 * This doesn't actually have side effects despite being a POST. The request simply needs to be sent as an HTTP body since it contains PII, and many HTTP clients don't support GET with an HTTP body
 * Count the number of entities (business or user) matching the search query.
 */
export const postEntitiesSearchCountOptions = (options: Options<PostEntitiesSearchCountData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesSearchCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesSearchCountQueryKey(options),
  });
};

/**
 * This doesn't actually have side effects despite being a POST. The request simply needs to be sent as an HTTP body since it contains PII, and many HTTP clients don't support GET with an HTTP body
 * Count the number of entities (business or user) matching the search query.
 */
export const postEntitiesSearchCountMutation = (
  options?: Partial<Options<PostEntitiesSearchCountData>>,
): UseMutationOptions<PostEntitiesSearchCountResponse, ApiError, Options<PostEntitiesSearchCountData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesSearchCountResponse,
    ApiError,
    Options<PostEntitiesSearchCountData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesSearchCount({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Works for either person or business entities. Updates data in a vault given a short-lived, entity-scoped client token.
 */
export const patchEntitiesVaultMutation = (
  options?: Partial<Options<PatchEntitiesVaultData>>,
): UseMutationOptions<PatchEntitiesVaultResponse, ApiError, Options<PatchEntitiesVaultData>> => {
  const mutationOptions: UseMutationOptions<PatchEntitiesVaultResponse, ApiError, Options<PatchEntitiesVaultData>> = {
    mutationFn: async localOptions => {
      const { data } = await patchEntitiesVault({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesVaultDecryptQueryKey = (options: Options<PostEntitiesVaultDecryptData>) =>
  createQueryKey('postEntitiesVaultDecrypt', options);

/**
 * Works for either person or business entities. Decrypts the specified list of fields given a short-lived, entity-scoped client token
 */
export const postEntitiesVaultDecryptOptions = (options: Options<PostEntitiesVaultDecryptData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesVaultDecrypt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesVaultDecryptQueryKey(options),
  });
};

/**
 * Works for either person or business entities. Decrypts the specified list of fields given a short-lived, entity-scoped client token
 */
export const postEntitiesVaultDecryptMutation = (
  options?: Partial<Options<PostEntitiesVaultDecryptData>>,
): UseMutationOptions<PostEntitiesVaultDecryptResponse, ApiError, Options<PostEntitiesVaultDecryptData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesVaultDecryptResponse,
    ApiError,
    Options<PostEntitiesVaultDecryptData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesVaultDecrypt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesVaultDecryptByTokenQueryKey = (options: Options<GetEntitiesVaultDecryptByTokenData>) =>
  createQueryKey('getEntitiesVaultDecryptByToken', options);

/**
 * Works for either person or business entities. Decrypts and downloads the entity's data as specified by the provided token.
 */
export const getEntitiesVaultDecryptByTokenOptions = (options: Options<GetEntitiesVaultDecryptByTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesVaultDecryptByToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesVaultDecryptByTokenQueryKey(options),
  });
};

export const postEntitiesVaultValidateQueryKey = (options: Options<PostEntitiesVaultValidateData>) =>
  createQueryKey('postEntitiesVaultValidate', options);

/**
 * Checks if provided data is valid before adding it to the vault given a short-lived, user-scoped client token. Returns an HTTP 200 if there are no validation errors, or HTTP 400 with context describing validation errors if any.
 */
export const postEntitiesVaultValidateOptions = (options: Options<PostEntitiesVaultValidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesVaultValidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesVaultValidateQueryKey(options),
  });
};

/**
 * Checks if provided data is valid before adding it to the vault given a short-lived, user-scoped client token. Returns an HTTP 200 if there are no validation errors, or HTTP 400 with context describing validation errors if any.
 */
export const postEntitiesVaultValidateMutation = (
  options?: Partial<Options<PostEntitiesVaultValidateData>>,
): UseMutationOptions<PostEntitiesVaultValidateResponse, ApiError, Options<PostEntitiesVaultValidateData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesVaultValidateResponse,
    ApiError,
    Options<PostEntitiesVaultValidateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesVaultValidate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesVaultByIdentifierUploadQueryKey = (
  options: Options<PostEntitiesVaultByIdentifierUploadData>,
) => createQueryKey('postEntitiesVaultByIdentifierUpload', options);

/**
 * Works for either person or business entities. Updates data in a vault given a short-lived, entity-scoped client token.
 */
export const postEntitiesVaultByIdentifierUploadOptions = (
  options: Options<PostEntitiesVaultByIdentifierUploadData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesVaultByIdentifierUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesVaultByIdentifierUploadQueryKey(options),
  });
};

/**
 * Works for either person or business entities. Updates data in a vault given a short-lived, entity-scoped client token.
 */
export const postEntitiesVaultByIdentifierUploadMutation = (
  options?: Partial<Options<PostEntitiesVaultByIdentifierUploadData>>,
): UseMutationOptions<
  PostEntitiesVaultByIdentifierUploadResponse,
  ApiError,
  Options<PostEntitiesVaultByIdentifierUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesVaultByIdentifierUploadResponse,
    ApiError,
    Options<PostEntitiesVaultByIdentifierUploadData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesVaultByIdentifierUpload({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsQueryKey = (
  options: Options<GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsData>,
) => createQueryKey('getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsights', options);

/**
 * Retrieve business insights for a given fp_bid and onboarding.
 */
export const getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsOptions = (
  options: Options<GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsights({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsQueryKey(options),
  });
};

export const postEntitiesByFpIdVaultByIdentifierUploadQueryKey = (
  options: Options<PostEntitiesByFpIdVaultByIdentifierUploadData>,
) => createQueryKey('postEntitiesByFpIdVaultByIdentifierUpload', options);

/**
 * Works for either person or business entities. Supports fp_id or ext_id. Updates data in a vault.
 */
export const postEntitiesByFpIdVaultByIdentifierUploadOptions = (
  options: Options<PostEntitiesByFpIdVaultByIdentifierUploadData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdVaultByIdentifierUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdVaultByIdentifierUploadQueryKey(options),
  });
};

/**
 * Works for either person or business entities. Supports fp_id or ext_id. Updates data in a vault.
 */
export const postEntitiesByFpIdVaultByIdentifierUploadMutation = (
  options?: Partial<Options<PostEntitiesByFpIdVaultByIdentifierUploadData>>,
): UseMutationOptions<
  PostEntitiesByFpIdVaultByIdentifierUploadResponse,
  ApiError,
  Options<PostEntitiesByFpIdVaultByIdentifierUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdVaultByIdentifierUploadResponse,
    ApiError,
    Options<PostEntitiesByFpIdVaultByIdentifierUploadData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdVaultByIdentifierUpload({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Deactivate an entity.
 */
export const deleteEntitiesByFpIdMutation = (
  options?: Partial<Options<DeleteEntitiesByFpIdData>>,
): UseMutationOptions<DeleteEntitiesByFpIdResponse, ApiError, Options<DeleteEntitiesByFpIdData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteEntitiesByFpIdResponse,
    ApiError,
    Options<DeleteEntitiesByFpIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteEntitiesByFpId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdQueryKey = (options: Options<GetEntitiesByFpIdData>) =>
  createQueryKey('getEntitiesByFpId', options);

/**
 * View details of a specific entity (business or user)
 */
export const getEntitiesByFpIdOptions = (options: Options<GetEntitiesByFpIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdQueryKey(options),
  });
};

export const postEntitiesByFpIdAgentsExecutionByIdQueryKey = (
  options: Options<PostEntitiesByFpIdAgentsExecutionByIdData>,
) => createQueryKey('postEntitiesByFpIdAgentsExecutionById', options);

/**
 * Decrypts structured information about the Agent Execution output
 */
export const postEntitiesByFpIdAgentsExecutionByIdOptions = (
  options: Options<PostEntitiesByFpIdAgentsExecutionByIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdAgentsExecutionById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdAgentsExecutionByIdQueryKey(options),
  });
};

/**
 * Decrypts structured information about the Agent Execution output
 */
export const postEntitiesByFpIdAgentsExecutionByIdMutation = (
  options?: Partial<Options<PostEntitiesByFpIdAgentsExecutionByIdData>>,
): UseMutationOptions<
  PostEntitiesByFpIdAgentsExecutionByIdResponse,
  ApiError,
  Options<PostEntitiesByFpIdAgentsExecutionByIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdAgentsExecutionByIdResponse,
    ApiError,
    Options<PostEntitiesByFpIdAgentsExecutionByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdAgentsExecutionById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesByFpIdInvestigationsArtifactsQueryKey = (
  options: Options<PostEntitiesByFpIdInvestigationsArtifactsData>,
) => createQueryKey('postEntitiesByFpIdInvestigationsArtifacts', options);

/**
 * Store artifacts as onboarding data for an investigation
 */
export const postEntitiesByFpIdInvestigationsArtifactsOptions = (
  options: Options<PostEntitiesByFpIdInvestigationsArtifactsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdInvestigationsArtifacts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdInvestigationsArtifactsQueryKey(options),
  });
};

/**
 * Store artifacts as onboarding data for an investigation
 */
export const postEntitiesByFpIdInvestigationsArtifactsMutation = (
  options?: Partial<Options<PostEntitiesByFpIdInvestigationsArtifactsData>>,
): UseMutationOptions<
  PostEntitiesByFpIdInvestigationsArtifactsResponse,
  ApiError,
  Options<PostEntitiesByFpIdInvestigationsArtifactsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdInvestigationsArtifactsResponse,
    ApiError,
    Options<PostEntitiesByFpIdInvestigationsArtifactsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdInvestigationsArtifacts({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdInvestigationsArtifactsByKeyQueryKey = (
  options: Options<GetEntitiesByFpIdInvestigationsArtifactsByKeyData>,
) => createQueryKey('getEntitiesByFpIdInvestigationsArtifactsByKey', options);

/**
 * Retrieve a single investigation artifact by filename, decrypted
 */
export const getEntitiesByFpIdInvestigationsArtifactsByKeyOptions = (
  options: Options<GetEntitiesByFpIdInvestigationsArtifactsByKeyData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdInvestigationsArtifactsByKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdInvestigationsArtifactsByKeyQueryKey(options),
  });
};

export const getEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionQueryKey = (
  options: Options<GetEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionData>,
) => createQueryKey('getEntitiesByFpIdInvestigationsByInvestigationIdActiveSession', options);

/**
 * Get the latest active session for an investiation
 */
export const getEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionOptions = (
  options: Options<GetEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdInvestigationsByInvestigationIdActiveSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionQueryKey(options),
  });
};

/**
 * Deactivate an investigation artifact by key
 */
export const deleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyMutation = (
  options?: Partial<Options<DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyData>>,
): UseMutationOptions<
  DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyResponse,
  ApiError,
  Options<DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyResponse,
    ApiError,
    Options<DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKey({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdLabelQueryKey = (options: Options<GetEntitiesByFpIdLabelData>) =>
  createQueryKey('getEntitiesByFpIdLabel', options);

/**
 * View a user's label
 */
export const getEntitiesByFpIdLabelOptions = (options: Options<GetEntitiesByFpIdLabelData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdLabel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdLabelQueryKey(options),
  });
};

export const postEntitiesByFpIdLabelQueryKey = (options: Options<PostEntitiesByFpIdLabelData>) =>
  createQueryKey('postEntitiesByFpIdLabel', options);

/**
 * Update a user's label
 */
export const postEntitiesByFpIdLabelOptions = (options: Options<PostEntitiesByFpIdLabelData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdLabel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdLabelQueryKey(options),
  });
};

/**
 * Update a user's label
 */
export const postEntitiesByFpIdLabelMutation = (
  options?: Partial<Options<PostEntitiesByFpIdLabelData>>,
): UseMutationOptions<PostEntitiesByFpIdLabelResponse, ApiError, Options<PostEntitiesByFpIdLabelData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdLabelResponse,
    ApiError,
    Options<PostEntitiesByFpIdLabelData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdLabel({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdTagsQueryKey = (options: Options<GetEntitiesByFpIdTagsData>) =>
  createQueryKey('getEntitiesByFpIdTags', options);

/**
 * View a user's tags
 */
export const getEntitiesByFpIdTagsOptions = (options: Options<GetEntitiesByFpIdTagsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdTags({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdTagsQueryKey(options),
  });
};

export const postEntitiesByFpIdTagsQueryKey = (options: Options<PostEntitiesByFpIdTagsData>) =>
  createQueryKey('postEntitiesByFpIdTags', options);

/**
 * Tag a user
 */
export const postEntitiesByFpIdTagsOptions = (options: Options<PostEntitiesByFpIdTagsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdTags({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdTagsQueryKey(options),
  });
};

/**
 * Tag a user
 */
export const postEntitiesByFpIdTagsMutation = (
  options?: Partial<Options<PostEntitiesByFpIdTagsData>>,
): UseMutationOptions<PostEntitiesByFpIdTagsResponse, ApiError, Options<PostEntitiesByFpIdTagsData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdTagsResponse,
    ApiError,
    Options<PostEntitiesByFpIdTagsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdTags({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Untag a user
 */
export const deleteEntitiesByFpIdTagsByTagIdMutation = (
  options?: Partial<Options<DeleteEntitiesByFpIdTagsByTagIdData>>,
): UseMutationOptions<
  DeleteEntitiesByFpIdTagsByTagIdResponse,
  ApiError,
  Options<DeleteEntitiesByFpIdTagsByTagIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteEntitiesByFpIdTagsByTagIdResponse,
    ApiError,
    Options<DeleteEntitiesByFpIdTagsByTagIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteEntitiesByFpIdTagsByTagId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesByFpIdActionsQueryKey = (options: Options<PostEntitiesByFpIdActionsData>) =>
  createQueryKey('postEntitiesByFpIdActions', options);

/**
 * Atomically apply the provided list of actions.
 */
export const postEntitiesByFpIdActionsOptions = (options: Options<PostEntitiesByFpIdActionsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdActions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdActionsQueryKey(options),
  });
};

/**
 * Atomically apply the provided list of actions.
 */
export const postEntitiesByFpIdActionsMutation = (
  options?: Partial<Options<PostEntitiesByFpIdActionsData>>,
): UseMutationOptions<PostEntitiesByFpIdActionsResponse, ApiError, Options<PostEntitiesByFpIdActionsData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdActionsResponse,
    ApiError,
    Options<PostEntitiesByFpIdActionsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdActions({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdAnnotationsQueryKey = (options: Options<GetEntitiesByFpIdAnnotationsData>) =>
  createQueryKey('getEntitiesByFpIdAnnotations', options);

/**
 * Gets the annotations for a user.
 */
export const getEntitiesByFpIdAnnotationsOptions = (options: Options<GetEntitiesByFpIdAnnotationsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdAnnotations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdAnnotationsQueryKey(options),
  });
};

export const postEntitiesByFpIdAnnotationsQueryKey = (options: Options<PostEntitiesByFpIdAnnotationsData>) =>
  createQueryKey('postEntitiesByFpIdAnnotations', options);

/**
 * Creates a new freeform annotation.
 */
export const postEntitiesByFpIdAnnotationsOptions = (options: Options<PostEntitiesByFpIdAnnotationsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdAnnotations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdAnnotationsQueryKey(options),
  });
};

/**
 * Creates a new freeform annotation.
 */
export const postEntitiesByFpIdAnnotationsMutation = (
  options?: Partial<Options<PostEntitiesByFpIdAnnotationsData>>,
): UseMutationOptions<PostEntitiesByFpIdAnnotationsResponse, ApiError, Options<PostEntitiesByFpIdAnnotationsData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdAnnotationsResponse,
    ApiError,
    Options<PostEntitiesByFpIdAnnotationsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdAnnotations({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Deletes an existing annotation.
 */
export const deleteEntitiesByFpIdAnnotationsByAnnotationIdMutation = (
  options?: Partial<Options<DeleteEntitiesByFpIdAnnotationsByAnnotationIdData>>,
): UseMutationOptions<
  DeleteEntitiesByFpIdAnnotationsByAnnotationIdResponse,
  ApiError,
  Options<DeleteEntitiesByFpIdAnnotationsByAnnotationIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteEntitiesByFpIdAnnotationsByAnnotationIdResponse,
    ApiError,
    Options<DeleteEntitiesByFpIdAnnotationsByAnnotationIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteEntitiesByFpIdAnnotationsByAnnotationId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates an existing annotation.
 */
export const patchEntitiesByFpIdAnnotationsByAnnotationIdMutation = (
  options?: Partial<Options<PatchEntitiesByFpIdAnnotationsByAnnotationIdData>>,
): UseMutationOptions<
  PatchEntitiesByFpIdAnnotationsByAnnotationIdResponse,
  ApiError,
  Options<PatchEntitiesByFpIdAnnotationsByAnnotationIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchEntitiesByFpIdAnnotationsByAnnotationIdResponse,
    ApiError,
    Options<PatchEntitiesByFpIdAnnotationsByAnnotationIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchEntitiesByFpIdAnnotationsByAnnotationId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdAvailableAdhocVendorsQueryKey = (
  options: Options<GetEntitiesByFpIdAvailableAdhocVendorsData>,
) => createQueryKey('getEntitiesByFpIdAvailableAdhocVendors', options);

/**
 * List all available adhoc vendors
 */
export const getEntitiesByFpIdAvailableAdhocVendorsOptions = (
  options: Options<GetEntitiesByFpIdAvailableAdhocVendorsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdAvailableAdhocVendors({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdAvailableAdhocVendorsQueryKey(options),
  });
};

export const getEntitiesByFpIdBusinessOwnersQueryKey = (options: Options<GetEntitiesByFpIdBusinessOwnersData>) =>
  createQueryKey('getEntitiesByFpIdBusinessOwners', options);

/**
 * Gets the beneficial owners of a business entity.
 */
export const getEntitiesByFpIdBusinessOwnersOptions = (options: Options<GetEntitiesByFpIdBusinessOwnersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdBusinessOwners({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdBusinessOwnersQueryKey(options),
  });
};

export const postEntitiesByFpIdBusinessOwnersKycLinksQueryKey = (
  options: Options<PostEntitiesByFpIdBusinessOwnersKycLinksData>,
) => createQueryKey('postEntitiesByFpIdBusinessOwnersKycLinks', options);

/**
 * Create (and optionally send) KYC links for beneficial owners awaiting KYC. Cannot be used for beneficials that have already completed KYC.
 */
export const postEntitiesByFpIdBusinessOwnersKycLinksOptions = (
  options: Options<PostEntitiesByFpIdBusinessOwnersKycLinksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdBusinessOwnersKycLinks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdBusinessOwnersKycLinksQueryKey(options),
  });
};

/**
 * Create (and optionally send) KYC links for beneficial owners awaiting KYC. Cannot be used for beneficials that have already completed KYC.
 */
export const postEntitiesByFpIdBusinessOwnersKycLinksMutation = (
  options?: Partial<Options<PostEntitiesByFpIdBusinessOwnersKycLinksData>>,
): UseMutationOptions<
  PostEntitiesByFpIdBusinessOwnersKycLinksResponse,
  ApiError,
  Options<PostEntitiesByFpIdBusinessOwnersKycLinksData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdBusinessOwnersKycLinksResponse,
    ApiError,
    Options<PostEntitiesByFpIdBusinessOwnersKycLinksData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdBusinessOwnersKycLinks({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdBusinessesQueryKey = (options: Options<GetEntitiesByFpIdBusinessesData>) =>
  createQueryKey('getEntitiesByFpIdBusinesses', options);

/**
 * Gets the beneficial owners of a business entity.
 */
export const getEntitiesByFpIdBusinessesOptions = (options: Options<GetEntitiesByFpIdBusinessesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdBusinesses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdBusinessesQueryKey(options),
  });
};

export const getEntitiesByFpIdDataQueryKey = (options: Options<GetEntitiesByFpIdDataData>) =>
  createQueryKey('getEntitiesByFpIdData', options);

/**
 * View the vault data for a specific entity (business or user)
 */
export const getEntitiesByFpIdDataOptions = (options: Options<GetEntitiesByFpIdDataData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdDataQueryKey(options),
  });
};

export const postEntitiesByFpIdDecryptAmlHitsBySignalIdQueryKey = (
  options: Options<PostEntitiesByFpIdDecryptAmlHitsBySignalIdData>,
) => createQueryKey('postEntitiesByFpIdDecryptAmlHitsBySignalId', options);

/**
 * Decrypts structured information about the AML hits for a AML risk signal.
 */
export const postEntitiesByFpIdDecryptAmlHitsBySignalIdOptions = (
  options: Options<PostEntitiesByFpIdDecryptAmlHitsBySignalIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdDecryptAmlHitsBySignalId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdDecryptAmlHitsBySignalIdQueryKey(options),
  });
};

/**
 * Decrypts structured information about the AML hits for a AML risk signal.
 */
export const postEntitiesByFpIdDecryptAmlHitsBySignalIdMutation = (
  options?: Partial<Options<PostEntitiesByFpIdDecryptAmlHitsBySignalIdData>>,
): UseMutationOptions<
  PostEntitiesByFpIdDecryptAmlHitsBySignalIdResponse,
  ApiError,
  Options<PostEntitiesByFpIdDecryptAmlHitsBySignalIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdDecryptAmlHitsBySignalIdResponse,
    ApiError,
    Options<PostEntitiesByFpIdDecryptAmlHitsBySignalIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdDecryptAmlHitsBySignalId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdDocumentsQueryKey = (options: Options<GetEntitiesByFpIdDocumentsData>) =>
  createQueryKey('getEntitiesByFpIdDocuments', options);

/**
 * View the documents uploaded for this vault.
 */
export const getEntitiesByFpIdDocumentsOptions = (options: Options<GetEntitiesByFpIdDocumentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdDocumentsQueryKey(options),
  });
};

export const getEntitiesByFpIdDocumentsByDocumentIdentifierQueryKey = (
  options: Options<GetEntitiesByFpIdDocumentsByDocumentIdentifierData>,
) => createQueryKey('getEntitiesByFpIdDocumentsByDocumentIdentifier', options);

/**
 * View the documents uploaded for this vault.
 */
export const getEntitiesByFpIdDocumentsByDocumentIdentifierOptions = (
  options: Options<GetEntitiesByFpIdDocumentsByDocumentIdentifierData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdDocumentsByDocumentIdentifier({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdDocumentsByDocumentIdentifierQueryKey(options),
  });
};

export const getEntitiesByFpIdDupesQueryKey = (options: Options<GetEntitiesByFpIdDupesData>) =>
  createQueryKey('getEntitiesByFpIdDupes', options);

/**
 * Lists information about other vaults with duplicate information for a footprint vault.
 */
export const getEntitiesByFpIdDupesOptions = (options: Options<GetEntitiesByFpIdDupesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdDupes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdDupesQueryKey(options),
  });
};

export const getEntitiesByFpIdLinkedBankAccountsQueryKey = (
  options: Options<GetEntitiesByFpIdLinkedBankAccountsData>,
) => createQueryKey('getEntitiesByFpIdLinkedBankAccounts', options);

/**
 * Get the linked bank accounts for an entity.
 */
export const getEntitiesByFpIdLinkedBankAccountsOptions = (
  options: Options<GetEntitiesByFpIdLinkedBankAccountsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdLinkedBankAccounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdLinkedBankAccountsQueryKey(options),
  });
};

export const getEntitiesByFpIdLivenessQueryKey = (options: Options<GetEntitiesByFpIdLivenessData>) =>
  createQueryKey('getEntitiesByFpIdLiveness', options);

/**
 * Allows a tenant to view a customer's registered webauthn credentials.
 */
export const getEntitiesByFpIdLivenessOptions = (options: Options<GetEntitiesByFpIdLivenessData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdLiveness({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdLivenessQueryKey(options),
  });
};

export const getEntitiesByFpIdMatchSignalsQueryKey = (options: Options<GetEntitiesByFpIdMatchSignalsData>) =>
  createQueryKey('getEntitiesByFpIdMatchSignals', options);

/**
 * Lists the match signals for a footprint user.
 */
export const getEntitiesByFpIdMatchSignalsOptions = (options: Options<GetEntitiesByFpIdMatchSignalsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdMatchSignals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdMatchSignalsQueryKey(options),
  });
};

export const getEntitiesByFpIdOnboardingsQueryKey = (options: Options<GetEntitiesByFpIdOnboardingsData>) =>
  createQueryKey('getEntitiesByFpIdOnboardings', options);

/**
 * Get the list of playbooks this user has onboarded onto, ordered by timestamp descending. If a user has onboarded onto one playbook multiple times, there will be multiple onboardings. Useful to find the status from onboarding onto a specific playbook.
 */
export const getEntitiesByFpIdOnboardingsOptions = (options: Options<GetEntitiesByFpIdOnboardingsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdOnboardings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdOnboardingsQueryKey(options),
  });
};

export const getEntitiesByFpIdOnboardingsInfiniteQueryKey = (
  options: Options<GetEntitiesByFpIdOnboardingsData>,
): QueryKey<Options<GetEntitiesByFpIdOnboardingsData>> => createQueryKey('getEntitiesByFpIdOnboardings', options, true);

/**
 * Get the list of playbooks this user has onboarded onto, ordered by timestamp descending. If a user has onboarded onto one playbook multiple times, there will be multiple onboardings. Useful to find the status from onboarding onto a specific playbook.
 */
export const getEntitiesByFpIdOnboardingsInfiniteOptions = (options: Options<GetEntitiesByFpIdOnboardingsData>) => {
  return infiniteQueryOptions<
    GetEntitiesByFpIdOnboardingsResponse,
    ApiError,
    InfiniteData<GetEntitiesByFpIdOnboardingsResponse>,
    QueryKey<Options<GetEntitiesByFpIdOnboardingsData>>,
    number | Pick<QueryKey<Options<GetEntitiesByFpIdOnboardingsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetEntitiesByFpIdOnboardingsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getEntitiesByFpIdOnboardings({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getEntitiesByFpIdOnboardingsInfiniteQueryKey(options),
    },
  );
};

export const getEntitiesByFpIdOnboardingsByOnboardingIdQueryKey = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdData>,
) => createQueryKey('getEntitiesByFpIdOnboardingsByOnboardingId', options);

/**
 * Get a single onboarding by workflow ID for the given entity.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdOptions = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdOnboardingsByOnboardingId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdOnboardingsByOnboardingIdQueryKey(options),
  });
};

export const getEntitiesByFpIdOnboardingsByOnboardingIdDataQueryKey = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdDataData>,
) => createQueryKey('getEntitiesByFpIdOnboardingsByOnboardingIdData', options);

/**
 * Get all onboarding data for a specific onboarding, decrypted. The schema field describes the data type; if None, assume the value is a string.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdDataOptions = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdDataData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdOnboardingsByOnboardingIdData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdOnboardingsByOnboardingIdDataQueryKey(options),
  });
};

export const getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsQueryKey = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsData>,
) => createQueryKey('getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignals', options);

/**
 * Lists the match signals for a footprint user.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsOptions = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsQueryKey(options),
  });
};

export const getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsQueryKey = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsData>,
) => createQueryKey('getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignals', options);

/**
 * Lists the risk signals for a footprint user and onboarding.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsOptions = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsQueryKey(options),
  });
};

export const getEntitiesByFpIdOnboardingsByOnboardingIdTraceQueryKey = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdTraceData>,
) => createQueryKey('getEntitiesByFpIdOnboardingsByOnboardingIdTrace', options);

/**
 * Get the onboarding trace for a given onboarding
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdTraceOptions = (
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdTraceData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdOnboardingsByOnboardingIdTrace({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdOnboardingsByOnboardingIdTraceQueryKey(options),
  });
};

export const postEntitiesByFpIdRequestFpReviewQueryKey = (options: Options<PostEntitiesByFpIdRequestFpReviewData>) =>
  createQueryKey('postEntitiesByFpIdRequestFpReview', options);

/**
 * Request that Footprint review an entity's profile
 */
export const postEntitiesByFpIdRequestFpReviewOptions = (options: Options<PostEntitiesByFpIdRequestFpReviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdRequestFpReview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdRequestFpReviewQueryKey(options),
  });
};

/**
 * Request that Footprint review an entity's profile
 */
export const postEntitiesByFpIdRequestFpReviewMutation = (
  options?: Partial<Options<PostEntitiesByFpIdRequestFpReviewData>>,
): UseMutationOptions<
  PostEntitiesByFpIdRequestFpReviewResponse,
  ApiError,
  Options<PostEntitiesByFpIdRequestFpReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdRequestFpReviewResponse,
    ApiError,
    Options<PostEntitiesByFpIdRequestFpReviewData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdRequestFpReview({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdReviewsQueryKey = (options: Options<GetEntitiesByFpIdReviewsData>) =>
  createQueryKey('getEntitiesByFpIdReviews', options);

/**
 * List all incomplete reviews for an entity
 */
export const getEntitiesByFpIdReviewsOptions = (options: Options<GetEntitiesByFpIdReviewsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdReviewsQueryKey(options),
  });
};

export const getEntitiesByFpIdRiskSignalsQueryKey = (options: Options<GetEntitiesByFpIdRiskSignalsData>) =>
  createQueryKey('getEntitiesByFpIdRiskSignals', options);

/**
 * Lists the risk signals for a footprint user.
 */
export const getEntitiesByFpIdRiskSignalsOptions = (options: Options<GetEntitiesByFpIdRiskSignalsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdRiskSignals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdRiskSignalsQueryKey(options),
  });
};

export const getEntitiesByFpIdRuleSetResultQueryKey = (options: Options<GetEntitiesByFpIdRuleSetResultData>) =>
  createQueryKey('getEntitiesByFpIdRuleSetResult', options);

/**
 * Retrieves the result of executing rules from the latest workflow decision made
 */
export const getEntitiesByFpIdRuleSetResultOptions = (options: Options<GetEntitiesByFpIdRuleSetResultData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdRuleSetResult({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdRuleSetResultQueryKey(options),
  });
};

export const getEntitiesByFpIdRuleSetResultByRuleSetResultIdQueryKey = (
  options: Options<GetEntitiesByFpIdRuleSetResultByRuleSetResultIdData>,
) => createQueryKey('getEntitiesByFpIdRuleSetResultByRuleSetResultId', options);

/**
 * Retrieves the RuleSetResult for the given fp_id,rule_set_result_id
 */
export const getEntitiesByFpIdRuleSetResultByRuleSetResultIdOptions = (
  options: Options<GetEntitiesByFpIdRuleSetResultByRuleSetResultIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdRuleSetResultByRuleSetResultId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdRuleSetResultByRuleSetResultIdQueryKey(options),
  });
};

export const postEntitiesByFpIdSentilinkBySignalIdQueryKey = (
  options: Options<PostEntitiesByFpIdSentilinkBySignalIdData>,
) => createQueryKey('postEntitiesByFpIdSentilinkBySignalId', options);

/**
 * Decrypts structured information about the sentilink risk levels
 */
export const postEntitiesByFpIdSentilinkBySignalIdOptions = (
  options: Options<PostEntitiesByFpIdSentilinkBySignalIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdSentilinkBySignalId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdSentilinkBySignalIdQueryKey(options),
  });
};

/**
 * Decrypts structured information about the sentilink risk levels
 */
export const postEntitiesByFpIdSentilinkBySignalIdMutation = (
  options?: Partial<Options<PostEntitiesByFpIdSentilinkBySignalIdData>>,
): UseMutationOptions<
  PostEntitiesByFpIdSentilinkBySignalIdResponse,
  ApiError,
  Options<PostEntitiesByFpIdSentilinkBySignalIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdSentilinkBySignalIdResponse,
    ApiError,
    Options<PostEntitiesByFpIdSentilinkBySignalIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdSentilinkBySignalId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update an entity's entity status.
 */
export const patchEntitiesByFpIdStatusesMutation = (
  options?: Partial<Options<PatchEntitiesByFpIdStatusesData>>,
): UseMutationOptions<PatchEntitiesByFpIdStatusesResponse, ApiError, Options<PatchEntitiesByFpIdStatusesData>> => {
  const mutationOptions: UseMutationOptions<
    PatchEntitiesByFpIdStatusesResponse,
    ApiError,
    Options<PatchEntitiesByFpIdStatusesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchEntitiesByFpIdStatuses({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdTimelineQueryKey = (options: Options<GetEntitiesByFpIdTimelineData>) =>
  createQueryKey('getEntitiesByFpIdTimeline', options);

/**
 * Gets the timeline for a user.
 */
export const getEntitiesByFpIdTimelineOptions = (options: Options<GetEntitiesByFpIdTimelineData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdTimeline({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdTimelineQueryKey(options),
  });
};

export const getEntitiesByFpIdTimelineInfiniteQueryKey = (
  options: Options<GetEntitiesByFpIdTimelineData>,
): QueryKey<Options<GetEntitiesByFpIdTimelineData>> => createQueryKey('getEntitiesByFpIdTimeline', options, true);

/**
 * Gets the timeline for a user.
 */
export const getEntitiesByFpIdTimelineInfiniteOptions = (options: Options<GetEntitiesByFpIdTimelineData>) => {
  return infiniteQueryOptions<
    GetEntitiesByFpIdTimelineResponse,
    ApiError,
    InfiniteData<GetEntitiesByFpIdTimelineResponse>,
    QueryKey<Options<GetEntitiesByFpIdTimelineData>>,
    string | Pick<QueryKey<Options<GetEntitiesByFpIdTimelineData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetEntitiesByFpIdTimelineData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getEntitiesByFpIdTimeline({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getEntitiesByFpIdTimelineInfiniteQueryKey(options),
    },
  );
};

export const postEntitiesByFpIdTokenQueryKey = (options: Options<PostEntitiesByFpIdTokenData>) =>
  createQueryKey('postEntitiesByFpIdToken', options);

/**
 * Create an identified token for the provided fp_id and a link to the hosted flow that allows the user to complete the requested flow.
 */
export const postEntitiesByFpIdTokenOptions = (options: Options<PostEntitiesByFpIdTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdTokenQueryKey(options),
  });
};

/**
 * Create an identified token for the provided fp_id and a link to the hosted flow that allows the user to complete the requested flow.
 */
export const postEntitiesByFpIdTokenMutation = (
  options?: Partial<Options<PostEntitiesByFpIdTokenData>>,
): UseMutationOptions<PostEntitiesByFpIdTokenResponse, ApiError, Options<PostEntitiesByFpIdTokenData>> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdTokenResponse,
    ApiError,
    Options<PostEntitiesByFpIdTokenData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdUserInsightsQueryKey = (options: Options<GetEntitiesByFpIdUserInsightsData>) =>
  createQueryKey('getEntitiesByFpIdUserInsights', options);

/**
 * Lists the user insights for a Footprint user: the consolidated insights across every onboarding (no onboarding_id) followed by each onboarding's own insights
 */
export const getEntitiesByFpIdUserInsightsOptions = (options: Options<GetEntitiesByFpIdUserInsightsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdUserInsights({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdUserInsightsQueryKey(options),
  });
};

/**
 * Works for either person or business entities. Deletes the provided fields from the provide vault.
 */
export const deleteEntitiesByFpIdVaultMutation = (
  options?: Partial<Options<DeleteEntitiesByFpIdVaultData>>,
): UseMutationOptions<DeleteEntitiesByFpIdVaultResponse, ApiError, Options<DeleteEntitiesByFpIdVaultData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteEntitiesByFpIdVaultResponse,
    ApiError,
    Options<DeleteEntitiesByFpIdVaultData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteEntitiesByFpIdVault({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getEntitiesByFpIdVaultQueryKey = (options: Options<GetEntitiesByFpIdVaultData>) =>
  createQueryKey('getEntitiesByFpIdVault', options);

/**
 * Returns information on which fields are present in the vault.
 */
export const getEntitiesByFpIdVaultOptions = (options: Options<GetEntitiesByFpIdVaultData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEntitiesByFpIdVault({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEntitiesByFpIdVaultQueryKey(options),
  });
};

/**
 * Works for either person or business entities. Updates data in a vault.
 */
export const patchEntitiesByFpIdVaultMutation = (
  options?: Partial<Options<PatchEntitiesByFpIdVaultData>>,
): UseMutationOptions<PatchEntitiesByFpIdVaultResponse, ApiError, Options<PatchEntitiesByFpIdVaultData>> => {
  const mutationOptions: UseMutationOptions<
    PatchEntitiesByFpIdVaultResponse,
    ApiError,
    Options<PatchEntitiesByFpIdVaultData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchEntitiesByFpIdVault({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesByFpIdVaultDecryptQueryKey = (options: Options<PostEntitiesByFpIdVaultDecryptData>) =>
  createQueryKey('postEntitiesByFpIdVaultDecrypt', options);

/**
 * Works for either person or business entities. Decrypts the specified list of fields from the provided vault.
 */
export const postEntitiesByFpIdVaultDecryptOptions = (options: Options<PostEntitiesByFpIdVaultDecryptData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdVaultDecrypt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdVaultDecryptQueryKey(options),
  });
};

/**
 * Works for either person or business entities. Decrypts the specified list of fields from the provided vault.
 */
export const postEntitiesByFpIdVaultDecryptMutation = (
  options?: Partial<Options<PostEntitiesByFpIdVaultDecryptData>>,
): UseMutationOptions<
  PostEntitiesByFpIdVaultDecryptResponse,
  ApiError,
  Options<PostEntitiesByFpIdVaultDecryptData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdVaultDecryptResponse,
    ApiError,
    Options<PostEntitiesByFpIdVaultDecryptData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdVaultDecrypt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesByFpIdVaultIntegrityQueryKey = (options: Options<PostEntitiesByFpIdVaultIntegrityData>) =>
  createQueryKey('postEntitiesByFpIdVaultIntegrity', options);

/**
 * Works for either person or business entities. Checks if provided data is valid before adding it to the vault.
 */
export const postEntitiesByFpIdVaultIntegrityOptions = (options: Options<PostEntitiesByFpIdVaultIntegrityData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdVaultIntegrity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdVaultIntegrityQueryKey(options),
  });
};

/**
 * Works for either person or business entities. Checks if provided data is valid before adding it to the vault.
 */
export const postEntitiesByFpIdVaultIntegrityMutation = (
  options?: Partial<Options<PostEntitiesByFpIdVaultIntegrityData>>,
): UseMutationOptions<
  PostEntitiesByFpIdVaultIntegrityResponse,
  ApiError,
  Options<PostEntitiesByFpIdVaultIntegrityData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdVaultIntegrityResponse,
    ApiError,
    Options<PostEntitiesByFpIdVaultIntegrityData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdVaultIntegrity({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postEntitiesByFpIdVaultValidateQueryKey = (options: Options<PostEntitiesByFpIdVaultValidateData>) =>
  createQueryKey('postEntitiesByFpIdVaultValidate', options);

/**
 * Checks if provided data is valid before adding it to the vault. Returns an HTTP 200 if there are no validation errors, or HTTP 400 with context describing validation errors if any.
 */
export const postEntitiesByFpIdVaultValidateOptions = (options: Options<PostEntitiesByFpIdVaultValidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postEntitiesByFpIdVaultValidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postEntitiesByFpIdVaultValidateQueryKey(options),
  });
};

/**
 * Checks if provided data is valid before adding it to the vault. Returns an HTTP 200 if there are no validation errors, or HTTP 400 with context describing validation errors if any.
 */
export const postEntitiesByFpIdVaultValidateMutation = (
  options?: Partial<Options<PostEntitiesByFpIdVaultValidateData>>,
): UseMutationOptions<
  PostEntitiesByFpIdVaultValidateResponse,
  ApiError,
  Options<PostEntitiesByFpIdVaultValidateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostEntitiesByFpIdVaultValidateResponse,
    ApiError,
    Options<PostEntitiesByFpIdVaultValidateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postEntitiesByFpIdVaultValidate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFailQueryKey = (options?: Options<GetFailData>) => createQueryKey('getFail', options);

export const getFailOptions = (options?: Options<GetFailData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFailQueryKey(options),
  });
};

export const getHeadersQueryKey = (options?: Options<GetHeadersData>) => createQueryKey('getHeaders', options);

export const getHeadersOptions = (options?: Options<GetHeadersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHeaders({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHeadersQueryKey(options),
  });
};

export const getHealthQueryKey = (options?: Options<GetHealthData>) => createQueryKey('getHealth', options);

/**
 * Returns 200 if the API server is running
 */
export const getHealthOptions = (options?: Options<GetHealthData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHealthQueryKey(options),
  });
};

export const getHealthEnclaveQueryKey = (options?: Options<GetHealthEnclaveData>) =>
  createQueryKey('getHealthEnclave', options);

/**
 * Returns enclave health
 */
export const getHealthEnclaveOptions = (options?: Options<GetHealthEnclaveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHealthEnclave({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHealthEnclaveQueryKey(options),
  });
};

export const getHealthEnclaveDecryptQueryKey = (options?: Options<GetHealthEnclaveDecryptData>) =>
  createQueryKey('getHealthEnclaveDecrypt', options);

/**
 * Checks health of enclave decrypt operation
 */
export const getHealthEnclaveDecryptOptions = (options?: Options<GetHealthEnclaveDecryptData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHealthEnclaveDecrypt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHealthEnclaveDecryptQueryKey(options),
  });
};

export const postInvestigationsByInvestigationIdSourcesQueryKey = (
  options: Options<PostInvestigationsByInvestigationIdSourcesData>,
) => createQueryKey('postInvestigationsByInvestigationIdSources', options);

/**
 * Bulk-hydrate the labeled [S#] sources for an investigation and, in the same call, resolve the caller's [S# <locator>] citations against each source's pinned content. Decrypted source data and citation evidence require manual review or decrypt-all permissions. Non-sensitive source handles remain available with tenant read permission. Scoped to the tenant.
 */
export const postInvestigationsByInvestigationIdSourcesOptions = (
  options: Options<PostInvestigationsByInvestigationIdSourcesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postInvestigationsByInvestigationIdSources({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postInvestigationsByInvestigationIdSourcesQueryKey(options),
  });
};

/**
 * Bulk-hydrate the labeled [S#] sources for an investigation and, in the same call, resolve the caller's [S# <locator>] citations against each source's pinned content. Decrypted source data and citation evidence require manual review or decrypt-all permissions. Non-sensitive source handles remain available with tenant read permission. Scoped to the tenant.
 */
export const postInvestigationsByInvestigationIdSourcesMutation = (
  options?: Partial<Options<PostInvestigationsByInvestigationIdSourcesData>>,
): UseMutationOptions<
  PostInvestigationsByInvestigationIdSourcesResponse,
  ApiError,
  Options<PostInvestigationsByInvestigationIdSourcesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostInvestigationsByInvestigationIdSourcesResponse,
    ApiError,
    Options<PostInvestigationsByInvestigationIdSourcesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postInvestigationsByInvestigationIdSources({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgQueryKey = (options?: Options<GetOrgData>) => createQueryKey('getOrg', options);

/**
 * Returns basic info about the authed tenant
 */
export const getOrgOptions = (options?: Options<GetOrgData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrg({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgQueryKey(options),
  });
};

/**
 * Updates the basic information for the tenant
 */
export const patchOrgMutation = (
  options?: Partial<Options<PatchOrgData>>,
): UseMutationOptions<PatchOrgResponse, ApiError, Options<PatchOrgData>> => {
  const mutationOptions: UseMutationOptions<PatchOrgResponse, ApiError, Options<PatchOrgData>> = {
    mutationFn: async localOptions => {
      const { data } = await patchOrg({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAgentsQueryKey = (options?: Options<GetOrgAgentsData>) => createQueryKey('getOrgAgents', options);

/**
 * List agents
 */
export const getOrgAgentsOptions = (options?: Options<GetOrgAgentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsQueryKey(options),
  });
};

export const getOrgAgentsInfiniteQueryKey = (
  options?: Options<GetOrgAgentsData>,
): QueryKey<Options<GetOrgAgentsData>> => createQueryKey('getOrgAgents', options, true);

/**
 * List agents
 */
export const getOrgAgentsInfiniteOptions = (options?: Options<GetOrgAgentsData>) => {
  return infiniteQueryOptions<
    GetOrgAgentsResponse,
    ApiError,
    InfiniteData<GetOrgAgentsResponse>,
    QueryKey<Options<GetOrgAgentsData>>,
    number | Pick<QueryKey<Options<GetOrgAgentsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgAgentsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgAgents({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgAgentsInfiniteQueryKey(options),
    },
  );
};

export const postOrgAgentsBuilderQueryKey = (options: Options<PostOrgAgentsBuilderData>) =>
  createQueryKey('postOrgAgentsBuilder', options);

/**
 * Create a new agent from a template. Use GET /org/agents/{agent_id}/builder to load an existing agent's head into the builder.
 */
export const postOrgAgentsBuilderOptions = (options: Options<PostOrgAgentsBuilderData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsBuilder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsBuilderQueryKey(options),
  });
};

/**
 * Create a new agent from a template. Use GET /org/agents/{agent_id}/builder to load an existing agent's head into the builder.
 */
export const postOrgAgentsBuilderMutation = (
  options?: Partial<Options<PostOrgAgentsBuilderData>>,
): UseMutationOptions<PostOrgAgentsBuilderResponse, ApiError, Options<PostOrgAgentsBuilderData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsBuilderResponse,
    ApiError,
    Options<PostOrgAgentsBuilderData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsBuilder({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsBuilderExplainRulesQueryKey = (options: Options<PostOrgAgentsBuilderExplainRulesData>) =>
  createQueryKey('postOrgAgentsBuilderExplainRules', options);

/**
 * Explain the supplied agent rules in plain language without saving or executing them.
 */
export const postOrgAgentsBuilderExplainRulesOptions = (options: Options<PostOrgAgentsBuilderExplainRulesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsBuilderExplainRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsBuilderExplainRulesQueryKey(options),
  });
};

/**
 * Explain the supplied agent rules in plain language without saving or executing them.
 */
export const postOrgAgentsBuilderExplainRulesMutation = (
  options?: Partial<Options<PostOrgAgentsBuilderExplainRulesData>>,
): UseMutationOptions<
  PostOrgAgentsBuilderExplainRulesResponse,
  ApiError,
  Options<PostOrgAgentsBuilderExplainRulesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsBuilderExplainRulesResponse,
    ApiError,
    Options<PostOrgAgentsBuilderExplainRulesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsBuilderExplainRules({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsBuilderGenerateRulesQueryKey = (options: Options<PostOrgAgentsBuilderGenerateRulesData>) =>
  createQueryKey('postOrgAgentsBuilderGenerateRules', options);

/**
 * Draft rules from an instruction and the fields available before this rules task. Validates the proposal without saving or executing the graph.
 */
export const postOrgAgentsBuilderGenerateRulesOptions = (options: Options<PostOrgAgentsBuilderGenerateRulesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsBuilderGenerateRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsBuilderGenerateRulesQueryKey(options),
  });
};

/**
 * Draft rules from an instruction and the fields available before this rules task. Validates the proposal without saving or executing the graph.
 */
export const postOrgAgentsBuilderGenerateRulesMutation = (
  options?: Partial<Options<PostOrgAgentsBuilderGenerateRulesData>>,
): UseMutationOptions<
  PostOrgAgentsBuilderGenerateRulesResponse,
  ApiError,
  Options<PostOrgAgentsBuilderGenerateRulesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsBuilderGenerateRulesResponse,
    ApiError,
    Options<PostOrgAgentsBuilderGenerateRulesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsBuilderGenerateRules({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAgentsMcpServersQueryKey = (options?: Options<GetOrgAgentsMcpServersData>) =>
  createQueryKey('getOrgAgentsMcpServers', options);

/**
 * Lists the tenant's remote MCP servers, without their header values.
 */
export const getOrgAgentsMcpServersOptions = (options?: Options<GetOrgAgentsMcpServersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsMcpServers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsMcpServersQueryKey(options),
  });
};

export const postOrgAgentsMcpServersQueryKey = (options: Options<PostOrgAgentsMcpServersData>) =>
  createQueryKey('postOrgAgentsMcpServers', options);

/**
 * Saves a remote MCP server the tenant's agents may call. The header value is sealed for Percy and never returned.
 */
export const postOrgAgentsMcpServersOptions = (options: Options<PostOrgAgentsMcpServersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsMcpServers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsMcpServersQueryKey(options),
  });
};

/**
 * Saves a remote MCP server the tenant's agents may call. The header value is sealed for Percy and never returned.
 */
export const postOrgAgentsMcpServersMutation = (
  options?: Partial<Options<PostOrgAgentsMcpServersData>>,
): UseMutationOptions<PostOrgAgentsMcpServersResponse, ApiError, Options<PostOrgAgentsMcpServersData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsMcpServersResponse,
    ApiError,
    Options<PostOrgAgentsMcpServersData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsMcpServers({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsMcpServersOauthCompleteQueryKey = (
  options: Options<PostOrgAgentsMcpServersOauthCompleteData>,
) => createQueryKey('postOrgAgentsMcpServersOauthComplete', options);

/**
 * Completes OAuth authorization with the code the provider sent back and saves the MCP server.
 */
export const postOrgAgentsMcpServersOauthCompleteOptions = (
  options: Options<PostOrgAgentsMcpServersOauthCompleteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsMcpServersOauthComplete({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsMcpServersOauthCompleteQueryKey(options),
  });
};

/**
 * Completes OAuth authorization with the code the provider sent back and saves the MCP server.
 */
export const postOrgAgentsMcpServersOauthCompleteMutation = (
  options?: Partial<Options<PostOrgAgentsMcpServersOauthCompleteData>>,
): UseMutationOptions<
  PostOrgAgentsMcpServersOauthCompleteResponse,
  ApiError,
  Options<PostOrgAgentsMcpServersOauthCompleteData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsMcpServersOauthCompleteResponse,
    ApiError,
    Options<PostOrgAgentsMcpServersOauthCompleteData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsMcpServersOauthComplete({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsMcpServersOauthStartQueryKey = (options: Options<PostOrgAgentsMcpServersOauthStartData>) =>
  createQueryKey('postOrgAgentsMcpServersOauthStart', options);

/**
 * Starts OAuth authorization for a new remote MCP server and returns the URL to send the user to.
 */
export const postOrgAgentsMcpServersOauthStartOptions = (options: Options<PostOrgAgentsMcpServersOauthStartData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsMcpServersOauthStart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsMcpServersOauthStartQueryKey(options),
  });
};

/**
 * Starts OAuth authorization for a new remote MCP server and returns the URL to send the user to.
 */
export const postOrgAgentsMcpServersOauthStartMutation = (
  options?: Partial<Options<PostOrgAgentsMcpServersOauthStartData>>,
): UseMutationOptions<
  PostOrgAgentsMcpServersOauthStartResponse,
  ApiError,
  Options<PostOrgAgentsMcpServersOauthStartData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsMcpServersOauthStartResponse,
    ApiError,
    Options<PostOrgAgentsMcpServersOauthStartData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsMcpServersOauthStart({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Removes a remote MCP server. Agents still referencing it run without it.
 */
export const deleteOrgAgentsMcpServersByServerIdMutation = (
  options?: Partial<Options<DeleteOrgAgentsMcpServersByServerIdData>>,
): UseMutationOptions<
  DeleteOrgAgentsMcpServersByServerIdResponse,
  ApiError,
  Options<DeleteOrgAgentsMcpServersByServerIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgAgentsMcpServersByServerIdResponse,
    ApiError,
    Options<DeleteOrgAgentsMcpServersByServerIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgAgentsMcpServersByServerId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Replaces the sealed header value of a remote MCP server.
 */
export const patchOrgAgentsMcpServersByServerIdMutation = (
  options?: Partial<Options<PatchOrgAgentsMcpServersByServerIdData>>,
): UseMutationOptions<
  PatchOrgAgentsMcpServersByServerIdResponse,
  ApiError,
  Options<PatchOrgAgentsMcpServersByServerIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgAgentsMcpServersByServerIdResponse,
    ApiError,
    Options<PatchOrgAgentsMcpServersByServerIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgAgentsMcpServersByServerId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsMcpServersByServerIdOauthStartQueryKey = (
  options: Options<PostOrgAgentsMcpServersByServerIdOauthStartData>,
) => createQueryKey('postOrgAgentsMcpServersByServerIdOauthStart', options);

/**
 * Starts OAuth authorization again for an existing remote MCP server, keeping its name and URL.
 */
export const postOrgAgentsMcpServersByServerIdOauthStartOptions = (
  options: Options<PostOrgAgentsMcpServersByServerIdOauthStartData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsMcpServersByServerIdOauthStart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsMcpServersByServerIdOauthStartQueryKey(options),
  });
};

/**
 * Starts OAuth authorization again for an existing remote MCP server, keeping its name and URL.
 */
export const postOrgAgentsMcpServersByServerIdOauthStartMutation = (
  options?: Partial<Options<PostOrgAgentsMcpServersByServerIdOauthStartData>>,
): UseMutationOptions<
  PostOrgAgentsMcpServersByServerIdOauthStartResponse,
  ApiError,
  Options<PostOrgAgentsMcpServersByServerIdOauthStartData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsMcpServersByServerIdOauthStartResponse,
    ApiError,
    Options<PostOrgAgentsMcpServersByServerIdOauthStartData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsMcpServersByServerIdOauthStart({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAgentsMetricsQueryKey = (options?: Options<GetOrgAgentsMetricsData>) =>
  createQueryKey('getOrgAgentsMetrics', options);

/**
 * Returns aggregate metrics for agent executions. Defaults to 24h timeframes for metrics
 */
export const getOrgAgentsMetricsOptions = (options?: Options<GetOrgAgentsMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsMetricsQueryKey(options),
  });
};

export const getOrgAgentsRunsByWorkflowIdQueryKey = (options: Options<GetOrgAgentsRunsByWorkflowIdData>) =>
  createQueryKey('getOrgAgentsRunsByWorkflowId', options);

/**
 * Get status for an agent run, keyed by the workflow id returned from the run API
 */
export const getOrgAgentsRunsByWorkflowIdOptions = (options: Options<GetOrgAgentsRunsByWorkflowIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsRunsByWorkflowId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsRunsByWorkflowIdQueryKey(options),
  });
};

export const getOrgAgentsTaskCatalogQueryKey = (options?: Options<GetOrgAgentsTaskCatalogData>) =>
  createQueryKey('getOrgAgentsTaskCatalog', options);

/**
 * List the task templates that can be added to an agent as plain, editable tasks
 */
export const getOrgAgentsTaskCatalogOptions = (options?: Options<GetOrgAgentsTaskCatalogData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsTaskCatalog({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsTaskCatalogQueryKey(options),
  });
};

export const getOrgAgentsTemplatesQueryKey = (options?: Options<GetOrgAgentsTemplatesData>) =>
  createQueryKey('getOrgAgentsTemplates', options);

/**
 * List the agent templates that can be built, and what each one builds
 */
export const getOrgAgentsTemplatesOptions = (options?: Options<GetOrgAgentsTemplatesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsTemplatesQueryKey(options),
  });
};

export const getOrgAgentsToolsQueryKey = (options?: Options<GetOrgAgentsToolsData>) =>
  createQueryKey('getOrgAgentsTools', options);

/**
 * List available tools for agents
 */
export const getOrgAgentsToolsOptions = (options?: Options<GetOrgAgentsToolsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsTools({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsToolsQueryKey(options),
  });
};

export const getOrgAgentsByAgentIdQueryKey = (options: Options<GetOrgAgentsByAgentIdData>) =>
  createQueryKey('getOrgAgentsByAgentId', options);

/**
 * Get a single agent by ID
 */
export const getOrgAgentsByAgentIdOptions = (options: Options<GetOrgAgentsByAgentIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsByAgentId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsByAgentIdQueryKey(options),
  });
};

/**
 * Update an agent's metadata
 */
export const patchOrgAgentsByAgentIdMutation = (
  options?: Partial<Options<PatchOrgAgentsByAgentIdData>>,
): UseMutationOptions<PatchOrgAgentsByAgentIdResponse, ApiError, Options<PatchOrgAgentsByAgentIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgAgentsByAgentIdResponse,
    ApiError,
    Options<PatchOrgAgentsByAgentIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgAgentsByAgentId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAgentsByAgentIdBuilderQueryKey = (options: Options<GetOrgAgentsByAgentIdBuilderData>) =>
  createQueryKey('getOrgAgentsByAgentIdBuilder', options);

/**
 * Get the current head of an agent's builder graph, or a specific historical version if `version_id` is provided.
 */
export const getOrgAgentsByAgentIdBuilderOptions = (options: Options<GetOrgAgentsByAgentIdBuilderData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsByAgentIdBuilder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsByAgentIdBuilderQueryKey(options),
  });
};

/**
 * Apply a single mutation (add / update / remove / reorder a node, or update norms) to the head agent version graph. Creates a new immutable agent_version row and advances the head pointer.
 */
export const patchOrgAgentsByAgentIdBuilderMutation = (
  options?: Partial<Options<PatchOrgAgentsByAgentIdBuilderData>>,
): UseMutationOptions<
  PatchOrgAgentsByAgentIdBuilderResponse,
  ApiError,
  Options<PatchOrgAgentsByAgentIdBuilderData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgAgentsByAgentIdBuilderResponse,
    ApiError,
    Options<PatchOrgAgentsByAgentIdBuilderData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgAgentsByAgentIdBuilder({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsByAgentIdBuilderPublishQueryKey = (
  options: Options<PostOrgAgentsByAgentIdBuilderPublishData>,
) => createQueryKey('postOrgAgentsByAgentIdBuilderPublish', options);

/**
 * Publish the current head agent version by tagging it with a semver. The new tag must be strictly greater than the agent's most recently published version_tag.
 */
export const postOrgAgentsByAgentIdBuilderPublishOptions = (
  options: Options<PostOrgAgentsByAgentIdBuilderPublishData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsByAgentIdBuilderPublish({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsByAgentIdBuilderPublishQueryKey(options),
  });
};

/**
 * Publish the current head agent version by tagging it with a semver. The new tag must be strictly greater than the agent's most recently published version_tag.
 */
export const postOrgAgentsByAgentIdBuilderPublishMutation = (
  options?: Partial<Options<PostOrgAgentsByAgentIdBuilderPublishData>>,
): UseMutationOptions<
  PostOrgAgentsByAgentIdBuilderPublishResponse,
  ApiError,
  Options<PostOrgAgentsByAgentIdBuilderPublishData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsByAgentIdBuilderPublishResponse,
    ApiError,
    Options<PostOrgAgentsByAgentIdBuilderPublishData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsByAgentIdBuilderPublish({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsByAgentIdBuilderRestoreQueryKey = (
  options: Options<PostOrgAgentsByAgentIdBuilderRestoreData>,
) => createQueryKey('postOrgAgentsByAgentIdBuilderRestore', options);

/**
 * Restore the agent builder to a target version. If the target is an ancestor of the head the head pointer moves back (undo); if it's in the future chain it moves forward (redo); otherwise a new version is created at the head carrying the target's graph. Undoing past a published version is rejected.
 */
export const postOrgAgentsByAgentIdBuilderRestoreOptions = (
  options: Options<PostOrgAgentsByAgentIdBuilderRestoreData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsByAgentIdBuilderRestore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsByAgentIdBuilderRestoreQueryKey(options),
  });
};

/**
 * Restore the agent builder to a target version. If the target is an ancestor of the head the head pointer moves back (undo); if it's in the future chain it moves forward (redo); otherwise a new version is created at the head carrying the target's graph. Undoing past a published version is rejected.
 */
export const postOrgAgentsByAgentIdBuilderRestoreMutation = (
  options?: Partial<Options<PostOrgAgentsByAgentIdBuilderRestoreData>>,
): UseMutationOptions<
  PostOrgAgentsByAgentIdBuilderRestoreResponse,
  ApiError,
  Options<PostOrgAgentsByAgentIdBuilderRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsByAgentIdBuilderRestoreResponse,
    ApiError,
    Options<PostOrgAgentsByAgentIdBuilderRestoreData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsByAgentIdBuilderRestore({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsByAgentIdBuilderSuggestionsAcceptQueryKey = (
  options: Options<PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData>,
) => createQueryKey('postOrgAgentsByAgentIdBuilderSuggestionsAccept', options);

/**
 * Accept a batch of pending Percy suggestions in one transaction: apply each proposed operation to the head agent version's graph in request order, writing one immutable agent_version row per accepted suggestion. The whole batch fails if any suggestion can't be applied — nothing is accepted unless every suggestion applies cleanly.
 */
export const postOrgAgentsByAgentIdBuilderSuggestionsAcceptOptions = (
  options: Options<PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsByAgentIdBuilderSuggestionsAccept({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsByAgentIdBuilderSuggestionsAcceptQueryKey(options),
  });
};

/**
 * Accept a batch of pending Percy suggestions in one transaction: apply each proposed operation to the head agent version's graph in request order, writing one immutable agent_version row per accepted suggestion. The whole batch fails if any suggestion can't be applied — nothing is accepted unless every suggestion applies cleanly.
 */
export const postOrgAgentsByAgentIdBuilderSuggestionsAcceptMutation = (
  options?: Partial<Options<PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData>>,
): UseMutationOptions<
  PostOrgAgentsByAgentIdBuilderSuggestionsAcceptResponse,
  ApiError,
  Options<PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsByAgentIdBuilderSuggestionsAcceptResponse,
    ApiError,
    Options<PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsByAgentIdBuilderSuggestionsAccept({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAgentsByAgentIdBuilderSuggestionsRejectQueryKey = (
  options: Options<PostOrgAgentsByAgentIdBuilderSuggestionsRejectData>,
) => createQueryKey('postOrgAgentsByAgentIdBuilderSuggestionsReject', options);

/**
 * Reject a batch of pending Percy suggestions in one transaction. Flips each suggestion row to `Rejected`; ids that are no longer pending are skipped. Does not touch the head graph.
 */
export const postOrgAgentsByAgentIdBuilderSuggestionsRejectOptions = (
  options: Options<PostOrgAgentsByAgentIdBuilderSuggestionsRejectData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsByAgentIdBuilderSuggestionsReject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsByAgentIdBuilderSuggestionsRejectQueryKey(options),
  });
};

/**
 * Reject a batch of pending Percy suggestions in one transaction. Flips each suggestion row to `Rejected`; ids that are no longer pending are skipped. Does not touch the head graph.
 */
export const postOrgAgentsByAgentIdBuilderSuggestionsRejectMutation = (
  options?: Partial<Options<PostOrgAgentsByAgentIdBuilderSuggestionsRejectData>>,
): UseMutationOptions<
  PostOrgAgentsByAgentIdBuilderSuggestionsRejectResponse,
  ApiError,
  Options<PostOrgAgentsByAgentIdBuilderSuggestionsRejectData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsByAgentIdBuilderSuggestionsRejectResponse,
    ApiError,
    Options<PostOrgAgentsByAgentIdBuilderSuggestionsRejectData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsByAgentIdBuilderSuggestionsReject({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAgentsByAgentIdHistoryQueryKey = (options: Options<GetOrgAgentsByAgentIdHistoryData>) =>
  createQueryKey('getOrgAgentsByAgentIdHistory', options);

/**
 * Paginated chain-walk of an agent's version history. The first page starts from the agent's most recently created version (the tip of the latest edit chain, even if the head currently sits on an older version due to undo) and walks backward via `base_version_id` pointers. Each item carries the operation that produced the version, the actor, timestamp, version tag, and whether the version was created from an AI suggestion.
 */
export const getOrgAgentsByAgentIdHistoryOptions = (options: Options<GetOrgAgentsByAgentIdHistoryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsByAgentIdHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsByAgentIdHistoryQueryKey(options),
  });
};

export const getOrgAgentsByAgentIdHistoryInfiniteQueryKey = (
  options: Options<GetOrgAgentsByAgentIdHistoryData>,
): QueryKey<Options<GetOrgAgentsByAgentIdHistoryData>> => createQueryKey('getOrgAgentsByAgentIdHistory', options, true);

/**
 * Paginated chain-walk of an agent's version history. The first page starts from the agent's most recently created version (the tip of the latest edit chain, even if the head currently sits on an older version due to undo) and walks backward via `base_version_id` pointers. Each item carries the operation that produced the version, the actor, timestamp, version tag, and whether the version was created from an AI suggestion.
 */
export const getOrgAgentsByAgentIdHistoryInfiniteOptions = (options: Options<GetOrgAgentsByAgentIdHistoryData>) => {
  return infiniteQueryOptions<
    GetOrgAgentsByAgentIdHistoryResponse,
    ApiError,
    InfiniteData<GetOrgAgentsByAgentIdHistoryResponse>,
    QueryKey<Options<GetOrgAgentsByAgentIdHistoryData>>,
    string | Pick<QueryKey<Options<GetOrgAgentsByAgentIdHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetOrgAgentsByAgentIdHistoryData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgAgentsByAgentIdHistory({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgAgentsByAgentIdHistoryInfiniteQueryKey(options),
    },
  );
};

export const getOrgAgentsByAgentIdReleasesQueryKey = (options: Options<GetOrgAgentsByAgentIdReleasesData>) =>
  createQueryKey('getOrgAgentsByAgentIdReleases', options);

/**
 * Paginated list of an agent's released versions — every row with a `version_tag` set, newest first. Returns the same `AgentVersionHistoryItem` shape as the history endpoint.
 */
export const getOrgAgentsByAgentIdReleasesOptions = (options: Options<GetOrgAgentsByAgentIdReleasesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsByAgentIdReleases({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsByAgentIdReleasesQueryKey(options),
  });
};

export const getOrgAgentsByAgentIdReleasesInfiniteQueryKey = (
  options: Options<GetOrgAgentsByAgentIdReleasesData>,
): QueryKey<Options<GetOrgAgentsByAgentIdReleasesData>> =>
  createQueryKey('getOrgAgentsByAgentIdReleases', options, true);

/**
 * Paginated list of an agent's released versions — every row with a `version_tag` set, newest first. Returns the same `AgentVersionHistoryItem` shape as the history endpoint.
 */
export const getOrgAgentsByAgentIdReleasesInfiniteOptions = (options: Options<GetOrgAgentsByAgentIdReleasesData>) => {
  return infiniteQueryOptions<
    GetOrgAgentsByAgentIdReleasesResponse,
    ApiError,
    InfiniteData<GetOrgAgentsByAgentIdReleasesResponse>,
    QueryKey<Options<GetOrgAgentsByAgentIdReleasesData>>,
    number | Pick<QueryKey<Options<GetOrgAgentsByAgentIdReleasesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetOrgAgentsByAgentIdReleasesData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgAgentsByAgentIdReleases({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgAgentsByAgentIdReleasesInfiniteQueryKey(options),
    },
  );
};

export const postOrgAgentsByAgentIdRunQueryKey = (options: Options<PostOrgAgentsByAgentIdRunData>) =>
  createQueryKey('postOrgAgentsByAgentIdRun', options);

/**
 * Run a configured agent on an entity's investigation workflow.
 */
export const postOrgAgentsByAgentIdRunOptions = (options: Options<PostOrgAgentsByAgentIdRunData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAgentsByAgentIdRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAgentsByAgentIdRunQueryKey(options),
  });
};

/**
 * Run a configured agent on an entity's investigation workflow.
 */
export const postOrgAgentsByAgentIdRunMutation = (
  options?: Partial<Options<PostOrgAgentsByAgentIdRunData>>,
): UseMutationOptions<PostOrgAgentsByAgentIdRunResponse, ApiError, Options<PostOrgAgentsByAgentIdRunData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAgentsByAgentIdRunResponse,
    ApiError,
    Options<PostOrgAgentsByAgentIdRunData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAgentsByAgentIdRun({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAgentsByAgentIdSummaryQueryKey = (options: Options<GetOrgAgentsByAgentIdSummaryData>) =>
  createQueryKey('getOrgAgentsByAgentIdSummary', options);

/**
 * Describe what an agent does — its steps, the data it needs, the rules it applies and what it returns — for its latest published release.
 */
export const getOrgAgentsByAgentIdSummaryOptions = (options: Options<GetOrgAgentsByAgentIdSummaryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAgentsByAgentIdSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAgentsByAgentIdSummaryQueryKey(options),
  });
};

export const getOrgApiKeysQueryKey = (options?: Options<GetOrgApiKeysData>) => createQueryKey('getOrgApiKeys', options);

/**
 * Lists the tenant's secret API keys
 */
export const getOrgApiKeysOptions = (options?: Options<GetOrgApiKeysData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgApiKeys({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgApiKeysQueryKey(options),
  });
};

export const getOrgApiKeysInfiniteQueryKey = (
  options?: Options<GetOrgApiKeysData>,
): QueryKey<Options<GetOrgApiKeysData>> => createQueryKey('getOrgApiKeys', options, true);

/**
 * Lists the tenant's secret API keys
 */
export const getOrgApiKeysInfiniteOptions = (options?: Options<GetOrgApiKeysData>) => {
  return infiniteQueryOptions<
    GetOrgApiKeysResponse,
    ApiError,
    InfiniteData<GetOrgApiKeysResponse>,
    QueryKey<Options<GetOrgApiKeysData>>,
    number | Pick<QueryKey<Options<GetOrgApiKeysData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgApiKeysData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgApiKeys({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgApiKeysInfiniteQueryKey(options),
    },
  );
};

export const postOrgApiKeysQueryKey = (options: Options<PostOrgApiKeysData>) =>
  createQueryKey('postOrgApiKeys', options);

/**
 * Generates a new secret tenant api key.
 */
export const postOrgApiKeysOptions = (options: Options<PostOrgApiKeysData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgApiKeys({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgApiKeysQueryKey(options),
  });
};

/**
 * Generates a new secret tenant api key.
 */
export const postOrgApiKeysMutation = (
  options?: Partial<Options<PostOrgApiKeysData>>,
): UseMutationOptions<PostOrgApiKeysResponse, ApiError, Options<PostOrgApiKeysData>> => {
  const mutationOptions: UseMutationOptions<PostOrgApiKeysResponse, ApiError, Options<PostOrgApiKeysData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgApiKeys({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates an existing secret tenant api key.
 */
export const patchOrgApiKeysByIdMutation = (
  options?: Partial<Options<PatchOrgApiKeysByIdData>>,
): UseMutationOptions<PatchOrgApiKeysByIdResponse, ApiError, Options<PatchOrgApiKeysByIdData>> => {
  const mutationOptions: UseMutationOptions<PatchOrgApiKeysByIdResponse, ApiError, Options<PatchOrgApiKeysByIdData>> = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgApiKeysById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgApiKeysByIdDeactivateQueryKey = (options: Options<PostOrgApiKeysByIdDeactivateData>) =>
  createQueryKey('postOrgApiKeysByIdDeactivate', options);

/**
 * Permanently deactivates an existing tenant API key.
 */
export const postOrgApiKeysByIdDeactivateOptions = (options: Options<PostOrgApiKeysByIdDeactivateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgApiKeysByIdDeactivate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgApiKeysByIdDeactivateQueryKey(options),
  });
};

/**
 * Permanently deactivates an existing tenant API key.
 */
export const postOrgApiKeysByIdDeactivateMutation = (
  options?: Partial<Options<PostOrgApiKeysByIdDeactivateData>>,
): UseMutationOptions<PostOrgApiKeysByIdDeactivateResponse, ApiError, Options<PostOrgApiKeysByIdDeactivateData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgApiKeysByIdDeactivateResponse,
    ApiError,
    Options<PostOrgApiKeysByIdDeactivateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgApiKeysByIdDeactivate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgApiKeysByIdRevealQueryKey = (options: Options<PostOrgApiKeysByIdRevealData>) =>
  createQueryKey('postOrgApiKeysByIdReveal', options);

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific tenant secret API key.
 */
export const postOrgApiKeysByIdRevealOptions = (options: Options<PostOrgApiKeysByIdRevealData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgApiKeysByIdReveal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgApiKeysByIdRevealQueryKey(options),
  });
};

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific tenant secret API key.
 */
export const postOrgApiKeysByIdRevealMutation = (
  options?: Partial<Options<PostOrgApiKeysByIdRevealData>>,
): UseMutationOptions<PostOrgApiKeysByIdRevealResponse, ApiError, Options<PostOrgApiKeysByIdRevealData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgApiKeysByIdRevealResponse,
    ApiError,
    Options<PostOrgApiKeysByIdRevealData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgApiKeysByIdReveal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAppMetaAndroidQueryKey = (options?: Options<GetOrgAppMetaAndroidData>) =>
  createQueryKey('getOrgAppMetaAndroid', options);

/**
 * Returns a list of metadata for tenant Android apps.
 */
export const getOrgAppMetaAndroidOptions = (options?: Options<GetOrgAppMetaAndroidData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAppMetaAndroid({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAppMetaAndroidQueryKey(options),
  });
};

export const postOrgAppMetaAndroidQueryKey = (options: Options<PostOrgAppMetaAndroidData>) =>
  createQueryKey('postOrgAppMetaAndroid', options);

/**
 * Creates a tenant Android app metadata entry for the organization.
 */
export const postOrgAppMetaAndroidOptions = (options: Options<PostOrgAppMetaAndroidData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAppMetaAndroid({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAppMetaAndroidQueryKey(options),
  });
};

/**
 * Creates a tenant Android app metadata entry for the organization.
 */
export const postOrgAppMetaAndroidMutation = (
  options?: Partial<Options<PostOrgAppMetaAndroidData>>,
): UseMutationOptions<PostOrgAppMetaAndroidResponse, ApiError, Options<PostOrgAppMetaAndroidData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAppMetaAndroidResponse,
    ApiError,
    Options<PostOrgAppMetaAndroidData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAppMetaAndroid({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a tenant android app metadata for the organization.
 */
export const deleteOrgAppMetaAndroidByMetaIdMutation = (
  options?: Partial<Options<DeleteOrgAppMetaAndroidByMetaIdData>>,
): UseMutationOptions<
  DeleteOrgAppMetaAndroidByMetaIdResponse,
  ApiError,
  Options<DeleteOrgAppMetaAndroidByMetaIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgAppMetaAndroidByMetaIdResponse,
    ApiError,
    Options<DeleteOrgAppMetaAndroidByMetaIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgAppMetaAndroidByMetaId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates the provided tenant android app metadata
 */
export const patchOrgAppMetaAndroidByMetaIdMutation = (
  options?: Partial<Options<PatchOrgAppMetaAndroidByMetaIdData>>,
): UseMutationOptions<
  PatchOrgAppMetaAndroidByMetaIdResponse,
  ApiError,
  Options<PatchOrgAppMetaAndroidByMetaIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgAppMetaAndroidByMetaIdResponse,
    ApiError,
    Options<PatchOrgAppMetaAndroidByMetaIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgAppMetaAndroidByMetaId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAppMetaAndroidByMetaIdRevealQueryKey = (
  options: Options<PostOrgAppMetaAndroidByMetaIdRevealData>,
) => createQueryKey('postOrgAppMetaAndroidByMetaIdReveal', options);

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific android app metadata entry
 */
export const postOrgAppMetaAndroidByMetaIdRevealOptions = (
  options: Options<PostOrgAppMetaAndroidByMetaIdRevealData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAppMetaAndroidByMetaIdReveal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAppMetaAndroidByMetaIdRevealQueryKey(options),
  });
};

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific android app metadata entry
 */
export const postOrgAppMetaAndroidByMetaIdRevealMutation = (
  options?: Partial<Options<PostOrgAppMetaAndroidByMetaIdRevealData>>,
): UseMutationOptions<
  PostOrgAppMetaAndroidByMetaIdRevealResponse,
  ApiError,
  Options<PostOrgAppMetaAndroidByMetaIdRevealData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAppMetaAndroidByMetaIdRevealResponse,
    ApiError,
    Options<PostOrgAppMetaAndroidByMetaIdRevealData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAppMetaAndroidByMetaIdReveal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAppMetaIosQueryKey = (options?: Options<GetOrgAppMetaIosData>) =>
  createQueryKey('getOrgAppMetaIos', options);

/**
 * Returns a list of metadata for tenant ios apps.
 */
export const getOrgAppMetaIosOptions = (options?: Options<GetOrgAppMetaIosData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAppMetaIos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAppMetaIosQueryKey(options),
  });
};

export const postOrgAppMetaIosQueryKey = (options: Options<PostOrgAppMetaIosData>) =>
  createQueryKey('postOrgAppMetaIos', options);

/**
 * Creates a tenant ios app metadata entry for the organization.
 */
export const postOrgAppMetaIosOptions = (options: Options<PostOrgAppMetaIosData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAppMetaIos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAppMetaIosQueryKey(options),
  });
};

/**
 * Creates a tenant ios app metadata entry for the organization.
 */
export const postOrgAppMetaIosMutation = (
  options?: Partial<Options<PostOrgAppMetaIosData>>,
): UseMutationOptions<PostOrgAppMetaIosResponse, ApiError, Options<PostOrgAppMetaIosData>> => {
  const mutationOptions: UseMutationOptions<PostOrgAppMetaIosResponse, ApiError, Options<PostOrgAppMetaIosData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAppMetaIos({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a tenant iOS app metadata for the organization.
 */
export const deleteOrgAppMetaIosByMetaIdMutation = (
  options?: Partial<Options<DeleteOrgAppMetaIosByMetaIdData>>,
): UseMutationOptions<DeleteOrgAppMetaIosByMetaIdResponse, ApiError, Options<DeleteOrgAppMetaIosByMetaIdData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgAppMetaIosByMetaIdResponse,
    ApiError,
    Options<DeleteOrgAppMetaIosByMetaIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgAppMetaIosByMetaId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates the provided tenant ios app metadata
 */
export const patchOrgAppMetaIosByMetaIdMutation = (
  options?: Partial<Options<PatchOrgAppMetaIosByMetaIdData>>,
): UseMutationOptions<PatchOrgAppMetaIosByMetaIdResponse, ApiError, Options<PatchOrgAppMetaIosByMetaIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgAppMetaIosByMetaIdResponse,
    ApiError,
    Options<PatchOrgAppMetaIosByMetaIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgAppMetaIosByMetaId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAppMetaIosByMetaIdRevealQueryKey = (options: Options<PostOrgAppMetaIosByMetaIdRevealData>) =>
  createQueryKey('postOrgAppMetaIosByMetaIdReveal', options);

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific ios app metadata entry
 */
export const postOrgAppMetaIosByMetaIdRevealOptions = (options: Options<PostOrgAppMetaIosByMetaIdRevealData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAppMetaIosByMetaIdReveal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAppMetaIosByMetaIdRevealQueryKey(options),
  });
};

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific ios app metadata entry
 */
export const postOrgAppMetaIosByMetaIdRevealMutation = (
  options?: Partial<Options<PostOrgAppMetaIosByMetaIdRevealData>>,
): UseMutationOptions<
  PostOrgAppMetaIosByMetaIdRevealResponse,
  ApiError,
  Options<PostOrgAppMetaIosByMetaIdRevealData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAppMetaIosByMetaIdRevealResponse,
    ApiError,
    Options<PostOrgAppMetaIosByMetaIdRevealData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAppMetaIosByMetaIdReveal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAppearencesQueryKey = (options?: Options<GetOrgAppearencesData>) =>
  createQueryKey('getOrgAppearences', options);

/**
 * Get a list of appearences for a tenant
 */
export const getOrgAppearencesOptions = (options?: Options<GetOrgAppearencesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAppearences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAppearencesQueryKey(options),
  });
};

export const getOrgAppearencesInfiniteQueryKey = (
  options?: Options<GetOrgAppearencesData>,
): QueryKey<Options<GetOrgAppearencesData>> => createQueryKey('getOrgAppearences', options, true);

/**
 * Get a list of appearences for a tenant
 */
export const getOrgAppearencesInfiniteOptions = (options?: Options<GetOrgAppearencesData>) => {
  return infiniteQueryOptions<
    GetOrgAppearencesResponse,
    ApiError,
    InfiniteData<GetOrgAppearencesResponse>,
    QueryKey<Options<GetOrgAppearencesData>>,
    string | Pick<QueryKey<Options<GetOrgAppearencesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgAppearencesData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgAppearences({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgAppearencesInfiniteQueryKey(options),
    },
  );
};

export const postOrgAppearencesQueryKey = (options: Options<PostOrgAppearencesData>) =>
  createQueryKey('postOrgAppearences', options);

/**
 * Create a new appearance for a tenant
 */
export const postOrgAppearencesOptions = (options: Options<PostOrgAppearencesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAppearences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAppearencesQueryKey(options),
  });
};

/**
 * Create a new appearance for a tenant
 */
export const postOrgAppearencesMutation = (
  options?: Partial<Options<PostOrgAppearencesData>>,
): UseMutationOptions<PostOrgAppearencesResponse, ApiError, Options<PostOrgAppearencesData>> => {
  const mutationOptions: UseMutationOptions<PostOrgAppearencesResponse, ApiError, Options<PostOrgAppearencesData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAppearences({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAppearencesByAppearanceIdQueryKey = (options: Options<GetOrgAppearencesByAppearanceIdData>) =>
  createQueryKey('getOrgAppearencesByAppearanceId', options);

/**
 * Get an appearance for a tenant
 */
export const getOrgAppearencesByAppearanceIdOptions = (options: Options<GetOrgAppearencesByAppearanceIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAppearencesByAppearanceId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAppearencesByAppearanceIdQueryKey(options),
  });
};

/**
 * Update an appearance for a tenant
 */
export const patchOrgAppearencesByAppearanceIdMutation = (
  options?: Partial<Options<PatchOrgAppearencesByAppearanceIdData>>,
): UseMutationOptions<
  PatchOrgAppearencesByAppearanceIdResponse,
  ApiError,
  Options<PatchOrgAppearencesByAppearanceIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgAppearencesByAppearanceIdResponse,
    ApiError,
    Options<PatchOrgAppearencesByAppearanceIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgAppearencesByAppearanceId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a new logo for the appearance.
 */
export const putOrgAppearencesByAppearanceIdLogoMutation = (
  options?: Partial<Options<PutOrgAppearencesByAppearanceIdLogoData>>,
): UseMutationOptions<
  PutOrgAppearencesByAppearanceIdLogoResponse,
  ApiError,
  Options<PutOrgAppearencesByAppearanceIdLogoData>
> => {
  const mutationOptions: UseMutationOptions<
    PutOrgAppearencesByAppearanceIdLogoResponse,
    ApiError,
    Options<PutOrgAppearencesByAppearanceIdLogoData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await putOrgAppearencesByAppearanceIdLogo({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAppearencesByAppearanceIdProposalQueryKey = (
  options: Options<PostOrgAppearencesByAppearanceIdProposalData>,
) => createQueryKey('postOrgAppearencesByAppearanceIdProposal', options);

/**
 * Append a batch of operations to the appearance's pending proposal without applying it.
 */
export const postOrgAppearencesByAppearanceIdProposalOptions = (
  options: Options<PostOrgAppearencesByAppearanceIdProposalData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAppearencesByAppearanceIdProposal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAppearencesByAppearanceIdProposalQueryKey(options),
  });
};

/**
 * Append a batch of operations to the appearance's pending proposal without applying it.
 */
export const postOrgAppearencesByAppearanceIdProposalMutation = (
  options?: Partial<Options<PostOrgAppearencesByAppearanceIdProposalData>>,
): UseMutationOptions<
  PostOrgAppearencesByAppearanceIdProposalResponse,
  ApiError,
  Options<PostOrgAppearencesByAppearanceIdProposalData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAppearencesByAppearanceIdProposalResponse,
    ApiError,
    Options<PostOrgAppearencesByAppearanceIdProposalData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAppearencesByAppearanceIdProposal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgArtifactsQueryKey = (options?: Options<GetOrgArtifactsData>) =>
  createQueryKey('getOrgArtifacts', options);

/**
 * List a tenant's artifacts, newest first. Optionally narrow by investigation_id.
 */
export const getOrgArtifactsOptions = (options?: Options<GetOrgArtifactsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgArtifacts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgArtifactsQueryKey(options),
  });
};

export const getOrgArtifactsInfiniteQueryKey = (
  options?: Options<GetOrgArtifactsData>,
): QueryKey<Options<GetOrgArtifactsData>> => createQueryKey('getOrgArtifacts', options, true);

/**
 * List a tenant's artifacts, newest first. Optionally narrow by investigation_id.
 */
export const getOrgArtifactsInfiniteOptions = (options?: Options<GetOrgArtifactsData>) => {
  return infiniteQueryOptions<
    GetOrgArtifactsResponse,
    ApiError,
    InfiniteData<GetOrgArtifactsResponse>,
    QueryKey<Options<GetOrgArtifactsData>>,
    number | Pick<QueryKey<Options<GetOrgArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgArtifacts({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgArtifactsInfiniteQueryKey(options),
    },
  );
};

export const postOrgArtifactsQueryKey = (options: Options<PostOrgArtifactsData>) =>
  createQueryKey('postOrgArtifacts', options);

/**
 * Create a new artifact (writes version 1). Multipart upload with a `metadata` JSON part and a `file` binary part.
 */
export const postOrgArtifactsOptions = (options: Options<PostOrgArtifactsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgArtifacts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgArtifactsQueryKey(options),
  });
};

/**
 * Create a new artifact (writes version 1). Multipart upload with a `metadata` JSON part and a `file` binary part.
 */
export const postOrgArtifactsMutation = (
  options?: Partial<Options<PostOrgArtifactsData>>,
): UseMutationOptions<PostOrgArtifactsResponse, ApiError, Options<PostOrgArtifactsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgArtifactsResponse, ApiError, Options<PostOrgArtifactsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgArtifacts({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Deactivate an artifact. The artifact will no longer appear in list or get queries.
 */
export const deleteOrgArtifactsByArtifactIdMutation = (
  options?: Partial<Options<DeleteOrgArtifactsByArtifactIdData>>,
): UseMutationOptions<
  DeleteOrgArtifactsByArtifactIdResponse,
  ApiError,
  Options<DeleteOrgArtifactsByArtifactIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgArtifactsByArtifactIdResponse,
    ApiError,
    Options<DeleteOrgArtifactsByArtifactIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgArtifactsByArtifactId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgArtifactsByArtifactIdQueryKey = (options: Options<GetOrgArtifactsByArtifactIdData>) =>
  createQueryKey('getOrgArtifactsByArtifactId', options);

/**
 * Stream the raw decrypted bytes of an artifact's latest version. `Content-Type` is the artifact's stored mime_type. `X-Artifact-Version-Id` identifies the version whose bytes are returned Additional metadata is available via `GET /org/artifacts` and `GET /org/artifacts/{id}/versions`.
 */
export const getOrgArtifactsByArtifactIdOptions = (options: Options<GetOrgArtifactsByArtifactIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgArtifactsByArtifactId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgArtifactsByArtifactIdQueryKey(options),
  });
};

/**
 * Update artifact metadata. Currently only supports renaming the artifact.
 */
export const patchOrgArtifactsByArtifactIdMutation = (
  options?: Partial<Options<PatchOrgArtifactsByArtifactIdData>>,
): UseMutationOptions<PatchOrgArtifactsByArtifactIdResponse, ApiError, Options<PatchOrgArtifactsByArtifactIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgArtifactsByArtifactIdResponse,
    ApiError,
    Options<PatchOrgArtifactsByArtifactIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgArtifactsByArtifactId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgArtifactsByArtifactIdVersionsQueryKey = (
  options: Options<GetOrgArtifactsByArtifactIdVersionsData>,
) => createQueryKey('getOrgArtifactsByArtifactIdVersions', options);

/**
 * List versions of an artifact (oldest first), without decrypting content. Offset-paginated.
 */
export const getOrgArtifactsByArtifactIdVersionsOptions = (
  options: Options<GetOrgArtifactsByArtifactIdVersionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgArtifactsByArtifactIdVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgArtifactsByArtifactIdVersionsQueryKey(options),
  });
};

export const getOrgArtifactsByArtifactIdVersionsInfiniteQueryKey = (
  options: Options<GetOrgArtifactsByArtifactIdVersionsData>,
): QueryKey<Options<GetOrgArtifactsByArtifactIdVersionsData>> =>
  createQueryKey('getOrgArtifactsByArtifactIdVersions', options, true);

/**
 * List versions of an artifact (oldest first), without decrypting content. Offset-paginated.
 */
export const getOrgArtifactsByArtifactIdVersionsInfiniteOptions = (
  options: Options<GetOrgArtifactsByArtifactIdVersionsData>,
) => {
  return infiniteQueryOptions<
    GetOrgArtifactsByArtifactIdVersionsResponse,
    ApiError,
    InfiniteData<GetOrgArtifactsByArtifactIdVersionsResponse>,
    QueryKey<Options<GetOrgArtifactsByArtifactIdVersionsData>>,
    number | Pick<QueryKey<Options<GetOrgArtifactsByArtifactIdVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetOrgArtifactsByArtifactIdVersionsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgArtifactsByArtifactIdVersions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgArtifactsByArtifactIdVersionsInfiniteQueryKey(options),
    },
  );
};

export const postOrgArtifactsByArtifactIdVersionsQueryKey = (
  options: Options<PostOrgArtifactsByArtifactIdVersionsData>,
) => createQueryKey('postOrgArtifactsByArtifactIdVersions', options);

/**
 * Create a new version of an existing artifact. Multipart upload with a `metadata` JSON part and a `file` binary part. The artifact's mime_type is fixed at create time and cannot be changed here.
 */
export const postOrgArtifactsByArtifactIdVersionsOptions = (
  options: Options<PostOrgArtifactsByArtifactIdVersionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgArtifactsByArtifactIdVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgArtifactsByArtifactIdVersionsQueryKey(options),
  });
};

/**
 * Create a new version of an existing artifact. Multipart upload with a `metadata` JSON part and a `file` binary part. The artifact's mime_type is fixed at create time and cannot be changed here.
 */
export const postOrgArtifactsByArtifactIdVersionsMutation = (
  options?: Partial<Options<PostOrgArtifactsByArtifactIdVersionsData>>,
): UseMutationOptions<
  PostOrgArtifactsByArtifactIdVersionsResponse,
  ApiError,
  Options<PostOrgArtifactsByArtifactIdVersionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgArtifactsByArtifactIdVersionsResponse,
    ApiError,
    Options<PostOrgArtifactsByArtifactIdVersionsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgArtifactsByArtifactIdVersions({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgArtifactsByArtifactIdVersionsByVersionIdQueryKey = (
  options: Options<GetOrgArtifactsByArtifactIdVersionsByVersionIdData>,
) => createQueryKey('getOrgArtifactsByArtifactIdVersionsByVersionId', options);

/**
 * Stream the raw decrypted bytes of a specific artifact version. `Content-Type` is the parent artifact's stored mime_type. `X-Artifact-Version-Id` echoes the version_id whose bytes are returned  Version metadata is available via `GET /org/artifacts/{id}/versions`.
 */
export const getOrgArtifactsByArtifactIdVersionsByVersionIdOptions = (
  options: Options<GetOrgArtifactsByArtifactIdVersionsByVersionIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgArtifactsByArtifactIdVersionsByVersionId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgArtifactsByArtifactIdVersionsByVersionIdQueryKey(options),
  });
};

export const getOrgAuditEventsQueryKey = (options?: Options<GetOrgAuditEventsData>) =>
  createQueryKey('getOrgAuditEvents', options);

/**
 * Query audit events, in descending order of timestamp.
 */
export const getOrgAuditEventsOptions = (options?: Options<GetOrgAuditEventsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAuditEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAuditEventsQueryKey(options),
  });
};

export const getOrgAuditEventsInfiniteQueryKey = (
  options?: Options<GetOrgAuditEventsData>,
): QueryKey<Options<GetOrgAuditEventsData>> => createQueryKey('getOrgAuditEvents', options, true);

/**
 * Query audit events, in descending order of timestamp.
 */
export const getOrgAuditEventsInfiniteOptions = (options?: Options<GetOrgAuditEventsData>) => {
  return infiniteQueryOptions<
    GetOrgAuditEventsResponse,
    ApiError,
    InfiniteData<GetOrgAuditEventsResponse>,
    QueryKey<Options<GetOrgAuditEventsData>>,
    string | Pick<QueryKey<Options<GetOrgAuditEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgAuditEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgAuditEvents({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgAuditEventsInfiniteQueryKey(options),
    },
  );
};

export const postOrgAuthAssumeRoleQueryKey = (options: Options<PostOrgAuthAssumeRoleData>) =>
  createQueryKey('postOrgAuthAssumeRole', options);

/**
 * After the user has proven they own an email address, allow them to assume an
 * auth role for any tenant to which the email address has access.
 */
export const postOrgAuthAssumeRoleOptions = (options: Options<PostOrgAuthAssumeRoleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAuthAssumeRole({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAuthAssumeRoleQueryKey(options),
  });
};

/**
 * After the user has proven they own an email address, allow them to assume an
 * auth role for any tenant to which the email address has access.
 */
export const postOrgAuthAssumeRoleMutation = (
  options?: Partial<Options<PostOrgAuthAssumeRoleData>>,
): UseMutationOptions<PostOrgAuthAssumeRoleResponse, ApiError, Options<PostOrgAuthAssumeRoleData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAuthAssumeRoleResponse,
    ApiError,
    Options<PostOrgAuthAssumeRoleData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAuthAssumeRole({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAuthDocsTokenQueryKey = (options?: Options<PostOrgAuthDocsTokenData>) =>
  createQueryKey('postOrgAuthDocsToken', options);

/**
 * Create a token scoped for use on the docs site
 */
export const postOrgAuthDocsTokenOptions = (options?: Options<PostOrgAuthDocsTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAuthDocsToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAuthDocsTokenQueryKey(options),
  });
};

/**
 * Create a token scoped for use on the docs site
 */
export const postOrgAuthDocsTokenMutation = (
  options?: Partial<Options<PostOrgAuthDocsTokenData>>,
): UseMutationOptions<PostOrgAuthDocsTokenResponse, ApiError, Options<PostOrgAuthDocsTokenData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAuthDocsTokenResponse,
    ApiError,
    Options<PostOrgAuthDocsTokenData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAuthDocsToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAuthGoogleOauthQueryKey = (options: Options<GetOrgAuthGoogleOauthData>) =>
  createQueryKey('getOrgAuthGoogleOauth', options);

/**
 * Request to authenticate via Google OAuth.
 */
export const getOrgAuthGoogleOauthOptions = (options: Options<GetOrgAuthGoogleOauthData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAuthGoogleOauth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAuthGoogleOauthQueryKey(options),
  });
};

export const postOrgAuthLoginQueryKey = (options: Options<PostOrgAuthLoginData>) =>
  createQueryKey('postOrgAuthLogin', options);

/**
 * Called from the front-end with the WorkOS code. Returns the authorization token needed for future requests as well as user information
 */
export const postOrgAuthLoginOptions = (options: Options<PostOrgAuthLoginData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAuthLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAuthLoginQueryKey(options),
  });
};

/**
 * Called from the front-end with the WorkOS code. Returns the authorization token needed for future requests as well as user information
 */
export const postOrgAuthLoginMutation = (
  options?: Partial<Options<PostOrgAuthLoginData>>,
): UseMutationOptions<PostOrgAuthLoginResponse, ApiError, Options<PostOrgAuthLoginData>> => {
  const mutationOptions: UseMutationOptions<PostOrgAuthLoginResponse, ApiError, Options<PostOrgAuthLoginData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAuthLogin({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAuthLogoutQueryKey = (options?: Options<PostOrgAuthLogoutData>) =>
  createQueryKey('postOrgAuthLogout', options);

/**
 * Logs out the authenticated principal and invalidates the session
 */
export const postOrgAuthLogoutOptions = (options?: Options<PostOrgAuthLogoutData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAuthLogout({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAuthLogoutQueryKey(options),
  });
};

/**
 * Logs out the authenticated principal and invalidates the session
 */
export const postOrgAuthLogoutMutation = (
  options?: Partial<Options<PostOrgAuthLogoutData>>,
): UseMutationOptions<PostOrgAuthLogoutResponse, ApiError, Options<PostOrgAuthLogoutData>> => {
  const mutationOptions: UseMutationOptions<PostOrgAuthLogoutResponse, ApiError, Options<PostOrgAuthLogoutData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAuthLogout({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAuthMagicLinkQueryKey = (options: Options<PostOrgAuthMagicLinkData>) =>
  createQueryKey('postOrgAuthMagicLink', options);

/**
 * Request to authenticate a user email. WorkOS will send the email a link to login. Once the user clicks the magic link, WorkOs will call the /workos/callback endpoint, at which point we authenticate the user
 */
export const postOrgAuthMagicLinkOptions = (options: Options<PostOrgAuthMagicLinkData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAuthMagicLink({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAuthMagicLinkQueryKey(options),
  });
};

/**
 * Request to authenticate a user email. WorkOS will send the email a link to login. Once the user clicks the magic link, WorkOs will call the /workos/callback endpoint, at which point we authenticate the user
 */
export const postOrgAuthMagicLinkMutation = (
  options?: Partial<Options<PostOrgAuthMagicLinkData>>,
): UseMutationOptions<PostOrgAuthMagicLinkResponse, ApiError, Options<PostOrgAuthMagicLinkData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAuthMagicLinkResponse,
    ApiError,
    Options<PostOrgAuthMagicLinkData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAuthMagicLink({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgAuthMcpCompleteQueryKey = (options: Options<PostOrgAuthMcpCompleteData>) =>
  createQueryKey('postOrgAuthMcpComplete', options);

/**
 * Complete WorkOS MCP authorization for the signed-in membership
 */
export const postOrgAuthMcpCompleteOptions = (options: Options<PostOrgAuthMcpCompleteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAuthMcpComplete({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAuthMcpCompleteQueryKey(options),
  });
};

/**
 * Complete WorkOS MCP authorization for the signed-in membership
 */
export const postOrgAuthMcpCompleteMutation = (
  options?: Partial<Options<PostOrgAuthMcpCompleteData>>,
): UseMutationOptions<PostOrgAuthMcpCompleteResponse, ApiError, Options<PostOrgAuthMcpCompleteData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgAuthMcpCompleteResponse,
    ApiError,
    Options<PostOrgAuthMcpCompleteData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAuthMcpComplete({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgAuthRolesQueryKey = (options?: Options<GetOrgAuthRolesData>) =>
  createQueryKey('getOrgAuthRoles', options);

/**
 * Return the list of tenants that can be inherited by the authed user
 */
export const getOrgAuthRolesOptions = (options?: Options<GetOrgAuthRolesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgAuthRoles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgAuthRolesQueryKey(options),
  });
};

export const postOrgAuthSamlSsoQueryKey = (options: Options<PostOrgAuthSamlSsoData>) =>
  createQueryKey('postOrgAuthSamlSso', options);

/**
 * Fetch the SAML SSO URL for a given email address.
 */
export const postOrgAuthSamlSsoOptions = (options: Options<PostOrgAuthSamlSsoData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgAuthSamlSso({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgAuthSamlSsoQueryKey(options),
  });
};

/**
 * Fetch the SAML SSO URL for a given email address.
 */
export const postOrgAuthSamlSsoMutation = (
  options?: Partial<Options<PostOrgAuthSamlSsoData>>,
): UseMutationOptions<PostOrgAuthSamlSsoResponse, ApiError, Options<PostOrgAuthSamlSsoData>> => {
  const mutationOptions: UseMutationOptions<PostOrgAuthSamlSsoResponse, ApiError, Options<PostOrgAuthSamlSsoData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgAuthSamlSso({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgBoardThreadsQueryKey = (options?: Options<GetOrgBoardThreadsData>) =>
  createQueryKey('getOrgBoardThreads', options);

/**
 * Every message-board thread for the tenant with its comments, newest thread first. Closed threads are included with deactivated_at set. Risk ops firm employees only.
 */
export const getOrgBoardThreadsOptions = (options?: Options<GetOrgBoardThreadsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgBoardThreads({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgBoardThreadsQueryKey(options),
  });
};

export const postOrgBoardThreadsByThreadIdDeactivateQueryKey = (
  options: Options<PostOrgBoardThreadsByThreadIdDeactivateData>,
) => createQueryKey('postOrgBoardThreadsByThreadIdDeactivate', options);

/**
 * Closes a message-board thread so agents stop commenting on it. The thread stays readable with deactivated_at set. Risk ops firm employees only.
 */
export const postOrgBoardThreadsByThreadIdDeactivateOptions = (
  options: Options<PostOrgBoardThreadsByThreadIdDeactivateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgBoardThreadsByThreadIdDeactivate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgBoardThreadsByThreadIdDeactivateQueryKey(options),
  });
};

/**
 * Closes a message-board thread so agents stop commenting on it. The thread stays readable with deactivated_at set. Risk ops firm employees only.
 */
export const postOrgBoardThreadsByThreadIdDeactivateMutation = (
  options?: Partial<Options<PostOrgBoardThreadsByThreadIdDeactivateData>>,
): UseMutationOptions<
  PostOrgBoardThreadsByThreadIdDeactivateResponse,
  ApiError,
  Options<PostOrgBoardThreadsByThreadIdDeactivateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgBoardThreadsByThreadIdDeactivateResponse,
    ApiError,
    Options<PostOrgBoardThreadsByThreadIdDeactivateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgBoardThreadsByThreadIdDeactivate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgClientSecurityConfigQueryKey = (options?: Options<GetOrgClientSecurityConfigData>) =>
  createQueryKey('getOrgClientSecurityConfig', options);

/**
 * Get the client security configuration.
 */
export const getOrgClientSecurityConfigOptions = (options?: Options<GetOrgClientSecurityConfigData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgClientSecurityConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgClientSecurityConfigQueryKey(options),
  });
};

/**
 * Update the client security configuration.
 */
export const patchOrgClientSecurityConfigMutation = (
  options?: Partial<Options<PatchOrgClientSecurityConfigData>>,
): UseMutationOptions<PatchOrgClientSecurityConfigResponse, ApiError, Options<PatchOrgClientSecurityConfigData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgClientSecurityConfigResponse,
    ApiError,
    Options<PatchOrgClientSecurityConfigData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgClientSecurityConfig({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgCredentialsQueryKey = (options?: Options<GetOrgCredentialsData>) =>
  createQueryKey('getOrgCredentials', options);

/**
 * Lists the credentials the caller may use: an agent's when `agent_id` is given (or the token belongs to an autopilot run), otherwise the caller's own.
 */
export const getOrgCredentialsOptions = (options?: Options<GetOrgCredentialsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgCredentials({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgCredentialsQueryKey(options),
  });
};

export const postOrgCredentialsQueryKey = (options: Options<PostOrgCredentialsData>) =>
  createQueryKey('postOrgCredentials', options);

/**
 * Saves a login Percy may use in a browser. The secret fields are sealed for the Percy sandbox and never returned to the dashboard.
 */
export const postOrgCredentialsOptions = (options: Options<PostOrgCredentialsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgCredentials({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgCredentialsQueryKey(options),
  });
};

/**
 * Saves a login Percy may use in a browser. The secret fields are sealed for the Percy sandbox and never returned to the dashboard.
 */
export const postOrgCredentialsMutation = (
  options?: Partial<Options<PostOrgCredentialsData>>,
): UseMutationOptions<PostOrgCredentialsResponse, ApiError, Options<PostOrgCredentialsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgCredentialsResponse, ApiError, Options<PostOrgCredentialsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgCredentials({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revokes a credential. Only the user who saved it may revoke it; anyone else gets not found.
 */
export const deleteOrgCredentialsByCredentialIdMutation = (
  options?: Partial<Options<DeleteOrgCredentialsByCredentialIdData>>,
): UseMutationOptions<
  DeleteOrgCredentialsByCredentialIdResponse,
  ApiError,
  Options<DeleteOrgCredentialsByCredentialIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgCredentialsByCredentialIdResponse,
    ApiError,
    Options<DeleteOrgCredentialsByCredentialIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgCredentialsByCredentialId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgCredentialsByCredentialIdDecryptQueryKey = (
  options: Options<PostOrgCredentialsByCredentialIdDecryptData>,
) => createQueryKey('postOrgCredentialsByCredentialIdDecrypt', options);

/**
 * Unseals a credential for the Percy sandbox. Copilot sessions may unseal the credentials their user saved; autopilot runs may unseal the credentials shared with their agent. Anything else is not found.
 */
export const postOrgCredentialsByCredentialIdDecryptOptions = (
  options: Options<PostOrgCredentialsByCredentialIdDecryptData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgCredentialsByCredentialIdDecrypt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgCredentialsByCredentialIdDecryptQueryKey(options),
  });
};

/**
 * Unseals a credential for the Percy sandbox. Copilot sessions may unseal the credentials their user saved; autopilot runs may unseal the credentials shared with their agent. Anything else is not found.
 */
export const postOrgCredentialsByCredentialIdDecryptMutation = (
  options?: Partial<Options<PostOrgCredentialsByCredentialIdDecryptData>>,
): UseMutationOptions<
  PostOrgCredentialsByCredentialIdDecryptResponse,
  ApiError,
  Options<PostOrgCredentialsByCredentialIdDecryptData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgCredentialsByCredentialIdDecryptResponse,
    ApiError,
    Options<PostOrgCredentialsByCredentialIdDecryptData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgCredentialsByCredentialIdDecrypt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgEntityStatusesQueryKey = (options?: Options<GetOrgEntityStatusesData>) =>
  createQueryKey('getOrgEntityStatuses', options);

/**
 * List all active entity statuses for the organization, optionally filtered by entity type and deactivated statuses
 */
export const getOrgEntityStatusesOptions = (options?: Options<GetOrgEntityStatusesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgEntityStatuses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgEntityStatusesQueryKey(options),
  });
};

export const getOrgEntityStatusesByIdQueryKey = (options: Options<GetOrgEntityStatusesByIdData>) =>
  createQueryKey('getOrgEntityStatusesById', options);

/**
 * Get a single entity status by ID, including deactivated statuses
 */
export const getOrgEntityStatusesByIdOptions = (options: Options<GetOrgEntityStatusesByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgEntityStatusesById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgEntityStatusesByIdQueryKey(options),
  });
};

/**
 * Deactivate (soft-delete) an entity status
 */
export const deleteOrgEntityStatusesBySlugMutation = (
  options?: Partial<Options<DeleteOrgEntityStatusesBySlugData>>,
): UseMutationOptions<DeleteOrgEntityStatusesBySlugResponse, ApiError, Options<DeleteOrgEntityStatusesBySlugData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgEntityStatusesBySlugResponse,
    ApiError,
    Options<DeleteOrgEntityStatusesBySlugData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgEntityStatusesBySlug({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update an entity status and/or its entries
 */
export const patchOrgEntityStatusesBySlugMutation = (
  options?: Partial<Options<PatchOrgEntityStatusesBySlugData>>,
): UseMutationOptions<PatchOrgEntityStatusesBySlugResponse, ApiError, Options<PatchOrgEntityStatusesBySlugData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgEntityStatusesBySlugResponse,
    ApiError,
    Options<PatchOrgEntityStatusesBySlugData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgEntityStatusesBySlug({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgFootprintWrappedQueryKey = (options?: Options<GetOrgFootprintWrappedData>) =>
  createQueryKey('getOrgFootprintWrapped', options);

/**
 * Lists the footprint wrapped metrics for a tenant.
 */
export const getOrgFootprintWrappedOptions = (options?: Options<GetOrgFootprintWrappedData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgFootprintWrapped({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgFootprintWrappedQueryKey(options),
  });
};

export const getOrgFrequentNotesQueryKey = (options: Options<GetOrgFrequentNotesData>) =>
  createQueryKey('getOrgFrequentNotes', options);

/**
 * Returns a list of frequent notes for the organization.
 */
export const getOrgFrequentNotesOptions = (options: Options<GetOrgFrequentNotesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgFrequentNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgFrequentNotesQueryKey(options),
  });
};

export const postOrgFrequentNotesQueryKey = (options: Options<PostOrgFrequentNotesData>) =>
  createQueryKey('postOrgFrequentNotes', options);

/**
 * Creates a new frequent note for the organization.
 */
export const postOrgFrequentNotesOptions = (options: Options<PostOrgFrequentNotesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgFrequentNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgFrequentNotesQueryKey(options),
  });
};

/**
 * Creates a new frequent note for the organization.
 */
export const postOrgFrequentNotesMutation = (
  options?: Partial<Options<PostOrgFrequentNotesData>>,
): UseMutationOptions<PostOrgFrequentNotesResponse, ApiError, Options<PostOrgFrequentNotesData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgFrequentNotesResponse,
    ApiError,
    Options<PostOrgFrequentNotesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgFrequentNotes({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a frequent note for the organization.
 */
export const deleteOrgFrequentNotesByFrequentNoteIdMutation = (
  options?: Partial<Options<DeleteOrgFrequentNotesByFrequentNoteIdData>>,
): UseMutationOptions<
  DeleteOrgFrequentNotesByFrequentNoteIdResponse,
  ApiError,
  Options<DeleteOrgFrequentNotesByFrequentNoteIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgFrequentNotesByFrequentNoteIdResponse,
    ApiError,
    Options<DeleteOrgFrequentNotesByFrequentNoteIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgFrequentNotesByFrequentNoteId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgGraphsByGraphIdNodesByNodeIdContextQueryKey = (
  options: Options<GetOrgGraphsByGraphIdNodesByNodeIdContextData>,
) => createQueryKey('getOrgGraphsByGraphIdNodesByNodeIdContext', options);

/**
 * Returns the context for a specific node in a graph to help render the node's drawer.
 */
export const getOrgGraphsByGraphIdNodesByNodeIdContextOptions = (
  options: Options<GetOrgGraphsByGraphIdNodesByNodeIdContextData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgGraphsByGraphIdNodesByNodeIdContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgGraphsByGraphIdNodesByNodeIdContextQueryKey(options),
  });
};

export const postOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsQueryKey = (
  options: Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData>,
) => createQueryKey('postOrgGraphsByGraphIdNodesByNodeIdValidateExpressions', options);

/**
 * Compile the given CEL programs against a node's position in the graph, returning the type each one resolves to. Lets the dashboard show an expression's type before it has been saved.
 */
export const postOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsOptions = (
  options: Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgGraphsByGraphIdNodesByNodeIdValidateExpressions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsQueryKey(options),
  });
};

/**
 * Compile the given CEL programs against a node's position in the graph, returning the type each one resolves to. Lets the dashboard show an expression's type before it has been saved.
 */
export const postOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsMutation = (
  options?: Partial<Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData>>,
): UseMutationOptions<
  PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsResponse,
  ApiError,
  Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsResponse,
    ApiError,
    Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgGraphsByGraphIdNodesByNodeIdValidateExpressions({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgGraphsByGraphIdNodesByNodeIdValidateRulesQueryKey = (
  options: Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData>,
) => createQueryKey('postOrgGraphsByGraphIdNodesByNodeIdValidateRules', options);

/**
 * Validate a rule for a given conditional node
 */
export const postOrgGraphsByGraphIdNodesByNodeIdValidateRulesOptions = (
  options: Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgGraphsByGraphIdNodesByNodeIdValidateRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgGraphsByGraphIdNodesByNodeIdValidateRulesQueryKey(options),
  });
};

/**
 * Validate a rule for a given conditional node
 */
export const postOrgGraphsByGraphIdNodesByNodeIdValidateRulesMutation = (
  options?: Partial<Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData>>,
): UseMutationOptions<
  PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesResponse,
  ApiError,
  Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesResponse,
    ApiError,
    Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgGraphsByGraphIdNodesByNodeIdValidateRules({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgGraphsByGraphIdSearchQueryKey = (options: Options<GetOrgGraphsByGraphIdSearchData>) =>
  createQueryKey('getOrgGraphsByGraphIdSearch', options);

/**
 * Returns a list of node_ids and searchable strings
 */
export const getOrgGraphsByGraphIdSearchOptions = (options: Options<GetOrgGraphsByGraphIdSearchData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgGraphsByGraphIdSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgGraphsByGraphIdSearchQueryKey(options),
  });
};

export const postOrgInvestigationsSearchQueryKey = (options?: Options<PostOrgInvestigationsSearchData>) =>
  createQueryKey('postOrgInvestigationsSearch', options);

/**
 * Query investigations (onboardings), in descending order of creation time.
 */
export const postOrgInvestigationsSearchOptions = (options?: Options<PostOrgInvestigationsSearchData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgInvestigationsSearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgInvestigationsSearchQueryKey(options),
  });
};

/**
 * Query investigations (onboardings), in descending order of creation time.
 */
export const postOrgInvestigationsSearchMutation = (
  options?: Partial<Options<PostOrgInvestigationsSearchData>>,
): UseMutationOptions<PostOrgInvestigationsSearchResponse, ApiError, Options<PostOrgInvestigationsSearchData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgInvestigationsSearchResponse,
    ApiError,
    Options<PostOrgInvestigationsSearchData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgInvestigationsSearch({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgInvestigationsByIdQueryKey = (options: Options<GetOrgInvestigationsByIdData>) =>
  createQueryKey('getOrgInvestigationsById', options);

/**
 * Get a single investigation by investigation ID.
 */
export const getOrgInvestigationsByIdOptions = (options: Options<GetOrgInvestigationsByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgInvestigationsById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgInvestigationsByIdQueryKey(options),
  });
};

export const getOrgInvestigationsByIdTraceQueryKey = (options: Options<GetOrgInvestigationsByIdTraceData>) =>
  createQueryKey('getOrgInvestigationsByIdTrace', options);

/**
 * For an investigation created by an agent run, returns the agent version's graph nodes, each with the completion timestamps and result of the latest trace entry for that node. Entries are empty when the investigation has no agent run.
 */
export const getOrgInvestigationsByIdTraceOptions = (options: Options<GetOrgInvestigationsByIdTraceData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgInvestigationsByIdTrace({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgInvestigationsByIdTraceQueryKey(options),
  });
};

export const getOrgInvoicePreviewQueryKey = (options?: Options<GetOrgInvoicePreviewData>) =>
  createQueryKey('getOrgInvoicePreview', options);

/**
 * Returns a preview of the in-progress invoice for the month, if exists
 */
export const getOrgInvoicePreviewOptions = (options?: Options<GetOrgInvoicePreviewData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgInvoicePreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgInvoicePreviewQueryKey(options),
  });
};

export const getOrgListsQueryKey = (options?: Options<GetOrgListsData>) => createQueryKey('getOrgLists', options);

/**
 * Retrieves all Lists for the Tenant
 */
export const getOrgListsOptions = (options?: Options<GetOrgListsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgLists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgListsQueryKey(options),
  });
};

export const getOrgListsInfiniteQueryKey = (options?: Options<GetOrgListsData>): QueryKey<Options<GetOrgListsData>> =>
  createQueryKey('getOrgLists', options, true);

/**
 * Retrieves all Lists for the Tenant
 */
export const getOrgListsInfiniteOptions = (options?: Options<GetOrgListsData>) => {
  return infiniteQueryOptions<
    GetOrgListsResponse,
    ApiError,
    InfiniteData<GetOrgListsResponse>,
    QueryKey<Options<GetOrgListsData>>,
    number | Pick<QueryKey<Options<GetOrgListsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgListsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgLists({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgListsInfiniteQueryKey(options),
    },
  );
};

export const postOrgListsQueryKey = (options: Options<PostOrgListsData>) => createQueryKey('postOrgLists', options);

/**
 * Creates a new List
 */
export const postOrgListsOptions = (options: Options<PostOrgListsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgLists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgListsQueryKey(options),
  });
};

/**
 * Creates a new List
 */
export const postOrgListsMutation = (
  options?: Partial<Options<PostOrgListsData>>,
): UseMutationOptions<PostOrgListsResponse, ApiError, Options<PostOrgListsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgListsResponse, ApiError, Options<PostOrgListsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgLists({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgListsByIdTimelineQueryKey = (options: Options<GetOrgListsByIdTimelineData>) =>
  createQueryKey('getOrgListsByIdTimeline', options);

/**
 * Returns events for a List.
 */
export const getOrgListsByIdTimelineOptions = (options: Options<GetOrgListsByIdTimelineData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgListsByIdTimeline({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgListsByIdTimelineQueryKey(options),
  });
};

export const getOrgListsByIdTimelineInfiniteQueryKey = (
  options: Options<GetOrgListsByIdTimelineData>,
): QueryKey<Options<GetOrgListsByIdTimelineData>> => createQueryKey('getOrgListsByIdTimeline', options, true);

/**
 * Returns events for a List.
 */
export const getOrgListsByIdTimelineInfiniteOptions = (options: Options<GetOrgListsByIdTimelineData>) => {
  return infiniteQueryOptions<
    GetOrgListsByIdTimelineResponse,
    ApiError,
    InfiniteData<GetOrgListsByIdTimelineResponse>,
    QueryKey<Options<GetOrgListsByIdTimelineData>>,
    string | Pick<QueryKey<Options<GetOrgListsByIdTimelineData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgListsByIdTimelineData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgListsByIdTimeline({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgListsByIdTimelineInfiniteQueryKey(options),
    },
  );
};

/**
 * Delete the List
 */
export const deleteOrgListsByListIdMutation = (
  options?: Partial<Options<DeleteOrgListsByListIdData>>,
): UseMutationOptions<DeleteOrgListsByListIdResponse, ApiError, Options<DeleteOrgListsByListIdData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgListsByListIdResponse,
    ApiError,
    Options<DeleteOrgListsByListIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgListsByListId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgListsByListIdQueryKey = (options: Options<GetOrgListsByListIdData>) =>
  createQueryKey('getOrgListsByListId', options);

/**
 * Returns a blocklist.
 */
export const getOrgListsByListIdOptions = (options: Options<GetOrgListsByListIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgListsByListId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgListsByListIdQueryKey(options),
  });
};

/**
 * Updates an existing list
 */
export const patchOrgListsByListIdMutation = (
  options?: Partial<Options<PatchOrgListsByListIdData>>,
): UseMutationOptions<PatchOrgListsByListIdResponse, ApiError, Options<PatchOrgListsByListIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgListsByListIdResponse,
    ApiError,
    Options<PatchOrgListsByListIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgListsByListId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgListsByListIdEntriesQueryKey = (options: Options<GetOrgListsByListIdEntriesData>) =>
  createQueryKey('getOrgListsByListIdEntries', options);

/**
 * Retrieves all entries of a list
 */
export const getOrgListsByListIdEntriesOptions = (options: Options<GetOrgListsByListIdEntriesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgListsByListIdEntries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgListsByListIdEntriesQueryKey(options),
  });
};

export const postOrgListsByListIdEntriesQueryKey = (options: Options<PostOrgListsByListIdEntriesData>) =>
  createQueryKey('postOrgListsByListIdEntries', options);

/**
 * Creates a new list entry
 */
export const postOrgListsByListIdEntriesOptions = (options: Options<PostOrgListsByListIdEntriesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgListsByListIdEntries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgListsByListIdEntriesQueryKey(options),
  });
};

/**
 * Creates a new list entry
 */
export const postOrgListsByListIdEntriesMutation = (
  options?: Partial<Options<PostOrgListsByListIdEntriesData>>,
): UseMutationOptions<PostOrgListsByListIdEntriesResponse, ApiError, Options<PostOrgListsByListIdEntriesData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgListsByListIdEntriesResponse,
    ApiError,
    Options<PostOrgListsByListIdEntriesData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgListsByListIdEntries({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete the List
 */
export const deleteOrgListsByListIdEntriesByListEntryIdMutation = (
  options?: Partial<Options<DeleteOrgListsByListIdEntriesByListEntryIdData>>,
): UseMutationOptions<
  DeleteOrgListsByListIdEntriesByListEntryIdResponse,
  ApiError,
  Options<DeleteOrgListsByListIdEntriesByListEntryIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgListsByListIdEntriesByListEntryIdResponse,
    ApiError,
    Options<DeleteOrgListsByListIdEntriesByListEntryIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgListsByListIdEntriesByListEntryId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a new logo for the organization.
 */
export const putOrgLogoMutation = (
  options?: Partial<Options<PutOrgLogoData>>,
): UseMutationOptions<PutOrgLogoResponse, ApiError, Options<PutOrgLogoData>> => {
  const mutationOptions: UseMutationOptions<PutOrgLogoResponse, ApiError, Options<PutOrgLogoData>> = {
    mutationFn: async localOptions => {
      const { data } = await putOrgLogo({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgMemberQueryKey = (options?: Options<GetOrgMemberData>) => createQueryKey('getOrgMember', options);

/**
 * Returns info on the authed user.
 */
export const getOrgMemberOptions = (options?: Options<GetOrgMemberData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgMember({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgMemberQueryKey(options),
  });
};

/**
 * Updates the authed user.
 */
export const patchOrgMemberMutation = (
  options?: Partial<Options<PatchOrgMemberData>>,
): UseMutationOptions<PatchOrgMemberResponse, ApiError, Options<PatchOrgMemberData>> => {
  const mutationOptions: UseMutationOptions<PatchOrgMemberResponse, ApiError, Options<PatchOrgMemberData>> = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgMember({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgMemberInProgressOnboardingsQueryKey = (options: Options<GetOrgMemberInProgressOnboardingsData>) =>
  createQueryKey('getOrgMemberInProgressOnboardings', options);

/**
 * Returns the list of in-progress KYC/KYB onboardings for the email associated with the logged-in dashboard user.
 */
export const getOrgMemberInProgressOnboardingsOptions = (options: Options<GetOrgMemberInProgressOnboardingsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgMemberInProgressOnboardings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgMemberInProgressOnboardingsQueryKey(options),
  });
};

export const getOrgMembersQueryKey = (options?: Options<GetOrgMembersData>) => createQueryKey('getOrgMembers', options);

/**
 * Returns a list of dashboard members for the tenant
 */
export const getOrgMembersOptions = (options?: Options<GetOrgMembersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgMembersQueryKey(options),
  });
};

export const getOrgMembersInfiniteQueryKey = (
  options?: Options<GetOrgMembersData>,
): QueryKey<Options<GetOrgMembersData>> => createQueryKey('getOrgMembers', options, true);

/**
 * Returns a list of dashboard members for the tenant
 */
export const getOrgMembersInfiniteOptions = (options?: Options<GetOrgMembersData>) => {
  return infiniteQueryOptions<
    GetOrgMembersResponse,
    ApiError,
    InfiniteData<GetOrgMembersResponse>,
    QueryKey<Options<GetOrgMembersData>>,
    number | Pick<QueryKey<Options<GetOrgMembersData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgMembersData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgMembers({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgMembersInfiniteQueryKey(options),
    },
  );
};

export const postOrgMembersQueryKey = (options: Options<PostOrgMembersData>) =>
  createQueryKey('postOrgMembers', options);

/**
 * Create a new IAM user for the tenant. Sends an invite link via WorkOs
 */
export const postOrgMembersOptions = (options: Options<PostOrgMembersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgMembersQueryKey(options),
  });
};

/**
 * Create a new IAM user for the tenant. Sends an invite link via WorkOs
 */
export const postOrgMembersMutation = (
  options?: Partial<Options<PostOrgMembersData>>,
): UseMutationOptions<PostOrgMembersResponse, ApiError, Options<PostOrgMembersData>> => {
  const mutationOptions: UseMutationOptions<PostOrgMembersResponse, ApiError, Options<PostOrgMembersData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgMembers({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates the provided member.
 */
export const patchOrgMembersByTenantUserIdMutation = (
  options?: Partial<Options<PatchOrgMembersByTenantUserIdData>>,
): UseMutationOptions<PatchOrgMembersByTenantUserIdResponse, ApiError, Options<PatchOrgMembersByTenantUserIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgMembersByTenantUserIdResponse,
    ApiError,
    Options<PatchOrgMembersByTenantUserIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgMembersByTenantUserId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgMembersByTenantUserIdDeactivateQueryKey = (
  options: Options<PostOrgMembersByTenantUserIdDeactivateData>,
) => createQueryKey('postOrgMembersByTenantUserIdDeactivate', options);

/**
 * Deactivates the provided user.
 */
export const postOrgMembersByTenantUserIdDeactivateOptions = (
  options: Options<PostOrgMembersByTenantUserIdDeactivateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgMembersByTenantUserIdDeactivate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgMembersByTenantUserIdDeactivateQueryKey(options),
  });
};

/**
 * Deactivates the provided user.
 */
export const postOrgMembersByTenantUserIdDeactivateMutation = (
  options?: Partial<Options<PostOrgMembersByTenantUserIdDeactivateData>>,
): UseMutationOptions<
  PostOrgMembersByTenantUserIdDeactivateResponse,
  ApiError,
  Options<PostOrgMembersByTenantUserIdDeactivateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgMembersByTenantUserIdDeactivateResponse,
    ApiError,
    Options<PostOrgMembersByTenantUserIdDeactivateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgMembersByTenantUserIdDeactivate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgMetricsQueryKey = (options?: Options<GetOrgMetricsData>) => createQueryKey('getOrgMetrics', options);

/**
 * Returns metrics to display on the dashboard home page.
 */
export const getOrgMetricsOptions = (options?: Options<GetOrgMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgMetricsQueryKey(options),
  });
};

export const postOrgOnboardingSessionQueryKey = (options: Options<PostOrgOnboardingSessionData>) =>
  createQueryKey('postOrgOnboardingSession', options);

export const postOrgOnboardingSessionOptions = (options: Options<PostOrgOnboardingSessionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgOnboardingSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgOnboardingSessionQueryKey(options),
  });
};

export const postOrgOnboardingSessionMutation = (
  options?: Partial<Options<PostOrgOnboardingSessionData>>,
): UseMutationOptions<PostOrgOnboardingSessionResponse, ApiError, Options<PostOrgOnboardingSessionData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgOnboardingSessionResponse,
    ApiError,
    Options<PostOrgOnboardingSessionData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgOnboardingSession({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgOnboardingSessionValidateQueryKey = (options: Options<PostOrgOnboardingSessionValidateData>) =>
  createQueryKey('postOrgOnboardingSessionValidate', options);

/**
 * After a user finishes an interactive Footprint onboarding flow through one of our SDKs, your application will be given a validation token. This API allows you to exchange that short-lived validation token for the long-lived `fp_id` of the user who finished the flow. This also returns some information about the flow that the user has completed.
 */
export const postOrgOnboardingSessionValidateOptions = (options: Options<PostOrgOnboardingSessionValidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgOnboardingSessionValidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgOnboardingSessionValidateQueryKey(options),
  });
};

/**
 * After a user finishes an interactive Footprint onboarding flow through one of our SDKs, your application will be given a validation token. This API allows you to exchange that short-lived validation token for the long-lived `fp_id` of the user who finished the flow. This also returns some information about the flow that the user has completed.
 */
export const postOrgOnboardingSessionValidateMutation = (
  options?: Partial<Options<PostOrgOnboardingSessionValidateData>>,
): UseMutationOptions<
  PostOrgOnboardingSessionValidateResponse,
  ApiError,
  Options<PostOrgOnboardingSessionValidateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgOnboardingSessionValidateResponse,
    ApiError,
    Options<PostOrgOnboardingSessionValidateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgOnboardingSessionValidate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgOnboardingConfigsByIdCopyQueryKey = (options: Options<PostOrgOnboardingConfigsByIdCopyData>) =>
  createQueryKey('postOrgOnboardingConfigsByIdCopy', options);

/**
 * Copies the provided onboarding configuration into the provided tenant and provided sandbox mode.
 */
export const postOrgOnboardingConfigsByIdCopyOptions = (options: Options<PostOrgOnboardingConfigsByIdCopyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgOnboardingConfigsByIdCopy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgOnboardingConfigsByIdCopyQueryKey(options),
  });
};

/**
 * Copies the provided onboarding configuration into the provided tenant and provided sandbox mode.
 */
export const postOrgOnboardingConfigsByIdCopyMutation = (
  options?: Partial<Options<PostOrgOnboardingConfigsByIdCopyData>>,
): UseMutationOptions<
  PostOrgOnboardingConfigsByIdCopyResponse,
  ApiError,
  Options<PostOrgOnboardingConfigsByIdCopyData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgOnboardingConfigsByIdCopyResponse,
    ApiError,
    Options<PostOrgOnboardingConfigsByIdCopyData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgOnboardingConfigsByIdCopy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgOnboardingsQueryKey = (options: Options<PostOrgOnboardingsData>) =>
  createQueryKey('postOrgOnboardings', options);

export const postOrgOnboardingsOptions = (options: Options<PostOrgOnboardingsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgOnboardings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgOnboardingsQueryKey(options),
  });
};

export const postOrgOnboardingsMutation = (
  options?: Partial<Options<PostOrgOnboardingsData>>,
): UseMutationOptions<PostOrgOnboardingsResponse, ApiError, Options<PostOrgOnboardingsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgOnboardingsResponse, ApiError, Options<PostOrgOnboardingsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgOnboardings({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgOnboardingsByIdQueryKey = (options: Options<GetOrgOnboardingsByIdData>) =>
  createQueryKey('getOrgOnboardingsById', options);

/**
 * Fetch an onboarding by `onboarding_id` or `onboarding_external_id`. Returns the same response as `POST /onboardings`, including a freshly minted `continue_onboarding` token when the user still has steps left to complete.
 */
export const getOrgOnboardingsByIdOptions = (options: Options<GetOrgOnboardingsByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgOnboardingsById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgOnboardingsByIdQueryKey(options),
  });
};

export const postOrgPercyEntitiesQueryQueryKey = (options: Options<PostOrgPercyEntitiesQueryData>) =>
  createQueryKey('postOrgPercyEntitiesQuery', options);

/**
 * Percy meta query: search scoped vaults by structured filters. Returns each matching entity's fp_id along with its associated workflow_ids and playbook_ids.
 */
export const postOrgPercyEntitiesQueryOptions = (options: Options<PostOrgPercyEntitiesQueryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPercyEntitiesQuery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPercyEntitiesQueryQueryKey(options),
  });
};

/**
 * Percy meta query: search scoped vaults by structured filters. Returns each matching entity's fp_id along with its associated workflow_ids and playbook_ids.
 */
export const postOrgPercyEntitiesQueryMutation = (
  options?: Partial<Options<PostOrgPercyEntitiesQueryData>>,
): UseMutationOptions<PostOrgPercyEntitiesQueryResponse, ApiError, Options<PostOrgPercyEntitiesQueryData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPercyEntitiesQueryResponse,
    ApiError,
    Options<PostOrgPercyEntitiesQueryData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPercyEntitiesQuery({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgPlaybooksQueryKey = (options?: Options<GetOrgPlaybooksData>) =>
  createQueryKey('getOrgPlaybooks', options);

/**
 * Returns a list of playbooks owned by the tenant.
 */
export const getOrgPlaybooksOptions = (options?: Options<GetOrgPlaybooksData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksQueryKey(options),
  });
};

export const getOrgPlaybooksInfiniteQueryKey = (
  options?: Options<GetOrgPlaybooksData>,
): QueryKey<Options<GetOrgPlaybooksData>> => createQueryKey('getOrgPlaybooks', options, true);

/**
 * Returns a list of playbooks owned by the tenant.
 */
export const getOrgPlaybooksInfiniteOptions = (options?: Options<GetOrgPlaybooksData>) => {
  return infiniteQueryOptions<
    GetOrgPlaybooksResponse,
    ApiError,
    InfiniteData<GetOrgPlaybooksResponse>,
    QueryKey<Options<GetOrgPlaybooksData>>,
    number | Pick<QueryKey<Options<GetOrgPlaybooksData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgPlaybooksData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgPlaybooks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgPlaybooksInfiniteQueryKey(options),
    },
  );
};

export const postOrgPlaybooksEditSessionsQueryKey = (options: Options<PostOrgPlaybooksEditSessionsData>) =>
  createQueryKey('postOrgPlaybooksEditSessions', options);

/**
 * Creates a new playbook edit session. Updates to a playbook can be staged in the edit session before all being committed atomically
 */
export const postOrgPlaybooksEditSessionsOptions = (options: Options<PostOrgPlaybooksEditSessionsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPlaybooksEditSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPlaybooksEditSessionsQueryKey(options),
  });
};

/**
 * Creates a new playbook edit session. Updates to a playbook can be staged in the edit session before all being committed atomically
 */
export const postOrgPlaybooksEditSessionsMutation = (
  options?: Partial<Options<PostOrgPlaybooksEditSessionsData>>,
): UseMutationOptions<PostOrgPlaybooksEditSessionsResponse, ApiError, Options<PostOrgPlaybooksEditSessionsData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPlaybooksEditSessionsResponse,
    ApiError,
    Options<PostOrgPlaybooksEditSessionsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPlaybooksEditSessions({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgPlaybooksEditSessionsByEditSessionIdQueryKey = (
  options: Options<GetOrgPlaybooksEditSessionsByEditSessionIdData>,
) => createQueryKey('getOrgPlaybooksEditSessionsByEditSessionId', options);

/**
 * Get an existing playbook edit session without creating a new one.
 */
export const getOrgPlaybooksEditSessionsByEditSessionIdOptions = (
  options: Options<GetOrgPlaybooksEditSessionsByEditSessionIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooksEditSessionsByEditSessionId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksEditSessionsByEditSessionIdQueryKey(options),
  });
};

/**
 * Apply the given operation to the graph.
 */
export const patchOrgPlaybooksEditSessionsByEditSessionIdMutation = (
  options?: Partial<Options<PatchOrgPlaybooksEditSessionsByEditSessionIdData>>,
): UseMutationOptions<
  PatchOrgPlaybooksEditSessionsByEditSessionIdResponse,
  ApiError,
  Options<PatchOrgPlaybooksEditSessionsByEditSessionIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgPlaybooksEditSessionsByEditSessionIdResponse,
    ApiError,
    Options<PatchOrgPlaybooksEditSessionsByEditSessionIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgPlaybooksEditSessionsByEditSessionId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgPlaybooksEditSessionsByEditSessionIdCommitQueryKey = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdCommitData>,
) => createQueryKey('postOrgPlaybooksEditSessionsByEditSessionIdCommit', options);

/**
 * Commits the playbook edit session by making a new playbook version.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdCommitOptions = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdCommitData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdCommit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPlaybooksEditSessionsByEditSessionIdCommitQueryKey(options),
  });
};

/**
 * Commits the playbook edit session by making a new playbook version.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdCommitMutation = (
  options?: Partial<Options<PostOrgPlaybooksEditSessionsByEditSessionIdCommitData>>,
): UseMutationOptions<
  PostOrgPlaybooksEditSessionsByEditSessionIdCommitResponse,
  ApiError,
  Options<PostOrgPlaybooksEditSessionsByEditSessionIdCommitData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPlaybooksEditSessionsByEditSessionIdCommitResponse,
    ApiError,
    Options<PostOrgPlaybooksEditSessionsByEditSessionIdCommitData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdCommit({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgPlaybooksEditSessionsByEditSessionIdModernizeQueryKey = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData>,
) => createQueryKey('postOrgPlaybooksEditSessionsByEditSessionIdModernize', options);

/**
 * Moves the work the legacy identify flow did before the graph ran onto the graph itself, as edits to the playbook edit session.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdModernizeOptions = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdModernize({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPlaybooksEditSessionsByEditSessionIdModernizeQueryKey(options),
  });
};

/**
 * Moves the work the legacy identify flow did before the graph ran onto the graph itself, as edits to the playbook edit session.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdModernizeMutation = (
  options?: Partial<Options<PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData>>,
): UseMutationOptions<
  PostOrgPlaybooksEditSessionsByEditSessionIdModernizeResponse,
  ApiError,
  Options<PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPlaybooksEditSessionsByEditSessionIdModernizeResponse,
    ApiError,
    Options<PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdModernize({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgPlaybooksEditSessionsByEditSessionIdRestoreQueryKey = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData>,
) => createQueryKey('postOrgPlaybooksEditSessionsByEditSessionIdRestore', options);

/**
 * Restore the graph to the provided log ID from an undo / redo operation.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdRestoreOptions = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdRestore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPlaybooksEditSessionsByEditSessionIdRestoreQueryKey(options),
  });
};

/**
 * Restore the graph to the provided log ID from an undo / redo operation.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdRestoreMutation = (
  options?: Partial<Options<PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData>>,
): UseMutationOptions<
  PostOrgPlaybooksEditSessionsByEditSessionIdRestoreResponse,
  ApiError,
  Options<PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPlaybooksEditSessionsByEditSessionIdRestoreResponse,
    ApiError,
    Options<PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdRestore({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgPlaybooksEditSessionsByEditSessionIdRunQueryKey = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdRunData>,
) => createQueryKey('postOrgPlaybooksEditSessionsByEditSessionIdRun', options);

/**
 * Get an existing playbook edit session without creating a new one.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdRunOptions = (
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdRunData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPlaybooksEditSessionsByEditSessionIdRunQueryKey(options),
  });
};

/**
 * Get an existing playbook edit session without creating a new one.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdRunMutation = (
  options?: Partial<Options<PostOrgPlaybooksEditSessionsByEditSessionIdRunData>>,
): UseMutationOptions<
  PostOrgPlaybooksEditSessionsByEditSessionIdRunResponse,
  ApiError,
  Options<PostOrgPlaybooksEditSessionsByEditSessionIdRunData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPlaybooksEditSessionsByEditSessionIdRunResponse,
    ApiError,
    Options<PostOrgPlaybooksEditSessionsByEditSessionIdRunData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPlaybooksEditSessionsByEditSessionIdRun({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgPlaybooksGalleryQueryKey = (options?: Options<GetOrgPlaybooksGalleryData>) =>
  createQueryKey('getOrgPlaybooksGallery', options);

/**
 * Lists the available playbook templates for the gallery
 */
export const getOrgPlaybooksGalleryOptions = (options?: Options<GetOrgPlaybooksGalleryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooksGallery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksGalleryQueryKey(options),
  });
};

export const getOrgPlaybooksTemplatesQueryKey = (options?: Options<GetOrgPlaybooksTemplatesData>) =>
  createQueryKey('getOrgPlaybooksTemplates', options);

/**
 * Lists the available playbook templates
 */
export const getOrgPlaybooksTemplatesOptions = (options?: Options<GetOrgPlaybooksTemplatesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooksTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksTemplatesQueryKey(options),
  });
};

export const getOrgPlaybooksByIdQueryKey = (options: Options<GetOrgPlaybooksByIdData>) =>
  createQueryKey('getOrgPlaybooksById', options);

/**
 * Returns a detailed view of a playbook owned by the tenant.
 */
export const getOrgPlaybooksByIdOptions = (options: Options<GetOrgPlaybooksByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooksById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksByIdQueryKey(options),
  });
};

/**
 * Updates an existing playbook's status.
 */
export const patchOrgPlaybooksByIdMutation = (
  options?: Partial<Options<PatchOrgPlaybooksByIdData>>,
): UseMutationOptions<PatchOrgPlaybooksByIdResponse, ApiError, Options<PatchOrgPlaybooksByIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgPlaybooksByIdResponse,
    ApiError,
    Options<PatchOrgPlaybooksByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgPlaybooksById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgPlaybooksByPlaybookIdDeploymentsQueryKey = (
  options: Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>,
) => createQueryKey('getOrgPlaybooksByPlaybookIdDeployments', options);

/**
 * Returns a paginated list of all deployments (active and historical) for the given playbook.
 */
export const getOrgPlaybooksByPlaybookIdDeploymentsOptions = (
  options: Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooksByPlaybookIdDeployments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksByPlaybookIdDeploymentsQueryKey(options),
  });
};

export const getOrgPlaybooksByPlaybookIdDeploymentsInfiniteQueryKey = (
  options: Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>,
): QueryKey<Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>> =>
  createQueryKey('getOrgPlaybooksByPlaybookIdDeployments', options, true);

/**
 * Returns a paginated list of all deployments (active and historical) for the given playbook.
 */
export const getOrgPlaybooksByPlaybookIdDeploymentsInfiniteOptions = (
  options: Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>,
) => {
  return infiniteQueryOptions<
    GetOrgPlaybooksByPlaybookIdDeploymentsResponse,
    ApiError,
    InfiniteData<GetOrgPlaybooksByPlaybookIdDeploymentsResponse>,
    QueryKey<Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>>,
    | number
    | Pick<QueryKey<Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetOrgPlaybooksByPlaybookIdDeploymentsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgPlaybooksByPlaybookIdDeployments({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgPlaybooksByPlaybookIdDeploymentsInfiniteQueryKey(options),
    },
  );
};

export const postOrgPlaybooksByPlaybookIdDeploymentsQueryKey = (
  options: Options<PostOrgPlaybooksByPlaybookIdDeploymentsData>,
) => createQueryKey('postOrgPlaybooksByPlaybookIdDeployments', options);

/**
 * Creates a new deployment for the given playbook, deactivating any existing active deployment.
 */
export const postOrgPlaybooksByPlaybookIdDeploymentsOptions = (
  options: Options<PostOrgPlaybooksByPlaybookIdDeploymentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPlaybooksByPlaybookIdDeployments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPlaybooksByPlaybookIdDeploymentsQueryKey(options),
  });
};

/**
 * Creates a new deployment for the given playbook, deactivating any existing active deployment.
 */
export const postOrgPlaybooksByPlaybookIdDeploymentsMutation = (
  options?: Partial<Options<PostOrgPlaybooksByPlaybookIdDeploymentsData>>,
): UseMutationOptions<
  PostOrgPlaybooksByPlaybookIdDeploymentsResponse,
  ApiError,
  Options<PostOrgPlaybooksByPlaybookIdDeploymentsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPlaybooksByPlaybookIdDeploymentsResponse,
    ApiError,
    Options<PostOrgPlaybooksByPlaybookIdDeploymentsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPlaybooksByPlaybookIdDeployments({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgPlaybooksByPlaybookIdVersionsQueryKey = (
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsData>,
) => createQueryKey('getOrgPlaybooksByPlaybookIdVersions', options);

/**
 * Returns the version history of onboarding configurations for the given playbook.
 */
export const getOrgPlaybooksByPlaybookIdVersionsOptions = (
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooksByPlaybookIdVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksByPlaybookIdVersionsQueryKey(options),
  });
};

export const getOrgPlaybooksByPlaybookIdVersionsInfiniteQueryKey = (
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsData>,
): QueryKey<Options<GetOrgPlaybooksByPlaybookIdVersionsData>> =>
  createQueryKey('getOrgPlaybooksByPlaybookIdVersions', options, true);

/**
 * Returns the version history of onboarding configurations for the given playbook.
 */
export const getOrgPlaybooksByPlaybookIdVersionsInfiniteOptions = (
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsData>,
) => {
  return infiniteQueryOptions<
    GetOrgPlaybooksByPlaybookIdVersionsResponse,
    ApiError,
    InfiniteData<GetOrgPlaybooksByPlaybookIdVersionsResponse>,
    QueryKey<Options<GetOrgPlaybooksByPlaybookIdVersionsData>>,
    number | Pick<QueryKey<Options<GetOrgPlaybooksByPlaybookIdVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetOrgPlaybooksByPlaybookIdVersionsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgPlaybooksByPlaybookIdVersions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgPlaybooksByPlaybookIdVersionsInfiniteQueryKey(options),
    },
  );
};

export const getOrgPlaybooksByPlaybookIdVersionsByVersionIdQueryKey = (
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsByVersionIdData>,
) => createQueryKey('getOrgPlaybooksByPlaybookIdVersionsByVersionId', options);

/**
 * Returns a detailed view of a specific playbook version.
 */
export const getOrgPlaybooksByPlaybookIdVersionsByVersionIdOptions = (
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsByVersionIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgPlaybooksByPlaybookIdVersionsByVersionId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgPlaybooksByPlaybookIdVersionsByVersionIdQueryKey(options),
  });
};

export const postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishQueryKey = (
  options: Options<PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData>,
) => createQueryKey('postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublish', options);

/**
 * Publishes the given version of the playbook and un-publishes the currently published version.
 */
export const postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishOptions = (
  options: Options<PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublish({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishQueryKey(options),
  });
};

/**
 * Publishes the given version of the playbook and un-publishes the currently published version.
 */
export const postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishMutation = (
  options?: Partial<Options<PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData>>,
): UseMutationOptions<
  PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishResponse,
  ApiError,
  Options<PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishResponse,
    ApiError,
    Options<PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublish({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgProxyConfigsQueryKey = (options?: Options<GetOrgProxyConfigsData>) =>
  createQueryKey('getOrgProxyConfigs', options);

/**
 * List the organization's proxy configurations
 */
export const getOrgProxyConfigsOptions = (options?: Options<GetOrgProxyConfigsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgProxyConfigs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgProxyConfigsQueryKey(options),
  });
};

export const postOrgProxyConfigsQueryKey = (options: Options<PostOrgProxyConfigsData>) =>
  createQueryKey('postOrgProxyConfigs', options);

/**
 * Create a new proxy configuration
 */
export const postOrgProxyConfigsOptions = (options: Options<PostOrgProxyConfigsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgProxyConfigs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgProxyConfigsQueryKey(options),
  });
};

/**
 * Create a new proxy configuration
 */
export const postOrgProxyConfigsMutation = (
  options?: Partial<Options<PostOrgProxyConfigsData>>,
): UseMutationOptions<PostOrgProxyConfigsResponse, ApiError, Options<PostOrgProxyConfigsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgProxyConfigsResponse, ApiError, Options<PostOrgProxyConfigsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgProxyConfigs({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgProxyConfigsByConfigIdLogsQueryKey = (options: Options<GetOrgProxyConfigsByConfigIdLogsData>) =>
  createQueryKey('getOrgProxyConfigsByConfigIdLogs', options);

/**
 * Lists the request logs for a proxy config.
 */
export const getOrgProxyConfigsByConfigIdLogsOptions = (options: Options<GetOrgProxyConfigsByConfigIdLogsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgProxyConfigsByConfigIdLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgProxyConfigsByConfigIdLogsQueryKey(options),
  });
};

export const getOrgProxyConfigsByConfigIdLogsInfiniteQueryKey = (
  options: Options<GetOrgProxyConfigsByConfigIdLogsData>,
): QueryKey<Options<GetOrgProxyConfigsByConfigIdLogsData>> =>
  createQueryKey('getOrgProxyConfigsByConfigIdLogs', options, true);

/**
 * Lists the request logs for a proxy config.
 */
export const getOrgProxyConfigsByConfigIdLogsInfiniteOptions = (
  options: Options<GetOrgProxyConfigsByConfigIdLogsData>,
) => {
  return infiniteQueryOptions<
    GetOrgProxyConfigsByConfigIdLogsResponse,
    ApiError,
    InfiniteData<GetOrgProxyConfigsByConfigIdLogsResponse>,
    QueryKey<Options<GetOrgProxyConfigsByConfigIdLogsData>>,
    string | Pick<QueryKey<Options<GetOrgProxyConfigsByConfigIdLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetOrgProxyConfigsByConfigIdLogsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgProxyConfigsByConfigIdLogs({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgProxyConfigsByConfigIdLogsInfiniteQueryKey(options),
    },
  );
};

export const getOrgProxyConfigsByProxyConfigIdQueryKey = (options: Options<GetOrgProxyConfigsByProxyConfigIdData>) =>
  createQueryKey('getOrgProxyConfigsByProxyConfigId', options);

/**
 * Get a proxy configuration with details
 */
export const getOrgProxyConfigsByProxyConfigIdOptions = (options: Options<GetOrgProxyConfigsByProxyConfigIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgProxyConfigsByProxyConfigId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgProxyConfigsByProxyConfigIdQueryKey(options),
  });
};

/**
 * Update an existing proxy configuration
 */
export const patchOrgProxyConfigsByProxyConfigIdMutation = (
  options?: Partial<Options<PatchOrgProxyConfigsByProxyConfigIdData>>,
): UseMutationOptions<
  PatchOrgProxyConfigsByProxyConfigIdResponse,
  ApiError,
  Options<PatchOrgProxyConfigsByProxyConfigIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgProxyConfigsByProxyConfigIdResponse,
    ApiError,
    Options<PatchOrgProxyConfigsByProxyConfigIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgProxyConfigsByProxyConfigId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgProxyConfigsByProxyConfigIdDeactivateQueryKey = (
  options: Options<PostOrgProxyConfigsByProxyConfigIdDeactivateData>,
) => createQueryKey('postOrgProxyConfigsByProxyConfigIdDeactivate', options);

/**
 * Delete organization's proxy configurations
 */
export const postOrgProxyConfigsByProxyConfigIdDeactivateOptions = (
  options: Options<PostOrgProxyConfigsByProxyConfigIdDeactivateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgProxyConfigsByProxyConfigIdDeactivate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgProxyConfigsByProxyConfigIdDeactivateQueryKey(options),
  });
};

/**
 * Delete organization's proxy configurations
 */
export const postOrgProxyConfigsByProxyConfigIdDeactivateMutation = (
  options?: Partial<Options<PostOrgProxyConfigsByProxyConfigIdDeactivateData>>,
): UseMutationOptions<
  PostOrgProxyConfigsByProxyConfigIdDeactivateResponse,
  ApiError,
  Options<PostOrgProxyConfigsByProxyConfigIdDeactivateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgProxyConfigsByProxyConfigIdDeactivateResponse,
    ApiError,
    Options<PostOrgProxyConfigsByProxyConfigIdDeactivateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgProxyConfigsByProxyConfigIdDeactivate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReportingEmbedQueryKey = (options?: Options<GetOrgReportingEmbedData>) =>
  createQueryKey('getOrgReportingEmbed', options);

/**
 * Returns the reporting embedded portal url.
 */
export const getOrgReportingEmbedOptions = (options?: Options<GetOrgReportingEmbedData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReportingEmbed({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReportingEmbedQueryKey(options),
  });
};

export const getOrgReviewAgentsQueryKey = (options?: Options<GetOrgReviewAgentsData>) =>
  createQueryKey('getOrgReviewAgents', options);

/**
 * List review agents
 */
export const getOrgReviewAgentsOptions = (options?: Options<GetOrgReviewAgentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewAgents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewAgentsQueryKey(options),
  });
};

export const postOrgReviewAgentsQueryKey = (options: Options<PostOrgReviewAgentsData>) =>
  createQueryKey('postOrgReviewAgents', options);

/**
 * Create a review agent
 */
export const postOrgReviewAgentsOptions = (options: Options<PostOrgReviewAgentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewAgents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewAgentsQueryKey(options),
  });
};

/**
 * Create a review agent
 */
export const postOrgReviewAgentsMutation = (
  options?: Partial<Options<PostOrgReviewAgentsData>>,
): UseMutationOptions<PostOrgReviewAgentsResponse, ApiError, Options<PostOrgReviewAgentsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgReviewAgentsResponse, ApiError, Options<PostOrgReviewAgentsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewAgents({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReviewAgentsReviewsQueryKey = (options?: Options<GetOrgReviewAgentsReviewsData>) =>
  createQueryKey('getOrgReviewAgentsReviews', options);

/**
 * List all reviews for a review agent
 */
export const getOrgReviewAgentsReviewsOptions = (options?: Options<GetOrgReviewAgentsReviewsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewAgentsReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewAgentsReviewsQueryKey(options),
  });
};

/**
 * Update a review agent by ID
 */
export const patchOrgReviewAgentsByIdMutation = (
  options?: Partial<Options<PatchOrgReviewAgentsByIdData>>,
): UseMutationOptions<PatchOrgReviewAgentsByIdResponse, ApiError, Options<PatchOrgReviewAgentsByIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgReviewAgentsByIdResponse,
    ApiError,
    Options<PatchOrgReviewAgentsByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgReviewAgentsById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReviewKindsQueryKey = (options?: Options<GetOrgReviewKindsData>) =>
  createQueryKey('getOrgReviewKinds', options);

/**
 * List review agents
 */
export const getOrgReviewKindsOptions = (options?: Options<GetOrgReviewKindsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewKinds({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewKindsQueryKey(options),
  });
};

export const postOrgReviewKindsQueryKey = (options: Options<PostOrgReviewKindsData>) =>
  createQueryKey('postOrgReviewKinds', options);

/**
 * Create a review kind
 */
export const postOrgReviewKindsOptions = (options: Options<PostOrgReviewKindsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewKinds({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewKindsQueryKey(options),
  });
};

/**
 * Create a review kind
 */
export const postOrgReviewKindsMutation = (
  options?: Partial<Options<PostOrgReviewKindsData>>,
): UseMutationOptions<PostOrgReviewKindsResponse, ApiError, Options<PostOrgReviewKindsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgReviewKindsResponse, ApiError, Options<PostOrgReviewKindsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewKinds({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a review kind
 */
export const patchOrgReviewKindsByIdMutation = (
  options?: Partial<Options<PatchOrgReviewKindsByIdData>>,
): UseMutationOptions<PatchOrgReviewKindsByIdResponse, ApiError, Options<PatchOrgReviewKindsByIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgReviewKindsByIdResponse,
    ApiError,
    Options<PatchOrgReviewKindsByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgReviewKindsById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReviewQueuesQueryKey = (options?: Options<GetOrgReviewQueuesData>) =>
  createQueryKey('getOrgReviewQueues', options);

/**
 * List all review queues for the organization
 */
export const getOrgReviewQueuesOptions = (options?: Options<GetOrgReviewQueuesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewQueues({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewQueuesQueryKey(options),
  });
};

export const postOrgReviewQueuesQueryKey = (options: Options<PostOrgReviewQueuesData>) =>
  createQueryKey('postOrgReviewQueues', options);

/**
 * Create a new review queue
 */
export const postOrgReviewQueuesOptions = (options: Options<PostOrgReviewQueuesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewQueues({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewQueuesQueryKey(options),
  });
};

/**
 * Create a new review queue
 */
export const postOrgReviewQueuesMutation = (
  options?: Partial<Options<PostOrgReviewQueuesData>>,
): UseMutationOptions<PostOrgReviewQueuesResponse, ApiError, Options<PostOrgReviewQueuesData>> => {
  const mutationOptions: UseMutationOptions<PostOrgReviewQueuesResponse, ApiError, Options<PostOrgReviewQueuesData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewQueues({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a review queue
 */
export const deleteOrgReviewQueuesByIdMutation = (
  options?: Partial<Options<DeleteOrgReviewQueuesByIdData>>,
): UseMutationOptions<DeleteOrgReviewQueuesByIdResponse, ApiError, Options<DeleteOrgReviewQueuesByIdData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgReviewQueuesByIdResponse,
    ApiError,
    Options<DeleteOrgReviewQueuesByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgReviewQueuesById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReviewQueuesByIdQueryKey = (options: Options<GetOrgReviewQueuesByIdData>) =>
  createQueryKey('getOrgReviewQueuesById', options);

/**
 * Get a specific review queue by ID
 */
export const getOrgReviewQueuesByIdOptions = (options: Options<GetOrgReviewQueuesByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewQueuesById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewQueuesByIdQueryKey(options),
  });
};

/**
 * Update a review queue
 */
export const patchOrgReviewQueuesByIdMutation = (
  options?: Partial<Options<PatchOrgReviewQueuesByIdData>>,
): UseMutationOptions<PatchOrgReviewQueuesByIdResponse, ApiError, Options<PatchOrgReviewQueuesByIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgReviewQueuesByIdResponse,
    ApiError,
    Options<PatchOrgReviewQueuesByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgReviewQueuesById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReviewQueuesByQueueIdMetricsQueryKey = (options: Options<GetOrgReviewQueuesByQueueIdMetricsData>) =>
  createQueryKey('getOrgReviewQueuesByQueueIdMetrics', options);

/**
 * Get the queue metrics for a queue
 */
export const getOrgReviewQueuesByQueueIdMetricsOptions = (options: Options<GetOrgReviewQueuesByQueueIdMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewQueuesByQueueIdMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewQueuesByQueueIdMetricsQueryKey(options),
  });
};

export const postOrgReviewQueuesByQueueIdNextQueryKey = (options: Options<PostOrgReviewQueuesByQueueIdNextData>) =>
  createQueryKey('postOrgReviewQueuesByQueueIdNext', options);

/**
 * Get the next review(s) for the current review agent
 */
export const postOrgReviewQueuesByQueueIdNextOptions = (options: Options<PostOrgReviewQueuesByQueueIdNextData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewQueuesByQueueIdNext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewQueuesByQueueIdNextQueryKey(options),
  });
};

/**
 * Get the next review(s) for the current review agent
 */
export const postOrgReviewQueuesByQueueIdNextMutation = (
  options?: Partial<Options<PostOrgReviewQueuesByQueueIdNextData>>,
): UseMutationOptions<
  PostOrgReviewQueuesByQueueIdNextResponse,
  ApiError,
  Options<PostOrgReviewQueuesByQueueIdNextData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgReviewQueuesByQueueIdNextResponse,
    ApiError,
    Options<PostOrgReviewQueuesByQueueIdNextData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewQueuesByQueueIdNext({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReviewQueuesByQueueIdReviewsQueryKey = (options: Options<GetOrgReviewQueuesByQueueIdReviewsData>) =>
  createQueryKey('getOrgReviewQueuesByQueueIdReviews', options);

/**
 * List all reviews for a queue
 */
export const getOrgReviewQueuesByQueueIdReviewsOptions = (options: Options<GetOrgReviewQueuesByQueueIdReviewsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewQueuesByQueueIdReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewQueuesByQueueIdReviewsQueryKey(options),
  });
};

export const getOrgReviewQueuesByQueueIdReviewsInfiniteQueryKey = (
  options: Options<GetOrgReviewQueuesByQueueIdReviewsData>,
): QueryKey<Options<GetOrgReviewQueuesByQueueIdReviewsData>> =>
  createQueryKey('getOrgReviewQueuesByQueueIdReviews', options, true);

/**
 * List all reviews for a queue
 */
export const getOrgReviewQueuesByQueueIdReviewsInfiniteOptions = (
  options: Options<GetOrgReviewQueuesByQueueIdReviewsData>,
) => {
  return infiniteQueryOptions<
    GetOrgReviewQueuesByQueueIdReviewsResponse,
    ApiError,
    InfiniteData<GetOrgReviewQueuesByQueueIdReviewsResponse>,
    QueryKey<Options<GetOrgReviewQueuesByQueueIdReviewsData>>,
    number | Pick<QueryKey<Options<GetOrgReviewQueuesByQueueIdReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetOrgReviewQueuesByQueueIdReviewsData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgReviewQueuesByQueueIdReviews({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgReviewQueuesByQueueIdReviewsInfiniteQueryKey(options),
    },
  );
};

export const getOrgReviewTeamsQueryKey = (options?: Options<GetOrgReviewTeamsData>) =>
  createQueryKey('getOrgReviewTeams', options);

/**
 * List all review teams for the organization
 */
export const getOrgReviewTeamsOptions = (options?: Options<GetOrgReviewTeamsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewTeams({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewTeamsQueryKey(options),
  });
};

export const postOrgReviewTeamsQueryKey = (options: Options<PostOrgReviewTeamsData>) =>
  createQueryKey('postOrgReviewTeams', options);

/**
 * Create a new review team
 */
export const postOrgReviewTeamsOptions = (options: Options<PostOrgReviewTeamsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewTeams({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewTeamsQueryKey(options),
  });
};

/**
 * Create a new review team
 */
export const postOrgReviewTeamsMutation = (
  options?: Partial<Options<PostOrgReviewTeamsData>>,
): UseMutationOptions<PostOrgReviewTeamsResponse, ApiError, Options<PostOrgReviewTeamsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgReviewTeamsResponse, ApiError, Options<PostOrgReviewTeamsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewTeams({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a review team
 */
export const deleteOrgReviewTeamsByIdMutation = (
  options?: Partial<Options<DeleteOrgReviewTeamsByIdData>>,
): UseMutationOptions<DeleteOrgReviewTeamsByIdResponse, ApiError, Options<DeleteOrgReviewTeamsByIdData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgReviewTeamsByIdResponse,
    ApiError,
    Options<DeleteOrgReviewTeamsByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgReviewTeamsById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgReviewTeamsByIdQueryKey = (options: Options<GetOrgReviewTeamsByIdData>) =>
  createQueryKey('getOrgReviewTeamsById', options);

/**
 * Get a specific review team by ID
 */
export const getOrgReviewTeamsByIdOptions = (options: Options<GetOrgReviewTeamsByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgReviewTeamsById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgReviewTeamsByIdQueryKey(options),
  });
};

/**
 * Update a review team
 */
export const patchOrgReviewTeamsByIdMutation = (
  options?: Partial<Options<PatchOrgReviewTeamsByIdData>>,
): UseMutationOptions<PatchOrgReviewTeamsByIdResponse, ApiError, Options<PatchOrgReviewTeamsByIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgReviewTeamsByIdResponse,
    ApiError,
    Options<PatchOrgReviewTeamsByIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgReviewTeamsById({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgReviewsByIdSelfAssignQueryKey = (options: Options<PostOrgReviewsByIdSelfAssignData>) =>
  createQueryKey('postOrgReviewsByIdSelfAssign', options);

/**
 * Self assign a review to the current review agent
 */
export const postOrgReviewsByIdSelfAssignOptions = (options: Options<PostOrgReviewsByIdSelfAssignData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewsByIdSelfAssign({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewsByIdSelfAssignQueryKey(options),
  });
};

/**
 * Self assign a review to the current review agent
 */
export const postOrgReviewsByIdSelfAssignMutation = (
  options?: Partial<Options<PostOrgReviewsByIdSelfAssignData>>,
): UseMutationOptions<PostOrgReviewsByIdSelfAssignResponse, ApiError, Options<PostOrgReviewsByIdSelfAssignData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgReviewsByIdSelfAssignResponse,
    ApiError,
    Options<PostOrgReviewsByIdSelfAssignData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewsByIdSelfAssign({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgReviewsByIdSelfUnassignQueryKey = (options: Options<PostOrgReviewsByIdSelfUnassignData>) =>
  createQueryKey('postOrgReviewsByIdSelfUnassign', options);

/**
 * Self unassign a review from the current review agent
 */
export const postOrgReviewsByIdSelfUnassignOptions = (options: Options<PostOrgReviewsByIdSelfUnassignData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewsByIdSelfUnassign({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewsByIdSelfUnassignQueryKey(options),
  });
};

/**
 * Self unassign a review from the current review agent
 */
export const postOrgReviewsByIdSelfUnassignMutation = (
  options?: Partial<Options<PostOrgReviewsByIdSelfUnassignData>>,
): UseMutationOptions<
  PostOrgReviewsByIdSelfUnassignResponse,
  ApiError,
  Options<PostOrgReviewsByIdSelfUnassignData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgReviewsByIdSelfUnassignResponse,
    ApiError,
    Options<PostOrgReviewsByIdSelfUnassignData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewsByIdSelfUnassign({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgReviewsByIdStartQueryKey = (options: Options<PostOrgReviewsByIdStartData>) =>
  createQueryKey('postOrgReviewsByIdStart', options);

/**
 * Start a review
 */
export const postOrgReviewsByIdStartOptions = (options: Options<PostOrgReviewsByIdStartData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgReviewsByIdStart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgReviewsByIdStartQueryKey(options),
  });
};

/**
 * Start a review
 */
export const postOrgReviewsByIdStartMutation = (
  options?: Partial<Options<PostOrgReviewsByIdStartData>>,
): UseMutationOptions<PostOrgReviewsByIdStartResponse, ApiError, Options<PostOrgReviewsByIdStartData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgReviewsByIdStartResponse,
    ApiError,
    Options<PostOrgReviewsByIdStartData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgReviewsByIdStart({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgRiskSignalMetricsQueryKey = (options?: Options<GetOrgRiskSignalMetricsData>) =>
  createQueryKey('getOrgRiskSignalMetrics', options);

/**
 * Get metrics for a risk signals
 */
export const getOrgRiskSignalMetricsOptions = (options?: Options<GetOrgRiskSignalMetricsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgRiskSignalMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgRiskSignalMetricsQueryKey(options),
  });
};

export const getOrgRiskSignalsSpecQueryKey = (options?: Options<GetOrgRiskSignalsSpecData>) =>
  createQueryKey('getOrgRiskSignalsSpec', options);

/**
 * List all Footprint Risk Signals
 */
export const getOrgRiskSignalsSpecOptions = (options?: Options<GetOrgRiskSignalsSpecData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgRiskSignalsSpec({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgRiskSignalsSpecQueryKey(options),
  });
};

export const getOrgRolesQueryKey = (options?: Options<GetOrgRolesData>) => createQueryKey('getOrgRoles', options);

/**
 * Returns a list of IAM roles for the tenant.
 */
export const getOrgRolesOptions = (options?: Options<GetOrgRolesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgRoles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgRolesQueryKey(options),
  });
};

export const getOrgRolesInfiniteQueryKey = (options?: Options<GetOrgRolesData>): QueryKey<Options<GetOrgRolesData>> =>
  createQueryKey('getOrgRoles', options, true);

/**
 * Returns a list of IAM roles for the tenant.
 */
export const getOrgRolesInfiniteOptions = (options?: Options<GetOrgRolesData>) => {
  return infiniteQueryOptions<
    GetOrgRolesResponse,
    ApiError,
    InfiniteData<GetOrgRolesResponse>,
    QueryKey<Options<GetOrgRolesData>>,
    number | Pick<QueryKey<Options<GetOrgRolesData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgRolesData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgRoles({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgRolesInfiniteQueryKey(options),
    },
  );
};

export const postOrgRolesQueryKey = (options: Options<PostOrgRolesData>) => createQueryKey('postOrgRoles', options);

/**
 * Create a new IAM role for the tenant.
 */
export const postOrgRolesOptions = (options: Options<PostOrgRolesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgRoles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgRolesQueryKey(options),
  });
};

/**
 * Create a new IAM role for the tenant.
 */
export const postOrgRolesMutation = (
  options?: Partial<Options<PostOrgRolesData>>,
): UseMutationOptions<PostOrgRolesResponse, ApiError, Options<PostOrgRolesData>> => {
  const mutationOptions: UseMutationOptions<PostOrgRolesResponse, ApiError, Options<PostOrgRolesData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgRoles({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates the provided IAM role.
 */
export const patchOrgRolesByTenantRoleIdMutation = (
  options?: Partial<Options<PatchOrgRolesByTenantRoleIdData>>,
): UseMutationOptions<PatchOrgRolesByTenantRoleIdResponse, ApiError, Options<PatchOrgRolesByTenantRoleIdData>> => {
  const mutationOptions: UseMutationOptions<
    PatchOrgRolesByTenantRoleIdResponse,
    ApiError,
    Options<PatchOrgRolesByTenantRoleIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchOrgRolesByTenantRoleId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgRolesByTenantRoleIdDeactivateQueryKey = (
  options: Options<PostOrgRolesByTenantRoleIdDeactivateData>,
) => createQueryKey('postOrgRolesByTenantRoleIdDeactivate', options);

/**
 * Deactivates the provided IAM role.
 */
export const postOrgRolesByTenantRoleIdDeactivateOptions = (
  options: Options<PostOrgRolesByTenantRoleIdDeactivateData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgRolesByTenantRoleIdDeactivate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgRolesByTenantRoleIdDeactivateQueryKey(options),
  });
};

/**
 * Deactivates the provided IAM role.
 */
export const postOrgRolesByTenantRoleIdDeactivateMutation = (
  options?: Partial<Options<PostOrgRolesByTenantRoleIdDeactivateData>>,
): UseMutationOptions<
  PostOrgRolesByTenantRoleIdDeactivateResponse,
  ApiError,
  Options<PostOrgRolesByTenantRoleIdDeactivateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgRolesByTenantRoleIdDeactivateResponse,
    ApiError,
    Options<PostOrgRolesByTenantRoleIdDeactivateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgRolesByTenantRoleIdDeactivate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgSdkVersionQueryKey = (options?: Options<GetOrgSdkVersionData>) =>
  createQueryKey('getOrgSdkVersion', options);

/**
 * Fetch SDK version usage for a tenant.
 */
export const getOrgSdkVersionOptions = (options?: Options<GetOrgSdkVersionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgSdkVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgSdkVersionQueryKey(options),
  });
};

export const getOrgSdkVersionInfiniteQueryKey = (
  options?: Options<GetOrgSdkVersionData>,
): QueryKey<Options<GetOrgSdkVersionData>> => createQueryKey('getOrgSdkVersion', options, true);

/**
 * Fetch SDK version usage for a tenant.
 */
export const getOrgSdkVersionInfiniteOptions = (options?: Options<GetOrgSdkVersionData>) => {
  return infiniteQueryOptions<
    GetOrgSdkVersionResponse,
    ApiError,
    InfiniteData<GetOrgSdkVersionResponse>,
    QueryKey<Options<GetOrgSdkVersionData>>,
    number | Pick<QueryKey<Options<GetOrgSdkVersionData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetOrgSdkVersionData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getOrgSdkVersion({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getOrgSdkVersionInfiniteQueryKey(options),
    },
  );
};

export const getOrgTagsQueryKey = (options: Options<GetOrgTagsData>) => createQueryKey('getOrgTags', options);

/**
 * Returns a list of Tags for the organization.
 */
export const getOrgTagsOptions = (options: Options<GetOrgTagsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgTags({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgTagsQueryKey(options),
  });
};

export const postOrgTagsQueryKey = (options: Options<PostOrgTagsData>) => createQueryKey('postOrgTags', options);

/**
 * Creates a new Tag for the organization.
 */
export const postOrgTagsOptions = (options: Options<PostOrgTagsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgTags({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgTagsQueryKey(options),
  });
};

/**
 * Creates a new Tag for the organization.
 */
export const postOrgTagsMutation = (
  options?: Partial<Options<PostOrgTagsData>>,
): UseMutationOptions<PostOrgTagsResponse, ApiError, Options<PostOrgTagsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgTagsResponse, ApiError, Options<PostOrgTagsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgTags({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a tag for the organization.
 */
export const deleteOrgTagsByTagIdMutation = (
  options?: Partial<Options<DeleteOrgTagsByTagIdData>>,
): UseMutationOptions<DeleteOrgTagsByTagIdResponse, ApiError, Options<DeleteOrgTagsByTagIdData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteOrgTagsByTagIdResponse,
    ApiError,
    Options<DeleteOrgTagsByTagIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await deleteOrgTagsByTagId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgVaultDrAwsPreEnrollmentQueryKey = (options?: Options<GetOrgVaultDrAwsPreEnrollmentData>) =>
  createQueryKey('getOrgVaultDrAwsPreEnrollment', options);

/**
 * Returns the AWS external ID for the tenant if it exists
 */
export const getOrgVaultDrAwsPreEnrollmentOptions = (options?: Options<GetOrgVaultDrAwsPreEnrollmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgVaultDrAwsPreEnrollment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgVaultDrAwsPreEnrollmentQueryKey(options),
  });
};

export const postOrgVaultDrAwsPreEnrollmentQueryKey = (options?: Options<PostOrgVaultDrAwsPreEnrollmentData>) =>
  createQueryKey('postOrgVaultDrAwsPreEnrollment', options);

/**
 * Generates an AWS external ID for the tenant if necessary.
 */
export const postOrgVaultDrAwsPreEnrollmentOptions = (options?: Options<PostOrgVaultDrAwsPreEnrollmentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgVaultDrAwsPreEnrollment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgVaultDrAwsPreEnrollmentQueryKey(options),
  });
};

/**
 * Generates an AWS external ID for the tenant if necessary.
 */
export const postOrgVaultDrAwsPreEnrollmentMutation = (
  options?: Partial<Options<PostOrgVaultDrAwsPreEnrollmentData>>,
): UseMutationOptions<
  PostOrgVaultDrAwsPreEnrollmentResponse,
  ApiError,
  Options<PostOrgVaultDrAwsPreEnrollmentData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgVaultDrAwsPreEnrollmentResponse,
    ApiError,
    Options<PostOrgVaultDrAwsPreEnrollmentData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgVaultDrAwsPreEnrollment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgVaultDrEnrollQueryKey = (options: Options<PostOrgVaultDrEnrollData>) =>
  createQueryKey('postOrgVaultDrEnroll', options);

/**
 * Enrolls the authorized tenant in Vault Disaster Recovery
 */
export const postOrgVaultDrEnrollOptions = (options: Options<PostOrgVaultDrEnrollData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgVaultDrEnroll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgVaultDrEnrollQueryKey(options),
  });
};

/**
 * Enrolls the authorized tenant in Vault Disaster Recovery
 */
export const postOrgVaultDrEnrollMutation = (
  options?: Partial<Options<PostOrgVaultDrEnrollData>>,
): UseMutationOptions<PostOrgVaultDrEnrollResponse, ApiError, Options<PostOrgVaultDrEnrollData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgVaultDrEnrollResponse,
    ApiError,
    Options<PostOrgVaultDrEnrollData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgVaultDrEnroll({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgVaultDrRevealWrappedRecordKeysQueryKey = (
  options: Options<PostOrgVaultDrRevealWrappedRecordKeysData>,
) => createQueryKey('postOrgVaultDrRevealWrappedRecordKeys', options);

/**
 * Reveals the wrapped record keys necessary to decrypt the Vault Disaster Recovery backups for the given fp_id fields
 */
export const postOrgVaultDrRevealWrappedRecordKeysOptions = (
  options: Options<PostOrgVaultDrRevealWrappedRecordKeysData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgVaultDrRevealWrappedRecordKeys({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgVaultDrRevealWrappedRecordKeysQueryKey(options),
  });
};

/**
 * Reveals the wrapped record keys necessary to decrypt the Vault Disaster Recovery backups for the given fp_id fields
 */
export const postOrgVaultDrRevealWrappedRecordKeysMutation = (
  options?: Partial<Options<PostOrgVaultDrRevealWrappedRecordKeysData>>,
): UseMutationOptions<
  PostOrgVaultDrRevealWrappedRecordKeysResponse,
  ApiError,
  Options<PostOrgVaultDrRevealWrappedRecordKeysData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgVaultDrRevealWrappedRecordKeysResponse,
    ApiError,
    Options<PostOrgVaultDrRevealWrappedRecordKeysData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgVaultDrRevealWrappedRecordKeys({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgVaultDrStatusQueryKey = (options?: Options<GetOrgVaultDrStatusData>) =>
  createQueryKey('getOrgVaultDrStatus', options);

/**
 * Returns the status of Vault Disaster Recovery for the authenticated organization
 */
export const getOrgVaultDrStatusOptions = (options?: Options<GetOrgVaultDrStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgVaultDrStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgVaultDrStatusQueryKey(options),
  });
};

export const getOrgVendorIntegrationsQueryKey = (options?: Options<GetOrgVendorIntegrationsData>) =>
  createQueryKey('getOrgVendorIntegrations', options);

/**
 * List every supported vendor, along with the organization's integration for it if one is registered
 */
export const getOrgVendorIntegrationsOptions = (options?: Options<GetOrgVendorIntegrationsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgVendorIntegrations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgVendorIntegrationsQueryKey(options),
  });
};

export const postOrgVendorIntegrationsQueryKey = (options: Options<PostOrgVendorIntegrationsData>) =>
  createQueryKey('postOrgVendorIntegrations', options);

/**
 * Register a vendor integration. Add its live and sandbox credentials with POST /org/vendor_integrations/{integration_id}/credentials
 */
export const postOrgVendorIntegrationsOptions = (options: Options<PostOrgVendorIntegrationsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgVendorIntegrations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgVendorIntegrationsQueryKey(options),
  });
};

/**
 * Register a vendor integration. Add its live and sandbox credentials with POST /org/vendor_integrations/{integration_id}/credentials
 */
export const postOrgVendorIntegrationsMutation = (
  options?: Partial<Options<PostOrgVendorIntegrationsData>>,
): UseMutationOptions<PostOrgVendorIntegrationsResponse, ApiError, Options<PostOrgVendorIntegrationsData>> => {
  const mutationOptions: UseMutationOptions<
    PostOrgVendorIntegrationsResponse,
    ApiError,
    Options<PostOrgVendorIntegrationsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgVendorIntegrations({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgVendorIntegrationsByIntegrationIdCredentialsQueryKey = (
  options: Options<PostOrgVendorIntegrationsByIntegrationIdCredentialsData>,
) => createQueryKey('postOrgVendorIntegrationsByIntegrationIdCredentials', options);

/**
 * Add or replace a live or sandbox credential on a vendor integration
 */
export const postOrgVendorIntegrationsByIntegrationIdCredentialsOptions = (
  options: Options<PostOrgVendorIntegrationsByIntegrationIdCredentialsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgVendorIntegrationsByIntegrationIdCredentials({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgVendorIntegrationsByIntegrationIdCredentialsQueryKey(options),
  });
};

/**
 * Add or replace a live or sandbox credential on a vendor integration
 */
export const postOrgVendorIntegrationsByIntegrationIdCredentialsMutation = (
  options?: Partial<Options<PostOrgVendorIntegrationsByIntegrationIdCredentialsData>>,
): UseMutationOptions<
  PostOrgVendorIntegrationsByIntegrationIdCredentialsResponse,
  ApiError,
  Options<PostOrgVendorIntegrationsByIntegrationIdCredentialsData>
> => {
  const mutationOptions: UseMutationOptions<
    PostOrgVendorIntegrationsByIntegrationIdCredentialsResponse,
    ApiError,
    Options<PostOrgVendorIntegrationsByIntegrationIdCredentialsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgVendorIntegrationsByIntegrationIdCredentials({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealQueryKey = (
  options: Options<PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData>,
) => createQueryKey('postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdReveal', options);

/**
 * Reveal the output of a vendor integration execution
 */
export const postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealOptions = (
  options: Options<PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdReveal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealQueryKey(options),
  });
};

/**
 * Reveal the output of a vendor integration execution
 */
export const postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealMutation = (
  options?: Partial<Options<PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData>>,
): UseMutationOptions<
  unknown,
  ApiError,
  Options<PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiError,
    Options<PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdReveal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgWebhookPortalQueryKey = (options?: Options<GetOrgWebhookPortalData>) =>
  createQueryKey('getOrgWebhookPortal', options);

/**
 * Returns the webhook portal url.
 */
export const getOrgWebhookPortalOptions = (options?: Options<GetOrgWebhookPortalData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgWebhookPortal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgWebhookPortalQueryKey(options),
  });
};

export const getPrivateAccessRequestsQueryKey = (options?: Options<GetPrivateAccessRequestsData>) =>
  createQueryKey('getPrivateAccessRequests', options);

/**
 * Lists all access requests for the tenant
 */
export const getPrivateAccessRequestsOptions = (options?: Options<GetPrivateAccessRequestsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrivateAccessRequests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrivateAccessRequestsQueryKey(options),
  });
};

export const postPrivateAccessRequestsQueryKey = (options: Options<PostPrivateAccessRequestsData>) =>
  createQueryKey('postPrivateAccessRequests', options);

/**
 * Creates a new access request
 */
export const postPrivateAccessRequestsOptions = (options: Options<PostPrivateAccessRequestsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postPrivateAccessRequests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postPrivateAccessRequestsQueryKey(options),
  });
};

/**
 * Creates a new access request
 */
export const postPrivateAccessRequestsMutation = (
  options?: Partial<Options<PostPrivateAccessRequestsData>>,
): UseMutationOptions<PostPrivateAccessRequestsResponse, ApiError, Options<PostPrivateAccessRequestsData>> => {
  const mutationOptions: UseMutationOptions<
    PostPrivateAccessRequestsResponse,
    ApiError,
    Options<PostPrivateAccessRequestsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postPrivateAccessRequests({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates an access request (e.g. to approve it or extend it's expiration time)
 */
export const patchPrivateAccessRequestsByRequestIdMutation = (
  options?: Partial<Options<PatchPrivateAccessRequestsByRequestIdData>>,
): UseMutationOptions<
  PatchPrivateAccessRequestsByRequestIdResponse,
  ApiError,
  Options<PatchPrivateAccessRequestsByRequestIdData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchPrivateAccessRequestsByRequestIdResponse,
    ApiError,
    Options<PatchPrivateAccessRequestsByRequestIdData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchPrivateAccessRequestsByRequestId({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postPrivateAssumeQueryKey = (options: Options<PostPrivateAssumeData>) =>
  createQueryKey('postPrivateAssume', options);

/**
 * Allow a firm employee to impersonate a tenant
 */
export const postPrivateAssumeOptions = (options: Options<PostPrivateAssumeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postPrivateAssume({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postPrivateAssumeQueryKey(options),
  });
};

/**
 * Allow a firm employee to impersonate a tenant
 */
export const postPrivateAssumeMutation = (
  options?: Partial<Options<PostPrivateAssumeData>>,
): UseMutationOptions<PostPrivateAssumeResponse, ApiError, Options<PostPrivateAssumeData>> => {
  const mutationOptions: UseMutationOptions<PostPrivateAssumeResponse, ApiError, Options<PostPrivateAssumeData>> = {
    mutationFn: async localOptions => {
      const { data } = await postPrivateAssume({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPrivateGraphsByGraphIdQueryKey = (options: Options<GetPrivateGraphsByGraphIdData>) =>
  createQueryKey('getPrivateGraphsByGraphId', options);

/**
 * Firm-employee-only: fetch any onboarding graph by ID plus the playbook  version that references it (if any). Used by the internal graph viewer to inspect graphs whose playbooks are hidden, deactivated, or absent.
 */
export const getPrivateGraphsByGraphIdOptions = (options: Options<GetPrivateGraphsByGraphIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrivateGraphsByGraphId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPrivateGraphsByGraphIdQueryKey(options),
  });
};

export const getRoStatusQueryKey = (options?: Options<GetRoStatusData>) => createQueryKey('getRoStatus', options);

/**
 * Performs health check to the RO database
 */
export const getRoStatusOptions = (options?: Options<GetRoStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRoStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRoStatusQueryKey(options),
  });
};

export const getStatusQueryKey = (options?: Options<GetStatusData>) => createQueryKey('getStatus', options);

/**
 * Returns health of services running
 */
export const getStatusOptions = (options?: Options<GetStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getStatusQueryKey(options),
  });
};

export const getStatus2QueryKey = (options?: Options<GetStatus2Data>) => createQueryKey('getStatus2', options);

/**
 * Returns health of services running
 */
export const getStatus2Options = (options?: Options<GetStatus2Data>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStatus2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getStatus2QueryKey(options),
  });
};

export const postVaultProxyLogsByLogIdRevealQueryKey = (options: Options<PostVaultProxyLogsByLogIdRevealData>) =>
  createQueryKey('postVaultProxyLogsByLogIdReveal', options);

/**
 * Reveals the contents of a vault proxy request log.
 */
export const postVaultProxyLogsByLogIdRevealOptions = (options: Options<PostVaultProxyLogsByLogIdRevealData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postVaultProxyLogsByLogIdReveal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postVaultProxyLogsByLogIdRevealQueryKey(options),
  });
};

/**
 * Reveals the contents of a vault proxy request log.
 */
export const postVaultProxyLogsByLogIdRevealMutation = (
  options?: Partial<Options<PostVaultProxyLogsByLogIdRevealData>>,
): UseMutationOptions<
  PostVaultProxyLogsByLogIdRevealResponse,
  ApiError,
  Options<PostVaultProxyLogsByLogIdRevealData>
> => {
  const mutationOptions: UseMutationOptions<
    PostVaultProxyLogsByLogIdRevealResponse,
    ApiError,
    Options<PostVaultProxyLogsByLogIdRevealData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postVaultProxyLogsByLogIdReveal({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
